import React from 'react'

const MobileServicesIcon = () => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 335 229">
      <mask
        id="a"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="335"
        height="229"
      >
        <path d="M335 .44H0v228.08h335V.44Z" fill="#fff" />
      </mask>
      <g mask="url(#a)">
        <path
          d="M119.953 25.8c-25.991 0-47.06 12.165-47.06 27.176v10.87H54.06C28.07 63.846 7 76.01 7 91.019v10.696c0 15.011 21.07 27.176 47.06 27.176h28.242c46.711 0 84.717-21.941 84.717-48.916V52.946c0-15.01-21.069-27.176-47.067-27.176l.001.03ZM327.04 91.04v-.021c0-15.007-21.076-27.173-47.067-27.173h-18.825v-10.87c0-15.01-21.07-27.176-47.067-27.176-25.998 0-47.06 12.165-47.06 27.176v27.03c0 26.974 38 48.915 84.711 48.915h28.241c25.991 0 47.067-12.165 47.067-27.176V91.04Z"
          fill="#D1D3D4"
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
        />
        <path
          d="m327.034 145.39.001-.022c0-15.007-21.07-27.172-47.06-27.172h-28.242c-46.711 0-84.717 21.941-84.717 48.916v27.029c0 15.011 21.076 27.177 47.067 27.177s47.067-12.166 47.067-27.177v-10.87h18.825c25.991 0 47.06-12.165 47.06-27.177V145.42l-.001-.03Z"
          fill="#D1D3D4"
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
        />
        <path
          d="M82.303 118.195H54.06C28.07 118.195 7 130.361 7 145.368v10.696c0 15.041 21.07 27.207 47.06 27.207h18.826v10.87c0 15.011 21.076 27.176 47.067 27.176s47.067-12.165 47.067-27.176v-27.029c0-26.975-38.007-48.916-84.718-48.916v-.001Z"
          fill="#D1D3D4"
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
        />
        <path
          d="M119.953 18.69c-25.991 0-47.06 12.166-47.06 27.177v10.87H54.06C28.07 56.736 7 68.901 7 83.908v10.697c0 15.011 21.07 27.177 47.06 27.177h28.242c46.711 0 84.717-21.942 84.717-48.917V45.837c0-15.012-21.069-27.177-47.067-27.177l.001.03Z"
          fill="#00908E"
        />
        <path
          d="M327.04 83.93v-.02c0-15.008-21.076-27.173-47.067-27.173h-18.825v-10.87c0-15.011-21.07-27.177-47.067-27.177-25.998 0-47.06 12.166-47.06 27.177v27.029c0 26.975 38 48.916 84.711 48.916h28.241c25.991 0 47.067-12.166 47.067-27.177V83.931Z"
          fill="#D6BD18"
        />
        <path
          d="m327.034 138.28.001-.021c0-15.007-21.07-27.173-47.06-27.173h-28.242c-46.711 0-84.717 21.941-84.717 48.916v27.029c0 15.011 21.076 27.177 47.067 27.177s47.067-12.166 47.067-27.177v-10.87h18.825c25.991 0 47.06-12.165 47.06-27.176V138.31l-.001-.03Z"
          fill="#4E9AC2"
        />
        <path
          d="M82.303 111.086H54.06C28.07 111.086 7 123.252 7 138.259v10.696c0 15.041 21.07 27.206 47.06 27.206h18.826v10.87c0 15.011 21.076 27.177 47.067 27.177s47.067-12.166 47.067-27.177v-27.029c0-26.975-38.007-48.916-84.718-48.916Z"
          fill="#C85651"
        />
        <path
          d="M119.954 203.439c-25.991 0-47.067-12.166-47.067-27.177v-10.87H54.06C28.07 165.392 7 153.227 7 138.216s21.07-27.173 47.06-27.173h28.242c46.711 0 84.717 21.942 84.717 48.917v16.303c0 15.011-21.076 27.176-47.067 27.176"
          fill="#F26862"
        />
        <path
          d="M82.302 111.043H54.06C28.07 111.043 7 98.877 7 83.866c0-15.01 21.07-27.172 47.06-27.172h18.832v-10.87c0-15.011 21.07-27.177 47.06-27.177 25.991 0 47.067 12.166 47.067 27.177v16.303c0 26.975-38.006 48.916-84.717 48.916"
          fill="#00ABA9"
        />
        <path
          d="M279.973 111.043h-28.241c-46.711 0-84.711-21.942-84.711-48.917V45.824c0-15.012 21.069-27.177 47.06-27.177 25.99 0 47.067 12.165 47.067 27.177v10.87h18.825c25.991 0 47.067 12.165 47.067 27.172 0 15.007-21.076 27.177-47.067 27.177Z"
          fill="#FFE512"
        />
        <path
          d="M214.083 203.439c-25.991 0-47.067-12.166-47.067-27.177v-16.303c0-26.975 38.006-48.916 84.717-48.916h28.242c25.991 0 47.06 12.166 47.06 27.173 0 15.007-21.07 27.176-47.06 27.176h-18.826v10.87c0 15.011-21.076 27.177-47.067 27.177"
          fill="#5CB7E7"
        />
        <path
          d="m53.072 119.673-18.608 10.744c-.605.35-1.097 1.2-1.095 1.896l.045 15.985c.002.697.497.978 1.103.628l18.608-10.743c.605-.35 1.097-1.2 1.095-1.897l-.045-15.985c-.002-.696-.497-.977-1.102-.628Z"
          fill="#F47F76"
        />
        <path
          d="m47.146 116.229-18.608 10.744c-.606.35-1.098 1.2-1.096 1.896l.046 15.985c0 .346.123.589.32.704l5.928 3.445c-.198-.115-.32-.358-.321-.705l-.045-15.984c-.002-.696.49-1.547 1.095-1.897l18.608-10.743c.305-.176.582-.192.782-.076l-5.927-3.445c-.2-.116-.478-.1-.782.076Z"
          fill="#C85651"
        />
        <path
          d="M43.78 129.318c-2.404 1.388-4.354 4.765-4.346 7.528.008 2.763 1.97 3.881 4.374 2.493 2.405-1.388 4.354-4.765 4.346-7.528-.008-2.763-1.97-3.881-4.374-2.493Zm.026 9.389c-2.1 1.213-3.816.236-3.823-2.178-.007-2.416 1.697-5.367 3.798-6.58 2.102-1.213 3.817-.236 3.824 2.179.007 2.415-1.697 5.366-3.799 6.579Z"
          fill="#fff"
        />
        <path
          d="m46.554 131.584-1.762 1.017-.006-2.025-2.01 1.161.006 2.024-1.753 1.012.007 2.31 1.752-1.012.006 2.014 2.01-1.161-.005-2.013 1.761-1.018-.006-2.309Z"
          fill="#fff"
        />
        <path
          d="m42.675 117.451-4.536 2.619c-1.012.584-1.833 2.006-1.83 3.169l.006 1.92.665.35-.006-1.92c-.003-1.164.818-2.585 1.83-3.169l4.523-1.84a.79.79 0 0 1 .012.131l.007 2.389.664.35-.006-2.389c-.001-.208-.075-.355-.193-.423l-.957-.556.486-.28c.476-.276.912-.317 1.24-.161l-.6-.316c-.333-.194-.796-.167-1.305.127v-.001Zm1.906.189.065.034-.065-.034Z"
          fill="#EDEDEE"
        />
        <path
          d="m43.34 117.8-4.537 2.619c-1.012.585-1.833 2.006-1.83 3.169l.006 1.921 1.176-.679-.006-2.39c-.002-.418.293-.929.656-1.139l4.537-2.619c.363-.21.66-.041.66.378l.008 2.389 1.176-.679-.006-1.92c-.003-1.163-.83-1.633-1.84-1.05Z"
          fill="#fff"
        />
        <path
          d="m44.864 120.378-.557.355v.538l.269.182.614-.384s.106-.403-.326-.691Z"
          fill="#EA624B"
        />
        <path
          d="m44.308 120.733.556-.355v-.183l-.556.346v.192Z"
          fill="#B5B6B6"
        />
        <path
          d="m37.787 124.468-.556.355v.538l.268.183.615-.385s.106-.403-.327-.691Z"
          fill="#EA624B"
        />
        <path
          d="m37.23 124.823.557-.355v-.182l-.556.345v.192Z"
          fill="#B5B6B6"
        />
        <path
          d="m35.549 126.992-1.905-1.099a.476.476 0 0 0-.433 0l-.82.476c-.06.035-.088.08-.088.125v-.001l-.001.259c0 .045.03.091.09.126l1.905 1.099c.12.07.314.07.433 0l.82-.476c.058-.035.088-.08.088-.125v-.258l-.002.019c.01-.052-.019-.106-.087-.146v.001Zm-3.244-.479.003.015-.003-.015Zm.013.034.007.014-.007-.014Zm3.305.625c.004-.007.008-.013.01-.02-.002.007-.006.013-.01.02Zm13.773-8.197-1.904-1.099a.475.475 0 0 0-.433 0l-.82.476c-.06.034-.089.079-.089.125v.258c0 .045.03.091.09.126l1.904 1.099c.12.07.314.07.433 0l.82-.476c.059-.035.089-.08.089-.125v-.258l-.003.019c.01-.052-.018-.106-.087-.146v.001Zm-3.243-.479c0 .005 0 .01.002.015l-.002-.015Zm.013.035.007.013-.007-.013Zm3.305.624c.004-.007.008-.013.01-.02-.002.007-.006.013-.01.02Z"
          fill="#fff"
        />
        <path
          d="M304.33 113.376a10.962 10.962 0 0 0-.266-.159c-2.966-1.713-5.479-.902-6.305 1.728-.015.047-.056.05-.097.027a.222.222 0 0 1-.098-.14c-.809-3.573-3.308-7.278-6.274-8.99-3.629-2.095-6.58-.414-6.592 3.775-.064.414-1.101 8.601 12.83 28.102 10.849-2.619 12.695-8.829 12.948-11.716.088-.436.135-.914.138-1.429.017-4.037-2.771-9.01-6.284-11.198Z"
          fill="#F26862"
        />
        <path
          d="M299.716 113.777a.217.217 0 0 1-.098-.14c-.808-3.573-3.308-7.278-6.274-8.99-1.824-1.053-3.477-1.152-4.672-.458l-2.055 1.195c1.195-.694 2.848-.596 4.672.458 2.965 1.712 5.465 5.417 6.274 8.99a.225.225 0 0 0 .097.14c.027.015.054.019.073.008l2.056-1.195c-.02.012-.047.008-.073-.008Z"
          fill="#C85651"
        />
        <path
          d="M306.385 112.182a9.87 9.87 0 0 0-.266-.16c-1.826-1.054-3.48-1.152-4.675-.458l-2.055 1.195c1.194-.694 2.848-.596 4.675.458.088.05.177.104.265.159 3.513 2.189 6.301 7.161 6.284 11.199-.003.514-.05.992-.138 1.429-.19 2.17-1.281 6.221-6.425 9.211l2.055-1.195c5.144-2.989 6.235-7.04 6.425-9.211.087-.436.135-.914.138-1.428.017-4.038-2.771-9.011-6.283-11.199Z"
          fill="#C85651"
        />
        <path
          d="m310.828 131.543-5.875-3.392-.84-3.386a.819.819 0 0 0-.353-.49c-.16-.088-.299-.046-.344.106l-1.398 4.702-2.074-11.995a.836.836 0 0 0-.357-.533c-.151-.088-.288-.059-.342.076l-2.566 6.39-13.295-7.676c-.202-.116-.366-.023-.366.208a.8.8 0 0 0 .363.63l13.55 7.823c.152.088.289.058.343-.075l2.222-5.536 2.117 12.237a.819.819 0 0 0 .355.533c.162.093.306.052.351-.101l1.47-4.943.554 2.233c.05.199.189.395.345.485l6.138 3.543c.202.117.366.024.366-.208a.802.802 0 0 0-.364-.631Z"
          fill="#fff"
        />
        <path
          opacity=".2"
          d="M286.446 75.036a3.051 3.051 0 0 0-.394-.279l-66.086-38.294a10.087 10.087 0 0 0-10.189-.011L182.26 52.537c-1.127.634-2.221 1.404-2.221 3.951 0 1.433.862 2.777 1.648 3.312.12.097.248.187.388.268l66.33 38.02a10.086 10.086 0 0 0 10.066-.011l27.562-15.914c.084-.048.159-.103.236-.158.953-.606 1.777-1.478 1.777-3.688 0-1.404-.828-2.724-1.6-3.28Z"
          fill="#010101"
        />
        <path
          d="M182.017 51.645c-1.133.636-2.238 1.401-2.238 3.96 0 1.85 1.437 3.56 2.291 3.56.854 0 1.124-1.859 1.124-3.708 0-1.848-.433-4.23-1.177-3.812Z"
          fill="#BDBEC0"
        />
        <path
          d="M285.496 73.877c-.854 0-1.124 1.858-1.124 3.707 0 1.848.433 4.23 1.177 3.812 1.133-.636 2.238-1.401 2.238-3.961 0-1.85-1.437-3.558-2.291-3.558Z"
          fill="#818181"
        />
        <path
          d="m285.792 76.14-65.774-38.453c-3.199-1.877-7.818-1.395-10.188-.012l-28.032 16.362c-1.976 1.153-1.965 4.01.018 5.15l66.33 38.02a10.086 10.086 0 0 0 10.066-.012l27.562-15.913c1.975-1.141 1.985-3.989.018-5.142Z"
          fill="#BDBEC0"
        />
        <path
          d="M285.791 73.875 219.705 35.58a10.085 10.085 0 0 0-10.188-.012l-27.72 16.204c-1.976 1.153-1.965 4.01.018 5.149l66.33 38.02a10.085 10.085 0 0 0 10.066-.012l27.562-15.913c1.975-1.14 1.985-3.988.018-5.142Z"
          fill="#3A3A39"
        />
        <path
          d="m186.146 57.53 58.297 33.878 34.93-20.167-58.297-33.878-34.93 20.166Z"
          fill="#04556D"
        />
        <path
          d="m244.443 91.408 34.929-20.167-58.297-33.878 23.368 54.045Z"
          fill="#fff"
          opacity=".08"
        />
        <path
          d="m182.928 55.659 3.218 1.87 34.93-20.166-3.219-1.87-34.929 20.166Z"
          fill="#04556D"
        />
        <path
          d="m266.229 72.208-29.52-16.839c-1.513-.865-4.028-.81-5.611.122l-17.68 10.4c-1.569.931-1.62 2.38-.11 3.242l29.52 16.839c1.515.864 4.026.809 5.613-.123l17.675-10.397c1.572-.933 1.624-2.383.112-3.245h.001Z"
          fill="#010101"
          opacity=".15"
        />
        <path
          d="m266.217 71.227-29.519-16.839c-1.514-.865-4.028-.81-5.612.123l-17.68 10.399c-1.568.931-1.619 2.38-.109 3.243l29.519 16.838c1.516.864 4.026.81 5.614-.123l17.674-10.396c1.573-.934 1.624-2.383.113-3.245Z"
          fill="#C7E0DF"
        />
        <path
          opacity=".4"
          d="M260.926 70.879c-1.207-.688-3.21-.644-4.47.098l-4.072 2.394c-1.25.742-1.292 1.9-.09 2.584 1.205.689 3.21.644 4.472-.097l4.074-2.396c1.247-.742 1.287-1.898.086-2.583Zm-10.159 5.976c-1.204-.689-3.21-.644-4.471.097l-4.069 2.394c-1.25.742-1.292 1.899-.091 2.586 1.204.686 3.21.643 4.473-.099l4.068-2.394c1.25-.742 1.291-1.9.09-2.584ZM227.218 63.42c-1.204-.685-3.21-.642-4.469.1l-4.074 2.396c-1.248.741-1.29 1.897-.088 2.582 1.204.688 3.21.643 4.471-.098l4.074-2.396c1.248-.741 1.288-1.898.087-2.583h-.001Zm10.162-5.974c-1.207-.687-3.21-.643-4.473.098l-4.073 2.396c-1.249.742-1.287 1.898-.089 2.583 1.206.687 3.212.644 4.471-.097l4.073-2.394c1.251-.743 1.29-1.9.091-2.586Zm7.847 4.477c-1.206-.687-3.209-.644-4.472.098l-4.073 2.396c-1.248.741-1.288 1.898-.088 2.584 1.207.687 3.21.643 4.473-.098l4.069-2.394c1.251-.743 1.293-1.9.091-2.586ZM235.068 67.9c-1.206-.688-3.21-.644-4.471.096l-4.074 2.397c-1.248.741-1.288 1.898-.086 2.583 1.204.686 3.21.644 4.469-.098l4.072-2.394c1.25-.742 1.291-1.9.09-2.585Zm18.008-1.5c-1.204-.686-3.21-.643-4.469.099l-4.074 2.397c-1.248.74-1.288 1.897-.088 2.581 1.206.69 3.21.644 4.471-.097l4.072-2.396c1.25-.742 1.292-1.898.088-2.583Zm-10.159 5.977c-1.203-.688-3.21-.644-4.47.098l-4.072 2.394c-1.25.742-1.289 1.899-.09 2.585 1.207.687 3.21.643 4.472-.098l4.07-2.395c1.25-.742 1.293-1.9.09-2.585Z"
          fill="#2D3B3B"
        />
        <path
          d="m224.401 62.071-4.697 2.496a2.013 2.013 0 1 0 1.89 3.557l4.697-2.496a2.015 2.015 0 0 0-1.89-3.557Z"
          fill="#E3E3E3"
        />
        <path
          d="m224.402 62.071-2.809 1.493.003-.001c.216-.081.459-.13.732-.134 2.039-.025 2.532 2.409 1.44 3.54l2.524-1.341a2.013 2.013 0 1 0-1.89-3.557Z"
          fill="#057686"
        />
        <path
          d="m232.19 66.764-4.698 2.496a2.013 2.013 0 0 0 1.89 3.557l4.697-2.496a2.015 2.015 0 0 0-1.889-3.557Z"
          fill="#E3E3E3"
        />
        <path
          d="m232.19 66.764-2.809 1.493.003-.001a2.13 2.13 0 0 1 .732-.133c2.039-.026 2.532 2.408 1.44 3.538l2.524-1.34a2.013 2.013 0 0 0-1.89-3.557Z"
          fill="#057686"
        />
        <path
          d="m240.111 71.25-4.697 2.496a2.015 2.015 0 0 0 1.89 3.557l4.697-2.496a2.015 2.015 0 0 0-1.89-3.557Z"
          fill="#E3E3E3"
        />
        <path
          d="m240.111 71.25-2.809 1.493h.003c.216-.082.459-.13.732-.134 2.039-.025 2.532 2.408 1.44 3.539l2.523-1.34a2.014 2.014 0 1 0-1.889-3.557Z"
          fill="#057686"
        />
        <path
          d="m247.897 75.739-4.698 2.495a2.013 2.013 0 0 0 1.89 3.557l4.697-2.496a2.014 2.014 0 1 0-1.889-3.556Z"
          fill="#E3E3E3"
        />
        <path
          d="m247.897 75.739-2.809 1.492h.003c.216-.082.459-.13.732-.134 2.039-.025 2.532 2.408 1.441 3.539l2.523-1.34a2.013 2.013 0 0 0-1.89-3.557Z"
          fill="#057686"
        />
        <path
          d="m234.453 56.064-4.697 2.496a2.015 2.015 0 0 0 1.889 3.557l4.698-2.496a2.013 2.013 0 0 0-1.89-3.557Z"
          fill="#E3E3E3"
        />
        <path
          d="m234.454 56.064-2.809 1.493h.003c.216-.082.458-.131.731-.134 2.04-.025 2.533 2.408 1.441 3.538l2.523-1.34a2.015 2.015 0 0 0-1.889-3.557Z"
          fill="#057686"
        />
        <path
          d="m242.239 60.758-4.697 2.496a2.015 2.015 0 0 0 1.89 3.556l4.697-2.496a2.013 2.013 0 0 0-1.89-3.556Z"
          fill="#E3E3E3"
        />
        <path
          d="m242.24 60.758-2.809 1.492h.002c.217-.082.46-.13.733-.134 2.039-.025 2.532 2.408 1.44 3.539l2.523-1.34a2.014 2.014 0 1 0-1.889-3.557Z"
          fill="#057686"
        />
        <path
          d="m250.162 65.244-4.697 2.496a2.015 2.015 0 0 0 1.889 3.556l4.698-2.496a2.013 2.013 0 0 0-1.89-3.556Z"
          fill="#E3E3E3"
        />
        <path
          d="m250.163 65.244-2.809 1.493h.002a2.14 2.14 0 0 1 .732-.134c2.04-.025 2.533 2.408 1.441 3.538l2.523-1.34a2.015 2.015 0 0 0-1.889-3.557Z"
          fill="#057686"
        />
        <path
          d="m257.948 69.732-4.697 2.496a2.015 2.015 0 0 0 1.889 3.557l4.698-2.496a2.013 2.013 0 1 0-1.89-3.557Z"
          fill="#E3E3E3"
        />
        <path
          d="m257.949 69.732-2.809 1.493h.002c.217-.082.46-.13.732-.134 2.04-.025 2.533 2.408 1.441 3.538l2.523-1.34a2.014 2.014 0 1 0-1.889-3.557Z"
          fill="#057686"
        />
        <path
          opacity=".3"
          d="M225.204 61.11c-.4.004-.799.106-1.153.295l-4.528 2.405-.432.226c-1.595 1.02-1.439 2.98-1.439 2.98-.006.621.318 1.147.879 1.467 1.214.694 3.281.655 4.551-.092l4.053-2.375c.667-.396.994-.955.971-1.453.07-1.225-.868-2.463-.868-2.463a2.515 2.515 0 0 0-2.035-.99h.001Zm7.854 4.463a2.536 2.536 0 0 0-1.153.296l-4.527 2.405c-.111.06-.432.226-.432.226-1.596 1.02-1.44 2.981-1.44 2.981-.005.62.319 1.146.88 1.467 1.213.693 3.28.654 4.551-.092l4.053-2.376c.667-.396.994-.955.971-1.452.07-1.226-.868-2.464-.868-2.464a2.515 2.515 0 0 0-2.035-.99Zm7.843 4.499a2.54 2.54 0 0 0-1.153.295l-4.528 2.406-.431.226c-1.596 1.019-1.44 2.98-1.44 2.98-.006.62.318 1.147.88 1.467 1.213.694 3.28.654 4.551-.092l4.053-2.376c.666-.395.994-.954.971-1.452.069-1.225-.868-2.463-.868-2.463a2.516 2.516 0 0 0-2.035-.991Zm7.854 4.476c-.4.005-.799.107-1.154.295l-4.527 2.406-.432.226c-1.596 1.019-1.44 2.98-1.44 2.98-.005.621.319 1.147.88 1.467 1.214.694 3.281.655 4.552-.092l4.052-2.375c.667-.396.994-.955.971-1.453.07-1.225-.868-2.463-.868-2.463a2.515 2.515 0 0 0-2.035-.991h.001Zm-13.362-19.402a2.53 2.53 0 0 0-1.153.296l-4.528 2.406c-.11.059-.431.226-.431.226-1.596 1.019-1.44 2.98-1.44 2.98-.005.62.319 1.147.88 1.467 1.213.693 3.28.654 4.551-.092l4.052-2.376c.667-.395.994-.954.971-1.452.07-1.225-.868-2.463-.868-2.463a2.515 2.515 0 0 0-2.035-.991h.001Zm7.854 4.464c-.4.005-.799.108-1.153.296l-4.528 2.406-.432.226c-1.596 1.019-1.439 2.98-1.439 2.98-.006.62.318 1.147.879 1.467 1.214.693 3.281.654 4.551-.092l4.053-2.376c.667-.396.994-.954.971-1.452.07-1.225-.868-2.463-.868-2.463a2.515 2.515 0 0 0-2.035-.991h.001Zm7.842 4.5a2.533 2.533 0 0 0-1.153.295l-4.527 2.406-.432.226c-1.596 1.019-1.44 2.98-1.44 2.98-.005.62.319 1.147.88 1.467 1.214.693 3.281.654 4.551-.092l4.053-2.376c.666-.395.994-.954.971-1.452.069-1.225-.868-2.463-.868-2.463a2.515 2.515 0 0 0-2.035-.991Zm7.854 4.475a2.53 2.53 0 0 0-1.153.296l-4.528 2.405c-.111.06-.432.226-.432.226-1.596 1.02-1.439 2.98-1.439 2.98-.006.621.318 1.147.88 1.467 1.214.694 3.28.655 4.551-.091l4.053-2.376c.666-.396.994-.955.971-1.453.07-1.225-.868-2.463-.868-2.463a2.515 2.515 0 0 0-2.035-.99Z"
          fill="#F0F1F1"
        />
        <path
          opacity=".4"
          d="m226.734 62.724-5.544 2.65c-.276.133-.381.488-.234.795.147.306.489.448.765.317l5.544-2.651c.276-.132.38-.487.233-.794-.147-.307-.489-.448-.764-.317Zm7.651 4.763-5.544 2.651c-.276.132-.38.487-.233.794.146.306.488.448.764.317l5.544-2.65c.276-.133.38-.488.233-.795-.146-.306-.488-.448-.764-.317Zm7.991 4.486-5.544 2.65c-.276.132-.38.488-.233.794.147.307.489.449.764.317l5.544-2.65c.276-.132.381-.487.234-.794-.147-.307-.489-.449-.765-.317Zm7.72 4.694-5.544 2.65c-.276.132-.38.488-.233.794.146.307.488.449.764.317l5.544-2.65c.276-.132.38-.488.233-.794-.146-.307-.488-.449-.764-.317ZM236.79 57.128l-5.544 2.65c-.276.132-.38.488-.233.794.146.307.489.45.764.317l5.544-2.65c.276-.132.38-.488.234-.794-.147-.307-.489-.449-.765-.317Zm7.651 4.763-5.544 2.65c-.276.133-.381.488-.234.794.147.307.489.45.765.317l5.544-2.65c.276-.132.38-.487.233-.794-.146-.307-.489-.449-.764-.317Zm7.992 4.486-5.544 2.65c-.276.132-.38.487-.234.794.147.307.489.449.765.317l5.544-2.65c.276-.132.38-.488.233-.794-.146-.307-.489-.449-.764-.317Zm7.718 4.693-5.544 2.652c-.275.132-.38.487-.233.793.147.307.489.449.765.317l5.544-2.65c.275-.132.379-.487.233-.794-.147-.307-.489-.449-.765-.317Z"
          fill="#F0F1F1"
        />
        <path
          opacity=".2"
          d="M235.138 47.929c-.058-1.192-.793-2.325-2.229-3.035-3.07-1.518-8.14-1.26-11.323.579-1.54.889-2.477 2.15-2.44 3.393 0 .026.007.06.009.087-.002-.017-.007-.033-.008-.05l.086 1.73c.085 1 .828 1.95 2.235 2.645 3.068 1.518 8.138 1.26 11.32-.578 1.724-.995 2.542-2.25 2.441-3.432l-.086-1.73c.011.13.006.26-.005.39Z"
          fill="#010101"
        />
        <path
          d="M232.53 44.364c-3.07-1.518-8.14-1.26-11.323.579-1.54.889-2.477 2.15-2.44 3.393.025.85.652 2.619 2.236 3.402 3.068 1.518 8.138 1.26 11.32-.578 3.183-1.837 3.275-5.278.207-6.795Z"
          fill="#EBF0F1"
        />
        <path
          d="M232.323 50.442c-3.182 1.837-8.252 2.096-11.32.578-1.407-.696-2.15-1.645-2.235-2.646l.086 1.73c.085 1 .827 1.949 2.235 2.645 3.068 1.518 8.138 1.259 11.32-.578 1.724-.995 2.541-2.25 2.441-3.432l-.086-1.729c.1 1.182-.717 2.436-2.441 3.432Z"
          fill="#C7E0DF"
        />
        <path
          d="M229.129 45.196c-.434.261-.928.582-1.452.933a49.11 49.11 0 0 0-3.174 2.347c-.489.398-.941.776-1.318 1.113-.38.334-.687.625-.9.832-.212.207-.329.332-.329.332s.154-.075.414-.217c.26-.142.629-.35 1.059-.616.434-.261.927-.583 1.452-.933a49.61 49.61 0 0 0 1.612-1.14c.54-.4 1.072-.81 1.563-1.205a37.96 37.96 0 0 0 1.318-1.114c.38-.334.687-.625.899-.832.212-.207.329-.332.329-.332s-.154.074-.414.217c-.26.142-.629.35-1.059.615Z"
          fill="#C7E0DF"
        />
        <path
          opacity=".2"
          d="M241.107 44.372c-2.62-2.206-7.606-3.162-11.135-2.136-1.707.497-2.917 1.5-3.178 2.715-.004.016-.006.036-.009.053l.001-.017-.328 1.7c-.156.992.339 2.09 1.54 3.102 2.619 2.205 7.604 3.161 11.132 2.135 1.912-.556 3.004-1.58 3.188-2.752l.328-1.7a2.28 2.28 0 0 1-.097.378c.227-1.171-.216-2.446-1.442-3.478Z"
          fill="#010101"
        />
        <path
          d="M241.032 43.69c-2.62-2.205-7.606-3.161-11.135-2.134-1.707.496-2.918 1.498-3.178 2.714-.178.83.009 2.698 1.361 3.837 2.619 2.205 7.604 3.16 11.132 2.135 3.529-1.027 4.438-4.346 1.82-6.551Z"
          fill="#EBF0F1"
        />
        <path
          d="M239.383 49.544c-3.528 1.026-8.513.07-11.132-2.135-1.201-1.011-1.696-2.11-1.54-3.102l-.329 1.7c-.155.992.34 2.09 1.541 3.102 2.618 2.205 7.604 3.16 11.132 2.135 1.911-.557 3.004-1.58 3.188-2.752l.328-1.7c-.184 1.172-1.276 2.196-3.188 2.752Z"
          fill="#C7E0DF"
        />
        <path
          d="M238.595 47.138a38.543 38.543 0 0 0-1.461-.917 49.683 49.683 0 0 0-1.718-.973 49.357 49.357 0 0 0-1.757-.9 38.142 38.142 0 0 0-1.568-.72 23.947 23.947 0 0 0-1.135-.46c-.278-.105-.44-.157-.44-.157s.133.107.372.282c.24.175.585.42 1.008.697.421.28.922.59 1.462.916.542.323 1.126.654 1.717.974a49.4 49.4 0 0 0 1.756.902 37.93 37.93 0 0 0 1.569.72c.463.202.858.355 1.135.46.278.103.441.156.441.156s-.133-.108-.372-.283c-.24-.175-.585-.42-1.008-.697h-.001Z"
          fill="#C7E0DF"
        />
        <path
          d="M218.734 52.411c-3.454-1.994-9.037-1.995-12.468-.001-3.434 1.995-3.414 5.229.04 7.223 3.454 1.994 9.037 1.995 12.47 0 3.432-1.995 3.412-5.228-.042-7.222Z"
          fill="#010101"
          opacity=".2"
        />
        <path
          d="M219.195 32.566c-3.342 1.942-8.776 1.94-12.138 0-1.693-.978-2.538-2.26-2.535-3.542l-.035 26.886c-.003 1.28.843 2.564 2.536 3.541 3.361 1.941 8.796 1.942 12.137 0 1.66-.965 2.491-2.228 2.495-3.492l.035-26.886c-.004 1.265-.835 2.528-2.495 3.493Z"
          fill="#FFF275"
        />
        <path
          d="M213.135 34.664c-2.404 0-4.676-.548-6.398-1.542a7.255 7.255 0 0 1-1.577-1.202l-.031 23.991c-.003 1.099.783 2.159 2.214 2.985 1.531.883 3.575 1.37 5.757 1.37 2.182 0 4.219-.486 5.738-1.369 1.4-.813 2.173-1.857 2.176-2.94l.031-24a7.174 7.174 0 0 1-1.528 1.164c-1.712.995-3.979 1.543-6.382 1.543Z"
          fill="#FEE9A1"
        />
        <path
          d="M219.157 25.534c-3.364-1.942-8.8-1.942-12.142 0-3.342 1.942-3.322 5.09.042 7.032 3.362 1.941 8.796 1.942 12.137 0 3.342-1.942 3.324-5.09-.037-7.031Z"
          fill="#F4A568"
        />
        <path
          d="M219.547 29.914c-3.542 2.058-9.301 2.057-12.864 0-1.794-1.035-2.69-2.395-2.686-3.752l-.007 3.417c-.004 1.358.892 2.717 2.686 3.752 3.563 2.057 9.322 2.059 12.864 0 1.758-1.021 2.638-2.358 2.642-3.698l.007-3.417c-.004 1.34-.884 2.676-2.642 3.698Z"
          fill="#C7E0DF"
        />
        <path
          d="M219.503 22.464c-3.564-2.057-9.322-2.059-12.862-.001-3.542 2.058-3.522 5.394.042 7.451 3.563 2.057 9.322 2.058 12.864 0 3.539-2.057 3.519-5.393-.044-7.45Z"
          fill="#fff"
        />
        <path
          d="M218.904 52.314c-3.23-1.865-8.451-1.866-11.66 0-3.211 1.865-3.192 4.89.038 6.754 3.23 1.865 8.451 1.866 11.662 0 3.209-1.865 3.189-4.889-.04-6.754Z"
          fill="#FFF275"
        />
        <path
          d="M218.094 54.005h-5.893c-.891 0-1.62.795-1.62 1.766v.063c0 .971.729 1.766 1.62 1.766h5.893c.891 0 1.62-.795 1.62-1.766v-.063c0-.97-.729-1.766-1.62-1.766Z"
          fill="#FFF5D0"
        />
        <path
          d="m214.381 50.612-5.253-2.672c-.794-.404-1.804-.026-2.244.84l-.029.056c-.44.865-.15 1.904.644 2.308l5.252 2.671c.795.404 1.805.027 2.245-.84l.028-.055c.441-.866.151-1.904-.643-2.308Z"
          fill="#FEEED7"
        />
        <path
          d="M213.454 50.436c-.718-.654-1.796-.65-2.396.009l-3.969 4.355c-.6.659-.503 1.733.214 2.387l.047.042c.718.654 1.796.65 2.396-.008l3.969-4.356c.6-.658.504-1.732-.214-2.386l-.046-.043h-.001Z"
          fill="#FFF6E8"
        />
        <path
          d="M217.603 47.488c-.267-.85-1.244-1.307-2.17-1.015l-.06.018c-.926.292-1.466 1.226-1.198 2.076l1.77 5.62c.267.85 1.244 1.307 2.17 1.016l.06-.02c.926-.291 1.465-1.225 1.198-2.075l-1.77-5.62Z"
          fill="#FFF4CC"
        />
        <path
          d="M209.52 42.444c-.358-.816-1.379-1.164-2.268-.773l-.058.025c-.889.39-1.323 1.378-.965 2.194l2.37 5.395c.358.815 1.379 1.164 2.268.773l.057-.025c.889-.391 1.324-1.378.965-2.194l-2.369-5.395Z"
          fill="#FEF4E5"
        />
        <path
          d="m220.304 45.087-.05-.038c-.777-.581-1.851-.474-2.385.24l-3.531 4.716c-.534.714-.335 1.773.442 2.355l.051.038c.777.582 1.85.475 2.384-.239l3.532-4.717c.534-.713.335-1.773-.443-2.355Z"
          fill="#FFF6D6"
        />
        <path
          d="M215.015 37.715c-2.044.34-7.33.746-10.529-3.306v20.594s3.629 5.37 10.827 3.51a.727.727 0 0 0 .545-.702V38.426a.722.722 0 0 0-.843-.71Z"
          fill="#F1F9FA"
        />
        <path
          d="M204.486 38.826v2.304s3.812 4.908 11.371 2.626l.001-1.796s-7.342 1.97-11.372-3.134Z"
          fill="#057686"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="m276.508 95.429 6.686 2.344 10.37-4.153-7.097-3.092-9.959 4.9Z"
          fill="url(#b)"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="m282.859 92.179 6.687 2.344 10.37-4.153-7.097-3.092-9.96 4.9Z"
          fill="url(#c)"
        />
        <path
          d="M278.971 94.139s-1.221-.004-2.929 0c-1.165.002-1.987 1.338-.988 2.2l6.289 1.877s1.891.51 2.507-.99l-.15-2.237-4.729-.85Z"
          fill="#40403F"
        />
        <path
          d="m290.011 51.32-1.2 4.064s3.842.855 4.041-.985c.833-7.66-.157-14.447-.157-14.447l-2.684 11.368Z"
          fill="#454E58"
        />
        <path
          opacity=".07"
          d="m290.011 51.32-1.2 4.064s3.842.855 4.041-.985c.833-7.66-.157-14.447-.157-14.447l-2.684 11.368Z"
          fill="#010101"
        />
        <path
          d="M285.925 90.796s-1.655-.002-3.283.001c-1.111.002-1.973 1.683-.943 2.098l5.996 1.788s2.106.59 2.693-.842l-.139-2.178-4.324-.867Z"
          fill="#40403F"
        />
        <path
          d="M290.371 56.176c-1.264.725-10.843 2.264-11.667 1.261l.669 36.774c.025.544.247 1.239 1.279 1.515 1.722.46 3.079-.277 3.079-.277l.119-13.265 1.545-11.776.221 9.06.469 11.738c.038.718.785 1.112 1.496 1.221 1.93.298 2.798-.633 2.798-.633l-.1-13.092s.173-4.403.467-8.161c.244-3.126.427-6.864.292-8.728-.111-1.53-.668-5.637-.668-5.637h.001Z"
          fill="#FDD69B"
        />
        <path
          opacity=".07"
          d="M287.545 71.284c.259-.89 1.062-4.613 1.447-5.665-1.43.651-1.762.797-3.179 1.114-.032.495-.329 2.972-.428 3.454l.232 9.282.469 11.737c.038.718.785 1.112 1.496 1.221.992.153 1.701-.018 2.158-.221-.71-6.947-4.153-14.216-2.195-20.922Zm-6.282.307c-.224-3.558-.918-7.06-.748-10.64a1.41 1.41 0 0 1 .247-.746 94.67 94.67 0 0 1 .02-2.442c-1.076.02-1.866-.069-2.078-.326l.669 36.774c.025.544.247 1.239 1.279 1.515.359.096.7.138 1.018.147-.286-4.537-.181-9.137-.258-13.614-.061-3.545.073-7.13-.149-10.668Z"
          fill="#010101"
        />
        <path
          d="M292.736 40.27c-.406-2.209-2.837-2.77-2.837-2.77s-3.117-.967-5.547-.152c-3.342 1.122-5.013 2.949-5.013 2.949l-1.2 7.628.659 11.432s.365 1.346 3.015 1.354c3.081.008 8.973-2.583 8.973-2.583s-.187-1.63-.093-3.42 2.419-12.392 2.043-14.437Z"
          fill="#454E58"
        />
        <path
          opacity=".07"
          d="M282.266 42.864a1.27 1.27 0 0 1-.261-.67c-.695-.84-1.569-1.476-2.431-2.128-.154.143-.235.23-.235.23l-1.2 7.629.659 11.432s.365 1.346 3.015 1.353a9.227 9.227 0 0 0 1.628-.169c-.627-2.693-.201-5.586-.169-8.324.033-2.81.759-6.97-1.006-9.353Z"
          fill="#010101"
        />
        <path
          d="m283.166 33.77.252 4.003c0 1.202 4.096.755 4.096-.447l-.32-3.556h-4.028Z"
          fill="#926750"
        />
        <path
          d="M287.652 36.45c-.37 1.217-3.04 1.472-4.388.968l-.485.506c.829 1.178 3.651 1.365 4.882.041.286-.308.329-.77.156-1.153l-.164-.363h-.001Z"
          fill="#fff"
        />
        <path
          d="M282.128 33.664c-.113 1.85 1.118 2.734 2.871 2.841 0 0 3.309-.81 3.42-2.626l.572-3.342-6.578-1.53-.285 4.657Z"
          fill="#926750"
        />
        <path
          d="M284.082 26.811c-1.482.543-3.847 1.867-1.75 3.527 0 0 .885.277.798 1.693-.086 1.416 1.319 2.925 2.375 3.867.768.685 2.218-.287 2.218-.287s2.291-2.301 1.475-6.516c-.498-2.568-4.073-2.666-5.116-2.284Z"
          fill="#40403F"
        />
        <path
          d="m282.924 32.09-.094 1.54c.626.334 1.208-.511 1.156-1.314-.07-1.09-1.062-.226-1.062-.226Z"
          fill="#926750"
        />
        <path
          d="M280.346 39.624c-1.637-.164-2.431 5.372-2.431 5.372l-.37 7.913-1.226 10.863c1.706 1.74 2.809.364 2.809.364l2.596-10.106.923-9.498s.492-4.63-2.301-4.908Z"
          fill="#454E58"
        />
        <path
          d="M278.399 66.942c.398-1.192.306-2.607.306-2.607l-2.115-.629-.456 2.52.465 2.32 1.54 1.178s-.137.08.26 0c.398-.08.378-.436.378-.436l-.378-.756v-1.59Z"
          fill="#926750"
        />
        <path
          d="M279.153 63.033c-.927.228-1.997-.002-2.676-.653l-.158 1.392c1.706 1.74 2.809.364 2.809.364l.28-1.096h-.002c-.086 0-.169-.004-.253-.007Z"
          fill="#868686"
        />
        <path
          opacity=".07"
          d="m277.915 44.996-.37 7.913-1.226 10.863c.533.543 1.006.783 1.406.855.199-4.06.971-8.06 1.369-12.107.404-4.117-.216-8.245.332-12.347-1.015 1.37-1.511 4.823-1.511 4.823Z"
          fill="#010101"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="M250.906 149.404a1.87 1.87 0 0 0-.269 3.187l9.582 6.99a5.684 5.684 0 0 0 5.919.478l23.854-12.089-16.103-10.003-22.982 11.437h-.001Z"
          fill="url(#d)"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m185.08 155.534 24.398 14.394 59.287-34.645-22.934-14.883-60.751 35.134Z"
          fill="url(#e)"
        />
        <path
          d="M200.772 101.658s-7.193 3.441-8.78 5.487c-4.132 5.328.287 16.074 3.161 15.813 1.802-.164 6.663-3.102 9.563-4.86 3.449-2.09.863-12.364-.338-15.029-.923-2.046-3.606-1.411-3.606-1.411Z"
          fill="#424143"
        />
        <path
          d="M209.505 97.695c-.761-1.34-4.502-2.318-4.502-2.318.064.12 2.565 17.079 2.565 17.079l5.946 4.163s2.745.043 3.02-.777l-4.62-5.719s-.909-9.79-2.409-12.428Z"
          fill="#fff"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="m208.875 152.057 2.9 5.41 14.668-6.158-5.011-4.108-12.557 4.856Z"
          fill="url(#f)"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          d="m200.392 155.116 2.899 5.409 14.668-6.158-5.01-4.107-12.557 4.856Z"
          fill="url(#g)"
        />
        <path
          d="m211.88 155.242-2.906-2.908h-3.158l-.331 2.211c0 .482.261.925.68 1.159l1.298.391a7.933 7.933 0 0 1 2.322 1.154c.817.583 2.274.857 3.044.598.694-.234 1.039-.367.777-1.084-.164-.446-.673-.963-1.726-1.521Zm-9.307 2.346-2.284-3.07h-3.057l-.24 2.119c0 .474.256.91.668 1.141l3.059 2.534c.632.524 1.449.802 2.262.695.641-.084 1.283-.386 1.497-1.204l-.02-.114c-.139-.76-1.342-1.552-1.885-2.101Z"
          fill="#424143"
        />
        <path
          d="m209.066 115.409-4.562 1.553-.575 6.966 1.067 12.875.488 15.993s2.088 1.34 4.104-.151l.425-17.138s-.159-9.312-.425-12.361c-.441-5.067-.522-7.738-.522-7.738v.001Z"
          fill="#676868"
        />
        <path
          opacity=".07"
          d="M209.29 130.648c-.1 2.997-.025 6.107-.307 9.148-.116 4.63-.258 8.828-.645 13.442.407-.101.83-.281 1.251-.593l.425-17.138s-.157-9.154-.419-12.28c-.048 2.473-.223 4.949-.305 7.421Z"
          fill="#010101"
        />
        <path
          d="m196.823 125.329.532 12.695-.363 16.89s2.217 1.621 3.743-.064l2.177-16.81 1.592-13.921 1.866-6.53-9.235-.429s-.581 1.556-.312 8.169Z"
          fill="#676868"
        />
        <path
          d="M209.138 99.952c-.023-1.95-1.026-3.248-2.378-3.568-3.656-.865-4.17-1.624-6.307-.833-2.693.996-5.265 2.885-5.265 2.885l1.47 5.284.909 7.866-.634 6.668c4.666 3.76 12.293.145 12.293.145s-.056-5.853-.219-8.045c-.068-.914.138-3.356.138-3.356.87-3.459.022-4.708-.006-7.046h-.001Z"
          fill="#454E58"
        />
        <path
          opacity=".07"
          d="m196.824 125.329.532 12.695-.363 16.89s.283.205.713.393c.039-.708.094-1.415.155-2.122-.012-5.245.187-10.058.27-15.311.039-2.518.115-5.001.241-7.49-.602-3.478-.352-7.002.143-10.494l-.016-.508a2.017 2.017 0 0 1 .261-1.117c.054-.341.11-.682.166-1.021l-1.791-.084s-.581 1.556-.312 8.169h.001Zm6.622 1.418c-.55 2.577-1.176 8.177-1.606 10.781.064.774-.015 1.566-.156 2.349-.007.163-.025.33-.071.507-1.342 5.129-1.703 9.988-2.422 15.224.524-.032 1.068-.232 1.545-.759l2.176-16.809 1.277-11.156 1.165-1.4s-1.836.922-1.908 1.263Z"
          fill="#010101"
        />
        <path
          d="M209.854 99.49c-.27-1.932-.947-2.807-2.282-3.195-.201-.059-1.533-.612-1.533-.577 0 .619.244 7.665-.286 10.273-.008.04 2.941 21.059 1.647 29.552 3.08-.528 3.294-1.464 3.294-1.464s-.661-20.864-.824-23.056c-.068-.914.458-8.143-.016-11.532Zm-4.97 6.958c-.915-1.331-3.797-11.132-4.431-10.897-2.693.996-5.265 2.885-5.265 2.885l1.47 5.284-.342 9.13-.549 21.409c2.279 1.837 6.391 1.907 9.332 1.402 1.295-8.492-.788-20.72-.214-29.212l-.001-.001Z"
          fill="#F9F9FA"
        />
        <path
          opacity=".07"
          d="M198.612 115.594c-1.699-3.657-.636-8.162-1.958-11.779l-.338 9.034-.549 21.409c2.279 1.837 6.391 1.907 9.332 1.403.558-3.66.487-8.015.273-12.464-2.928-1.807-5.342-4.551-6.76-7.603Z"
          fill="#010101"
        />
        <path
          d="M200.451 95.55a2.286 2.286 0 1 0 4.571 0v-3.738h-4.234l-.337 3.739Z"
          fill="#F7CDB4"
        />
        <path
          opacity=".07"
          d="M200.718 92.6c.053.198.081.414.075.652-.045 1.699 1.69 4.105 3.566 2.903.496-.317.688-.899.663-1.756l.001-.016v-2.571h-4.234l-.071.788Z"
          fill="#010101"
        />
        <path
          d="M199.946 92.426c0 1.913 2.297 2.822 3.42 2.975 1.356.186 2.823-.848 2.823-2.796v-4.904l-6.628 1.182.385 3.543Z"
          fill="#F7CDB4"
        />
        <path
          d="M205.355 85.729c-2.628-1.65-4.897-.694-6.461 1.28-.764.962-.239 2.902-.012 3.812.512 2.059 1.709 3.186 1.709 3.186l.197-3.264.384.649.55-.402s-.241-1.385-.23-1.615c.039-.785 4.696-.898 4.696-.898s2.033-.948-.833-2.748Z"
          fill="#424143"
        />
        <path
          d="m200.562 94.322-1.002 1.552c1.194 2.966 3.805 3.396 3.805 3.396l.563-1.77c-3.217-.472-3.366-3.178-3.366-3.178Zm3.367 3.178s1.112.78 1.391 1.244c0 0 .597-2.797-.297-3.689 0 0 .163 1.602-1.094 2.445Z"
          fill="#F6F6F6"
        />
        <path
          d="M199.66 90.912c-.105.839.451 1.763 1.129 1.452l.064-1.512s-1.049-1.08-1.193.06Z"
          fill="#F7CDB4"
        />
        <path
          opacity=".07"
          d="M208.073 97.369c-.686-.961-2.092-1.717-2.092-1.717l-.76-.33s.348.742.669 2.297c.32 1.556-.153 8.433-.153 8.433.93-3.827 2.702-6.807 2.702-6.807l-1.098-1.693.732-.183Z"
          fill="#010101"
        />
        <path
          d="M207.674 97.345c-.686-.96-1.693-1.693-1.693-1.693l-.76-.33s.348.742.669 2.297c.32 1.556-.153 8.433-.153 8.433.93-3.827 2.303-6.831 2.303-6.831l-1.098-1.693.732-.183Z"
          fill="#fff"
        />
        <path
          opacity=".07"
          d="M199.943 95.195s-.686.732-1.098 1.006c-.412.275-.47 2.54-.47 2.54l.824.046-.046 1.83c1.876.64 5.73 5.862 5.73 5.862-.854-2.654-2.333-5.749-3.431-7.213-1.098-1.464-1.509-4.071-1.509-4.071Z"
          fill="#010101"
        />
        <path
          d="M199.943 95.195s-.686.732-1.098 1.006c-.412.275-.183 2.379-.183 2.379l.824.046-.046 1.83c1.876.64 5.444 6.023 5.444 6.023-.854-2.653-2.333-5.749-3.431-7.213-1.098-1.463-1.51-4.071-1.51-4.071Zm-1.052 11.619v3.66s2.333 1.189 3.705-.229l-.183-3.431h-3.522Z"
          fill="#fff"
        />
        <path
          d="m200.347 94.65-.361.198c-.104.112-1.068 1.36.14 4.742 1.194 3.344.777 5.25.773 5.269l.284.068c.02-.08.453-2.003-.782-5.435-1.184-3.29-.064-4.829-.054-4.842Zm4.668.387.163.198c.098.014 2.145.534 2.058 4.564l.233.035c-.077-4.954-2.413-4.721-2.454-4.797Z"
          fill="#04556D"
        />
        <path
          d="M201.102 105.794a.954.954 0 1 0 0-1.908.954.954 0 0 0 0 1.908Z"
          fill="#B5B5B5"
        />
        <path
          d="M201.102 104.145a.698.698 0 0 0-.696.696.697.697 0 0 0 1.392 0 .698.698 0 0 0-.696-.696Zm0 1.098a.403.403 0 1 1 0-.806.403.403 0 0 1 0 .806Z"
          fill="#787877"
        />
        <path
          d="M208.748 100.721c-.284-.496-.74-.8-1.353-.9-.495-.08-.869.035-1.119.345-.985 1.218.376 5.146.749 6.154-.038.053-.058.114-.034.173l.162.403c.04.1.168.142.286.095.119-.048.182-.167.142-.266l-.163-.404c-.029-.073-.108-.1-.194-.098-.371-1.016-1.671-4.815-.778-5.918.2-.247.502-.335.913-.266.546.09.948.355 1.197.791.72 1.259.03 3.592-.23 4.361-.073.011-.138.043-.16.109l-.139.412c-.035.102.036.217.156.258.12.04.246-.009.281-.111l.139-.412c.023-.068-.013-.134-.067-.188.273-.797.983-3.187.211-4.538h.001Z"
          fill="#A8A7A6"
        />
        <path
          d="M207.395 99.82c-.495-.078-.869.036-1.12.346-.32.396-.389 1.081-.328 1.858.069-.02.139-.039.21-.056-.055-.707.009-1.318.29-1.664.199-.247.501-.335.912-.266.546.09.948.356 1.197.791.217.381.297.862.308 1.365.077.035.15.076.223.115 0-.579-.084-1.141-.34-1.588-.283-.496-.739-.8-1.352-.9Z"
          fill="#04556D"
        />
        <path
          d="m186.359 156.583 1.227-.632v-2.181l-1.247-.718.02 3.531Z"
          fill="#8B8A8A"
        />
        <path
          d="m185.201 152.409 24.419 14.099v-22.949l-24.399-14.038-.02 22.888Z"
          fill="#C0BFBF"
        />
        <path
          d="m208.199 169.157 1.421.842v-26.44l-1.4-.781-.021 26.379ZM185.201 155.9l1.158.683v-26.44l-1.138-.622-.02 26.379Z"
          fill="#C0BFBF"
        />
        <path
          opacity=".15"
          d="m185.201 130.466 24.419 14.099v-1.006l-24.399-14.038-.02.945Z"
          fill="#010101"
        />
        <path
          d="m257.157 142.486 1.178-.603v-26.4l-1.178.603v26.4Zm-47.537 27.472 1.218-.728v-26.399l-1.218.728v26.399Z"
          fill="#fff"
        />
        <path
          d="m209.62 167.008 48.716-28.076v-23.449l-48.716 28.076v23.449Z"
          fill="#fff"
        />
        <path
          opacity=".15"
          d="m209.62 144.587 48.716-28.076v-1.028l-48.716 28.076v1.028Z"
          fill="#010101"
        />
        <path
          d="m184.613 129.603 24.978 14.421v-1.496l-24.957-14.359-.021 1.434Z"
          fill="#333B42"
        />
        <path
          d="m209.591 143.983 49.831-28.719v-1.454l-49.831 28.718v1.455Z"
          fill="#697179"
        />
        <path
          d="m184.634 128.169 24.957 14.359 49.832-28.718-24.937-14.339-49.852 28.698Z"
          fill="#454E58"
        />
        <path
          d="m255.974 141.875 1.174.611v-2.868l-1.174.677v1.58Z"
          fill="#969696"
        />
        <path
          d="m222.404 118.256-5.063-2.423a.708.708 0 0 0-.646 0l-12.543 7.241c-.179.104-.181.272-.002.375l5.062 2.424a.716.716 0 0 0 .647 0l12.543-7.242c.179-.103.18-.271.002-.374v-.001Z"
          fill="#A7A6A6"
        />
        <path
          d="m222.402 118.631-12.543 7.241a.71.71 0 0 1-.647 0l-5.063-2.423c-.088-.052-.132-.119-.132-.186v.121c0 .067.044.134.133.186l5.062 2.72a.71.71 0 0 0 .647 0l12.543-7.241c.09-.052.135-.121.135-.189v-.418c0 .068-.045.137-.135.189Z"
          fill="#878787"
        />
        <path
          d="M216.881 116.211c-.025-.013-.068-.01-.096.006l-.641.371c-.028.016-.031.039-.006.051l.633.313a.114.114 0 0 0 .095-.007l.642-.37c.028-.016.03-.039.005-.052l-.632-.312Zm-.832.48a.114.114 0 0 0-.095.007l-.642.37c-.027.017-.03.04-.005.052l.633.313a.114.114 0 0 0 .095-.007l.641-.371c.028-.015.03-.039.006-.051l-.633-.313Zm1.608-.053-1.67.964c-.023.013-.023.032-.002.043l.547.27a.094.094 0 0 0 .08-.004l1.67-.964c.022-.013.023-.032.001-.043l-.546-.27a.094.094 0 0 0-.08.004Zm.764.377-1.286.743c-.022.012-.023.032-.001.042l.546.271c.022.01.058.008.08-.004l1.286-.743c.022-.013.023-.032.001-.042l-.547-.271a.092.092 0 0 0-.079.004Zm.763.378-1.063.613c-.023.014-.023.033-.002.043l.547.271a.094.094 0 0 0 .08-.004l1.062-.614c.023-.013.023-.032.002-.043l-.547-.27a.092.092 0 0 0-.079.004Zm.763.377-.658.38c-.023.013-.023.032-.002.043l.547.271a.1.1 0 0 0 .079-.004l.658-.38c.023-.013.023-.032.002-.043l-.547-.271a.096.096 0 0 0-.079.005v-.001Zm.763.378-.708.409c-.023.013-.023.032-.002.043l.313.154a.095.095 0 0 0 .079-.003l.709-.41c.022-.013.023-.032.001-.042l-.312-.155a.094.094 0 0 0-.08.004Zm-5.492-.977a.117.117 0 0 0-.096.007l-.642.371c-.027.016-.03.039-.005.051l.633.313c.024.012.067.009.095-.007l.642-.37c.028-.017.03-.04.005-.052l-.632-.313Zm.6.528-.658.38c-.023.013-.023.032-.002.043l.547.27a.091.091 0 0 0 .079-.004l.658-.38c.023-.012.023-.031.002-.042l-.547-.27a.095.095 0 0 0-.079.003Zm1.15.155-.658.379c-.022.014-.023.033-.001.043l.546.271c.022.01.057.009.08-.004l.658-.38c.023-.013.023-.032.001-.043l-.547-.27a.092.092 0 0 0-.079.004Zm.984.25-.658.38c-.023.013-.023.032-.002.043l.547.27c.021.01.057.009.079-.004l.658-.38c.023-.013.023-.032.002-.043l-.547-.27a.091.091 0 0 0-.079.004Zm1.172.142-.658.38c-.022.012-.023.031-.001.042l.546.271c.022.01.058.008.08-.004l.658-.38c.022-.013.023-.032.001-.043l-.546-.271a.098.098 0 0 0-.08.005Zm.733.394-.708.409c-.022.012-.023.032-.002.043l.313.154a.094.094 0 0 0 .08-.004l.708-.409c.022-.013.023-.032.001-.043l-.312-.154a.094.094 0 0 0-.08.004Zm-5.471-.988a.11.11 0 0 0-.095.007l-.804.464c-.027.016-.03.039-.005.051l.632.313a.117.117 0 0 0 .096-.007l.803-.464c.028-.016.03-.039.005-.052l-.632-.312Zm.605.525-.658.38c-.023.013-.023.032-.002.043l.547.27a.091.091 0 0 0 .079-.004l.658-.38c.023-.013.023-.032.002-.043l-.547-.27a.092.092 0 0 0-.079.004Zm1.153.153-.658.38c-.022.012-.023.032-.002.042l.547.271c.021.01.057.008.08-.004l.658-.38c.022-.013.023-.032.001-.043l-.546-.27a.094.094 0 0 0-.08.004Zm.98.252-.658.38c-.022.012-.023.032-.001.042l.546.271c.022.01.058.008.08-.004l.658-.38c.023-.013.023-.032.002-.043l-.547-.27a.094.094 0 0 0-.08.004Zm1.177.139-.658.38c-.022.012-.023.032-.001.042l.546.271a.094.094 0 0 0 .08-.004l.658-.38c.022-.013.022-.032.001-.042l-.547-.271a.092.092 0 0 0-.079.004Zm.705.411-.709.409c-.022.013-.022.032-.001.043l.313.154a.092.092 0 0 0 .079-.004l.709-.409c.022-.013.022-.032.001-.043l-.312-.154a.094.094 0 0 0-.08.004Zm-5.614-.906c-.025-.013-.068-.01-.096.006l-3.96 2.287c-.028.016-.03.039-.005.051l.632.313a.114.114 0 0 0 .095-.007l3.961-2.286c.027-.017.03-.04.005-.052l-.632-.312Zm.771.429-.658.38c-.023.013-.023.032-.002.043l.547.27a.092.092 0 0 0 .079-.004l.658-.38c.023-.013.023-.032.002-.042l-.547-.271a.091.091 0 0 0-.079.004Zm1.156.151-.658.38c-.023.013-.023.032-.002.043l.547.27a.094.094 0 0 0 .08-.004l.658-.38c.022-.013.023-.032.001-.043l-.547-.27a.092.092 0 0 0-.079.004Zm.978.253-.658.38c-.022.013-.023.032-.001.043l.546.27a.094.094 0 0 0 .08-.004l.658-.38c.023-.013.023-.032.002-.042l-.547-.271a.094.094 0 0 0-.08.004Zm1.181.137-.658.38c-.023.013-.023.032-.002.043l.547.27a.094.094 0 0 0 .08-.004l.658-.38c.022-.013.023-.032.001-.042l-.546-.271a.094.094 0 0 0-.08.004Zm.677.428-.708.409c-.023.013-.023.032-.002.043l.313.154a.094.094 0 0 0 .08-.004l.708-.409c.022-.013.023-.032.001-.043l-.312-.154a.094.094 0 0 0-.08.004Zm-4.82-.491-.658.38c-.022.012-.023.031-.001.042l.547.271c.022.01.057.008.079-.004l.658-.38c.022-.013.023-.032.001-.043l-.547-.271a.1.1 0 0 0-.079.004v.001Zm1.159.149-.658.38c-.022.013-.023.032-.001.043l.547.27a.092.092 0 0 0 .079-.004l.658-.38c.023-.013.023-.032.002-.042l-.547-.27a.097.097 0 0 0-.08.003Zm.977.254-.658.38c-.022.013-.023.032-.001.043l.546.27a.094.094 0 0 0 .08-.004l.658-.38c.022-.012.023-.032.001-.042l-.546-.271a.094.094 0 0 0-.08.004Zm1.184.135-.658.38c-.023.013-.023.032-.002.043l.547.27a.094.094 0 0 0 .08-.004l.658-.379c.022-.014.022-.033.001-.043l-.547-.271a.089.089 0 0 0-.079.005v-.001Zm.648.444-.709.409c-.022.013-.023.032-.001.043l.312.155c.022.01.057.009.08-.004l.708-.41c.023-.013.023-.032.002-.042l-.313-.155a.092.092 0 0 0-.079.004Zm-4.795-.505-.658.38c-.022.013-.023.032-.001.043l.546.27a.094.094 0 0 0 .08-.004l.658-.38c.023-.013.023-.032.002-.042l-.547-.27a.094.094 0 0 0-.08.003Zm1.161.148-.658.38c-.022.013-.023.032-.001.042l.547.271a.092.092 0 0 0 .079-.004l.658-.38c.022-.012.023-.032.002-.043l-.547-.27a.102.102 0 0 0-.08.004Zm.975.256-.658.38c-.023.013-.023.032-.002.043l.547.27a.094.094 0 0 0 .08-.004l.658-.38c.022-.013.023-.032.001-.043l-.546-.27a.094.094 0 0 0-.08.004Zm1.188.133-.658.379c-.022.013-.023.032-.001.043l.547.27a.092.092 0 0 0 .079-.004l.658-.38c.022-.012.023-.032.002-.042l-.547-.271a.09.09 0 0 0-.08.005Zm.618.46-.708.409c-.022.013-.023.032-.002.043l.313.154a.091.091 0 0 0 .079-.004l.709-.409c.022-.013.023-.032.002-.043l-.313-.154a.094.094 0 0 0-.08.004Zm-4.769-.519-.658.38c-.022.012-.023.032-.002.042l.547.271a.094.094 0 0 0 .08-.004l.658-.38c.022-.013.023-.032.001-.043l-.546-.27a.094.094 0 0 0-.08.004Zm1.164.146-.658.38c-.022.013-.023.032-.001.043l.546.27a.094.094 0 0 0 .08-.004l.658-.38c.023-.013.023-.032.002-.042l-.547-.271a.094.094 0 0 0-.08.004Zm.973.257-.658.38c-.023.013-.023.032-.002.043l.547.27a.094.094 0 0 0 .08-.004l.658-.38c.022-.013.023-.032.001-.043l-.547-.27a.092.092 0 0 0-.079.004Zm-2.964.074-.658.38c-.023.013-.023.032-.002.043l.547.27a.094.094 0 0 0 .08-.004l.658-.38c.022-.012.023-.032.001-.042l-.546-.271a.094.094 0 0 0-.08.004Zm1.167.145-.658.38c-.022.013-.023.032-.001.042l.546.271a.094.094 0 0 0 .08-.004l.658-.38c.022-.013.022-.032.001-.043l-.547-.27a.092.092 0 0 0-.079.004Zm.97.259-.658.38c-.023.012-.023.032-.002.043l.547.27a.092.092 0 0 0 .079-.004l.658-.38c.023-.013.023-.032.002-.043l-.547-.27a.099.099 0 0 0-.079.004Zm2.018-.348-.658.38c-.022.013-.023.032-.001.043l.546.271c.022.01.057.008.08-.004l.658-.38c.022-.013.023-.032.001-.043l-.546-.27a.091.091 0 0 0-.079.004l-.001-.001Zm-.823.476-.658.38c-.023.013-.023.032-.002.042l.547.271a.094.094 0 0 0 .08-.004l.658-.38c.022-.013.023-.032.001-.043l-.546-.27a.094.094 0 0 0-.08.004Zm1.414.002-.709.409c-.022.013-.023.032-.001.043l.312.154a.094.094 0 0 0 .08-.004l.708-.409c.023-.013.023-.032.002-.043l-.312-.154a.094.094 0 0 0-.08.004Zm-6.359-.477a.117.117 0 0 0-.096.007l-.803.464c-.028.016-.03.039-.005.051l.632.313a.114.114 0 0 0 .095-.007l.804-.464c.027-.016.03-.039.005-.051l-.632-.313Zm.786.421-.658.38c-.023.013-.023.032-.002.043l.547.271c.022.01.057.008.08-.004l.658-.38c.022-.013.023-.032.001-.043l-.547-.271a.1.1 0 0 0-.079.004Zm1.169.143-.658.38c-.023.013-.023.032-.002.043l.547.271c.021.01.057.008.08-.004l.658-.38c.022-.013.022-.032.001-.043l-.547-.271a.1.1 0 0 0-.079.004Zm.968.26-.658.38c-.023.013-.023.032-.002.043l.547.27a.092.092 0 0 0 .079-.004l.658-.38c.023-.013.023-.032.002-.043l-.547-.27a.091.091 0 0 0-.079.004Zm1.199.126-.658.38c-.023.013-.023.032-.002.042l.547.271a.092.092 0 0 0 .079-.004l.658-.38c.022-.013.023-.032.002-.043l-.547-.27a.092.092 0 0 0-.079.004Zm1.384.018-.708.41c-.023.012-.023.032-.002.042l.313.155a.092.092 0 0 0 .079-.004l.709-.409c.022-.013.023-.032.001-.043l-.312-.154a.097.097 0 0 0-.08.003Zm-6.501-.394a.11.11 0 0 0-.095.006l-.642.371c-.028.016-.03.039-.005.051l.632.313a.114.114 0 0 0 .095-.007l.642-.37c.028-.016.03-.039.005-.052l-.632-.312Zm.953.325-.657.38c-.023.012-.023.031-.002.042l.547.271c.022.01.057.008.079-.004l.658-.38c.022-.013.023-.032.002-.043l-.547-.271a.102.102 0 0 0-.08.004v.001Zm1.172.141-.658.38c-.022.013-.023.032-.001.043l.547.27a.092.092 0 0 0 .079-.004l.658-.38c.022-.013.023-.032.001-.042l-.546-.27a.09.09 0 0 0-.08.004v-.001Zm.965.262-.658.379c-.022.013-.023.033-.001.043l.547.27a.092.092 0 0 0 .079-.004l.658-.379c.023-.014.023-.033.002-.043l-.547-.271a.094.094 0 0 0-.08.004v.001Zm1.204.123-.659.38c-.022.013-.023.032-.001.042l.547.271a.092.092 0 0 0 .079-.004l.658-.38c.022-.013.023-.032.002-.043l-.547-.27a.092.092 0 0 0-.079.004Zm1.356.035-.709.41c-.022.013-.023.032-.001.042l.312.155a.094.094 0 0 0 .08-.004l.708-.409c.022-.013.023-.032.002-.043l-.313-.154a.092.092 0 0 0-.079.004v-.001Zm-6.567-.404-.658.379c-.022.013-.023.032-.001.043l.283.14c.022.01.057.008.079-.004l.658-.38c.023-.013.024-.032.002-.043l-.283-.14a.09.09 0 0 0-.08.005Zm1.043.32-.658.38c-.023.013-.023.032-.002.043l.547.271a.1.1 0 0 0 .079-.004l.658-.38c.023-.013.023-.032.002-.043l-.547-.27a.091.091 0 0 0-.079.004v-.001Zm1.174.14-.658.38c-.022.013-.023.032-.001.043l.546.27a.094.094 0 0 0 .08-.004l.658-.38c.023-.013.023-.032.002-.043l-.547-.27a.094.094 0 0 0-.08.004Zm.963.263-.658.38c-.022.013-.023.032-.001.043l.546.27a.094.094 0 0 0 .08-.004l.658-.38c.023-.013.023-.032.002-.042l-.547-.271a.094.094 0 0 0-.08.004Zm1.208.121-.658.38c-.022.013-.023.032-.001.043l.546.27a.094.094 0 0 0 .08-.004l.658-.38c.022-.012.022-.032.001-.042l-.547-.27a.093.093 0 0 0-.078.003h-.001Zm1.326.052-.708.41c-.023.013-.023.032-.002.042l.313.155a.092.092 0 0 0 .079-.004l.709-.409c.023-.013.023-.032.002-.043l-.313-.155a.102.102 0 0 0-.08.004Zm-6.542-.418-.659.38c-.022.013-.023.032-.001.043l.283.14c.022.01.057.008.08-.004l.658-.38c.022-.013.023-.032.001-.043l-.283-.139a.091.091 0 0 0-.079.003Zm-.83.479-.658.38c-.022.013-.023.032-.001.042l.283.14a.092.092 0 0 0 .079-.004l.658-.38c.023-.013.023-.032.002-.042l-.283-.14a.094.094 0 0 0-.08.004Zm1.23-.282-.658.38c-.022.013-.025.031-.005.041l.252.125a.088.088 0 0 0 .075-.007l.658-.379c.023-.014.025-.032.006-.041l-.253-.125c-.019-.01-.052-.007-.075.006Zm.644.123-1.67.964c-.023.013-.023.032-.002.043l.547.27a.091.091 0 0 0 .079-.004l1.671-.964c.022-.013.023-.032.001-.043l-.547-.27a.092.092 0 0 0-.079.004Zm1.177.138-.658.38c-.022.013-.023.032-.002.043l.547.271c.022.01.058.008.08-.004l.658-.38c.022-.013.023-.032.001-.043l-.546-.27a.094.094 0 0 0-.08.004v-.001Zm.961.264-.658.38c-.022.013-.023.032-.002.043l.547.27a.094.094 0 0 0 .08-.004l.658-.379c.022-.013.022-.033.001-.043l-.547-.27a.091.091 0 0 0-.079.003Zm1.211.12-.658.379c-.023.014-.023.033-.002.043l.547.271c.022.01.057.009.08-.004l.658-.38c.022-.013.023-.032.001-.043l-.546-.27a.094.094 0 0 0-.08.004Zm1.297.068-.708.409c-.022.013-.023.032-.002.043l.313.155c.022.01.057.008.08-.004l.708-.41c.022-.013.023-.032.001-.042l-.312-.155a.094.094 0 0 0-.08.004Zm-4.294.024-.658.38c-.023.013-.023.032-.002.043l.547.27a.094.094 0 0 0 .08-.004l.658-.38c.022-.013.023-.032.001-.042l-.546-.27a.094.094 0 0 0-.08.003Zm.958.265-.658.38c-.023.013-.023.032-.002.043l.547.271c.021.01.057.008.08-.004l.658-.38c.022-.013.023-.032.001-.043l-.547-.27a.095.095 0 0 0-.079.003Z"
          fill="#3C3C3B"
        />
        <path
          d="m208.057 123.83-.152.088-.737-.363a.094.094 0 0 0-.08.004l-.436.253c-.023.013-.023.032-.001.043l1.326.652a.096.096 0 0 0 .081-.004l.628-.364c.023-.013.023-.033.002-.044l-.55-.27a.094.094 0 0 0-.08.004l-.001.001Zm2.014-.358-.658.38c-.023.013-.023.032-.002.043l.547.27a.094.094 0 0 0 .08-.004l.658-.38c.022-.012.022-.032.001-.042l-.547-.271a.092.092 0 0 0-.079.004Zm1.269.086-.709.409c-.022.013-.022.032-.001.043l.312.154a.094.094 0 0 0 .08-.004l.708-.409c.023-.012.023-.032.002-.042l-.313-.155a.092.092 0 0 0-.079.004Zm-2.092.39-1.083.625c-.023.013-.023.032-.002.043l.547.271a.1.1 0 0 0 .079-.004l1.084-.626c.022-.012.023-.032.001-.042l-.547-.271a.097.097 0 0 0-.078.004h-.001Zm1.24.102-.708.409c-.023.013-.023.032-.002.043l.313.154a.094.094 0 0 0 .08-.004l.708-.409c.022-.013.023-.032.001-.043l-.312-.154a.094.094 0 0 0-.08.004Zm-.852.492-.709.409c-.022.013-.023.032-.001.043l.312.154a.094.094 0 0 0 .08-.004l.708-.409c.023-.013.024-.032.002-.043l-.312-.154a.094.094 0 0 0-.08.004Z"
          fill="#3C3C3B"
        />
        <path
          d="M203.25 118.237c-.429-.312-1.818 1.225-1.818 1.225s.312.693.599.9c.286.208 2.109 1.17 2.109 1.17l.474.853.356.914c.234.199.412-.065.412-.065l-.149-.88-.233-1.013.622.592.524 1.121c.166.388.504.163.504.163l-.237-1.205-.316-.751.593.646.479.612c.436.339.647-.072.647-.072l-.773-1.342.607.368c.514.198.667-.148.667-.148l-2.536-2.218-2.53-.869-.001-.001Z"
          fill="#F7CDB4"
        />
        <path
          d="M198.44 103.137s.055-5.122-1.573-5.278c-2.778-.265-3.189 4.344-3.189 4.344l-.793 11.275c-.07.87.394 1.695 1.173 2.089l7.746 5.215s.041-1.859 2.104-2.836l-6.313-5.917.845-8.892Z"
          fill="#fff"
        />
        <path
          opacity=".07"
          d="M193.856 110.369c.428-3.406.223-7.203 1.279-10.777a4.5 4.5 0 0 1 .313-.78c.052-.251.123-.488.213-.709-1.694.92-1.983 4.1-1.983 4.1l-.793 11.275c-.07.87.394 1.695 1.173 2.089l7.746 5.215s.009-.29.142-.699c-1.477-.896-8.693-4.919-8.09-9.714Z"
          fill="#010101"
        />
        <path
          d="M199.402 127.346c-.854 0-1.571.514-1.807.968-.314.606 2.419 1.709 2.867 1.83.564.153 1.968-.64 1.96-1.059-.013-.682-2.166-1.739-3.02-1.739Z"
          fill="#fff"
        />
        <path
          d="M197.595 128.314c-.314.606 2.419 1.709 2.867 1.83.286.078.776-.092 1.199-.329-1.464-.076-2.953-.601-4.002-1.6-.023.034-.047.067-.064.1v-.001Z"
          fill="#F1F0F0"
        />
        <path
          d="m216.406 114.065-2.534-1.037-1.051 1.155.184.683.184 1.327 1.247 1.411s.21-.052.224-.446c.009-.278-.289-.349-.63-1.005-.342-.656.984-.04.984-.04l.841.814.42.815s.296.41.604.065l-.676-1.661.532.624.443.806s.309.389.647.06l-.814-1.786.551.486.565.775s.207.351.591.053l-.683-1.288-1.628-1.811h-.001Z"
          fill="#F7CDB4"
        />
        <path
          d="m216.406 114.065 1.484 1.852-.118-.768-1.366-1.084Z"
          fill="#F7CDB4"
        />
        <path
          d="m209.871 111.023.122 2.485 2.913 2.181s.18-.994.381-1.312c.549-.869 1.497-1.248 1.497-1.248l-2.87-3.006-2.043.9Z"
          fill="#fff"
        />
        <path
          d="M237.513 107.374a.494.494 0 0 0-.496-.003l-5.635 3.22a.284.284 0 0 0 0 .493l8.34 4.782a.498.498 0 0 0 .498-.003l5.468-3.216a.285.285 0 0 0-.001-.491l-8.174-4.782Z"
          fill="#989898"
        />
        <path
          d="m232.635 110.567 7.096 4.029 4.51-2.586-6.915-4.15-4.691 2.707Z"
          fill="#F3F3F3"
        />
        <path
          d="m232.635 110.837 7.096 4.029 4.51-2.586-6.915-4.149-4.691 2.706Z"
          fill="#fff"
        />
        <path
          d="M242.663 112.684a.088.088 0 0 0-.09-.001l-2.029 1.158a.09.09 0 0 0 0 .157l1.007.571a.088.088 0 0 0 .045.011c.015 0 .03-.004.044-.011l2.03-1.143a.09.09 0 0 0 .001-.157l-1.007-.586-.001.001Zm-1.067 1.703-.825-.468 1.847-1.054.826.481-1.848 1.041Z"
          fill="#505050"
        />
        <path
          d="m241.204 114.242.391.248 2.03-1.142-.421-.241c-.007-.005-2.007 1.143-2 1.135Z"
          fill="#505050"
        />
        <path
          d="M226.152 124.673a.858.858 0 0 0-.86 0l-4.935 2.841a.309.309 0 0 0-.001.535l1.892 1.096a.862.862 0 0 0 .866-.001l4.91-2.861a.309.309 0 0 0-.001-.534l-1.871-1.076Zm4.418-19.872-14.037 7.799a.994.994 0 0 0-.468.575l-2.302 12.952c-.127.408.761 1.095 1.131.881l13.371-8.288a.994.994 0 0 0 .449-.55l3.018-12.63c.136-.406-.788-.947-1.162-.739Z"
          fill="#676868"
        />
        <path
          d="m231.062 105.085-14.037 7.799a.998.998 0 0 0-.468.575l-2.301 12.952a.47.47 0 0 0 .682.547l13.82-7.954c.211-.122.372-.318.449-.55l2.529-12.81a.47.47 0 0 0-.674-.559Z"
          fill="#676868"
        />
        <path
          d="m222.237 120.532.015 7.483 3.859-2.373-.987-6.754-2.887 1.644Z"
          fill="#989898"
        />
        <path
          d="m222.008 119.674.229.829 2.887-1.643-.643-.601-2.473 1.415Z"
          fill="#838383"
        />
        <path
          d="m222.008 119.674-.056.333.113.492-.166 7.175.353.341-.015-7.512-.229-.829Z"
          fill="#676868"
        />
        <path
          d="m218.084 114.667 12.324-7.087.057-.28-12.339 7.055-.042.312Z"
          fill="#414141"
        />
        <path
          opacity=".07"
          d="M210.606 112.648c-.214-.366-.58-8.082-.58-8.082-.366 2.898-.033 8.942-.033 8.942l2.912 2.181.1-.823s-2.186-1.852-2.399-2.218Z"
          fill="#010101"
        />
        <path
          d="M259.656 155.61c-.679.392-1.226 1.339-1.223 2.116.001.387.137.659.357.787l.52.303c-.22-.128-.356-.401-.358-.788-.002-.777.545-1.724 1.224-2.116.34-.196.649-.215.871-.085l-.52-.302c-.223-.13-.531-.112-.871.085Z"
          fill="#424143"
        />
        <path
          d="M260.176 155.912c-.678.392-1.225 1.339-1.223 2.116.003.78.553 1.093 1.231.702.676-.391 1.223-1.338 1.221-2.118-.002-.777-.553-1.09-1.229-.7Z"
          fill="#424143"
        />
        <path
          d="M259.108 157.261a2.24 2.24 0 0 0-.155.767c.003.78.553 1.093 1.231.702.302-.175.574-.462.787-.793-.612-.189-1.216-.385-1.817-.651-.016-.007-.03-.017-.046-.024v-.001Z"
          fill="#2E2E2C"
        />
        <path
          d="M260.671 156.194c-.679.392-1.226 1.339-1.224 2.116.001.387.138.659.358.787l.52.302c-.221-.128-.357-.4-.358-.787-.002-.777.545-1.724 1.223-2.116.34-.196.649-.215.871-.085l-1.108-.643c-.222-.13.057.229-.283.426h.001Z"
          fill="#424143"
        />
        <path
          d="M261.191 156.496c-.678.392-1.225 1.339-1.223 2.116.002.78.553 1.093 1.231.702.676-.391 1.223-1.338 1.221-2.118-.002-.777-.553-1.09-1.229-.7Z"
          fill="#585856"
        />
        <path
          d="M252.602 149.099c-.678.392-1.225 1.339-1.223 2.116.001.388.137.66.358.788l.519.302c-.22-.128-.356-.4-.357-.788-.002-.776.545-1.724 1.223-2.115.34-.197.648-.215.871-.086l-.52-.302c-.223-.129-.531-.111-.872.085h.001Z"
          fill="#424143"
        />
        <path
          d="M253.123 149.401c-.678.392-1.226 1.339-1.224 2.116.003.78.553 1.093 1.232.702.675-.391 1.223-1.338 1.221-2.118-.003-.777-.553-1.09-1.229-.7Z"
          fill="#424143"
        />
        <path
          d="M252.054 150.751a2.21 2.21 0 0 0-.156.766c.003.78.553 1.094 1.232.702.301-.174.574-.462.786-.794-.612-.188-1.216-.384-1.817-.65-.016-.007-.03-.017-.045-.024Z"
          fill="#2E2E2C"
        />
        <path
          d="M253.617 149.683c-.679.392-1.226 1.339-1.223 2.116.001.387.137.66.357.788l.52.302c-.22-.128-.357-.4-.358-.788-.002-.777.545-1.724 1.224-2.116.34-.196.648-.214.871-.085l-1.108-.643c-.223-.129.057.23-.283.426Z"
          fill="#424143"
        />
        <path
          d="M254.136 149.985c-.678.392-1.225 1.339-1.223 2.116.002.78.553 1.094 1.231.702.676-.39 1.223-1.338 1.221-2.118-.002-.776-.552-1.09-1.229-.7Z"
          fill="#585856"
        />
        <path
          d="M272.789 154.131c-.34-.197-.649-.215-.871-.085l-.521.302c.223-.13.532-.112.872.085.678.392 1.225 1.339 1.223 2.116-.001.387-.138.659-.358.787l.52-.302c.22-.128.356-.4.358-.787.002-.777-.545-1.725-1.223-2.116Z"
          fill="#424143"
        />
        <path
          d="M272.269 154.433c-.676-.39-1.227-.076-1.229.7-.002.78.545 1.728 1.221 2.118.678.392 1.229.078 1.231-.702.003-.777-.545-1.725-1.223-2.116Z"
          fill="#424143"
        />
        <path
          d="M273.291 155.807c-.601.266-1.205.461-1.817.65.213.332.485.619.786.793.679.392 1.229.078 1.232-.701 0-.247-.059-.509-.156-.767l-.045.025Z"
          fill="#2E2E2C"
        />
        <path
          d="M271.774 154.715c-.339-.197-.061-.555-.283-.426l-1.108.643c.222-.129.531-.111.871.085.679.392 1.226 1.339 1.223 2.116-.001.387-.137.66-.358.788l.52-.303c.22-.128.357-.4.358-.787.002-.777-.545-1.725-1.223-2.116Z"
          fill="#424143"
        />
        <path
          d="M271.255 155.017c-.676-.39-1.226-.076-1.229.701-.002.779.545 1.727 1.221 2.117.678.392 1.229.078 1.232-.702.002-.776-.545-1.724-1.224-2.115v-.001Z"
          fill="#585856"
        />
        <path
          d="M276.294 147.28c-.34-.196-.648-.214-.872-.085l-.52.302c.223-.129.532-.111.872.085.678.392 1.226 1.339 1.223 2.116-.001.388-.137.66-.358.788l.52-.302c.22-.128.357-.401.358-.788.002-.777-.544-1.724-1.223-2.116Z"
          fill="#424143"
        />
        <path
          d="M275.774 147.582c-.676-.39-1.227-.076-1.229.701-.002.779.545 1.727 1.221 2.117.678.392 1.229.078 1.231-.701.002-.777-.545-1.725-1.223-2.117Z"
          fill="#424143"
        />
        <path
          d="M276.796 148.956c-.601.266-1.205.462-1.817.651.212.331.485.619.786.793.678.392 1.229.078 1.231-.702a2.185 2.185 0 0 0-.155-.766c-.016.007-.029.017-.045.024Z"
          fill="#2E2E2C"
        />
        <path
          d="M275.278 147.865c-.34-.197-.061-.556-.283-.426l-1.108.643c.222-.13.531-.112.871.085.679.392 1.226 1.339 1.224 2.116-.002.387-.138.659-.358.787l.52-.302c.22-.128.356-.4.357-.788.003-.777-.544-1.724-1.223-2.115Z"
          fill="#424143"
        />
        <path
          d="M274.758 148.166c-.676-.39-1.226-.076-1.229.701-.002.779.545 1.727 1.221 2.117.678.392 1.229.078 1.231-.702.003-.776-.544-1.724-1.223-2.116Z"
          fill="#585856"
        />
        <path
          d="M264.121 143.133c-.34-.197-.649-.215-.871-.086l-.521.303c.223-.13.532-.112.872.085.678.392 1.225 1.339 1.223 2.116-.001.387-.138.659-.358.787l.52-.302c.22-.128.356-.4.358-.788.002-.776-.545-1.724-1.223-2.115Z"
          fill="#424143"
        />
        <path
          d="M263.601 143.434c-.676-.39-1.227-.076-1.229.701-.002.779.545 1.727 1.221 2.117.678.392 1.229.078 1.231-.701.003-.777-.544-1.725-1.223-2.116v-.001Z"
          fill="#424143"
        />
        <path
          d="M264.623 144.808c-.601.266-1.205.462-1.817.651.212.331.485.619.786.793.679.392 1.229.078 1.232-.701 0-.247-.059-.509-.156-.767-.016.008-.029.017-.045.024Z"
          fill="#2E2E2C"
        />
        <path
          d="M263.106 143.717c-.34-.197-.061-.556-.283-.426l-1.108.643c.222-.13.531-.112.871.085.679.392 1.226 1.339 1.223 2.116-.001.387-.137.659-.357.787l.519-.302c.221-.128.357-.4.358-.788.002-.776-.545-1.724-1.223-2.115Z"
          fill="#424143"
        />
        <path
          d="M262.586 144.019c-.676-.39-1.226-.077-1.229.7-.002.78.546 1.727 1.221 2.118.679.391 1.229.077 1.232-.702.002-.777-.545-1.724-1.224-2.116Z"
          fill="#585856"
        />
        <path
          d="m262.668 144.235.571 3.595 1.862-.331-2.433-4.058v.794Zm-3.063 12.061s.562.395.995.408l4.896-6.566.013-1.798-5.904 7.341v.615Z"
          fill="#2F2E2D"
        />
        <path
          d="m265.483 150.163 6.77 5.394c.434-.013 1.046-.447 1.046-.447v-.614l-8.02-6.615.204 2.282Z"
          fill="#2F2E2D"
        />
        <path
          d="m262.891 149.522 13.701-1.275v-.561l-11.049.085-2.652 1.751Z"
          fill="#2F2E2D"
        />
        <path
          d="m252.472 150.201 10.81-.713.85-1.275-11.66 1.518v.47Z"
          fill="#2F2E2D"
        />
        <path
          d="m275.402 146.836-9.377.169-2.18-3.652c-.395.02-.787.049-1.177.088l1.107 3.769-10.914 1.768a3.353 3.353 0 0 0-.389.753l10.942-1.218-3.809 7.169c.23.168.409.282.872.435l4.958-7.009 6.824 5.822c.364-.143.717-.297 1.057-.464l-6.269-6.289 9.545-.492c-.142-.207-1.006-.65-1.19-.85v.001Z"
          fill="#424143"
        />
        <path
          d="M263.699 147.193a1.36 1.36 0 0 0 2.72 0V128.29h-2.72v18.903Z"
          fill="#2F2E2D"
        />
        <path
          d="m265.562 105.217-1.265.402 13.272 29.864 2.113-1.294-1.574-21.902-12.546-7.07Z"
          fill="#454E58"
        />
        <path
          d="m264.298 105.619-2.245 19.326 4.2 8.037 11.252.043-.79-20.278-12.417-7.128Z"
          fill="#515A63"
        />
        <path
          d="M268.322 129.641c-4.391-2.585-6.151-4.002-6.151-4.002l-14.01 6.657s-.251.36-.273.776c-.072 1.337.352 1.696.352 1.696s1.442 1.252 6.604 4.297a98.706 98.706 0 0 0 7.89 4.149c.337.158.728.143 1.053-.039l13.783-7.692s.745-.885-.08-2.443c-.021-.04-5.545-1.266-9.168-3.399Z"
          fill="#454E58"
        />
        <path
          d="m262.17 124.172-14.038 8.138s1.442 1.252 6.604 4.297a98.655 98.655 0 0 0 7.451 3.942c.61.29 1.32.264 1.909-.065l13.366-7.459s-3.794-1.703-9.141-4.85c-4.39-2.584-6.151-4.003-6.151-4.003Z"
          fill="#606871"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".7"
          d="m247.314 152.826 1.677 3.406 8.119-4.442-1.522-3.43-8.274 4.466Z"
          fill="url(#h)"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".7"
          d="m256.38 156.165.118 4.247 8.119-4.442-1.522-3.43-6.715 3.625Z"
          fill="url(#i)"
        />
        <path
          d="m251.942 132.722 9.835 4.62 1.556-1.395-2.104-4.094-9.287.869Z"
          fill="#B24E51"
        />
        <path
          d="m264.815 124.322.073 3.367s-2.315 1.539-7.033 4.842c-3.39 2.373-3.035 3.592-3.153 4.064-.11.44.528 18.097.616 20.487-.328.698-.978 2.075-1.18 2.447-.275.503-1.738 2.18-1.814 2.592-.126.676.579 1.388 2.317.564.907-.429 1.693-2.241 2.059-2.47.366-.229 1.372-.915 1.281-1.601-.077-.579-.315-1.353-.388-1.585.116-.815.514-3.596.937-6.467.322-2.186.869-4.518.961-6.13.235-4.128-.168-6.572-.168-6.572s11.535-4.88 13.068-7.121c1.534-2.241-2.47-7.441-2.47-7.441l-5.106 1.024Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".07"
          d="m267.797 123.724-2.983.599.074 3.367s-2.315 1.538-7.033 4.841l-.017.012c1.08.252 1.995 1.429 1.283 2.688-1.694 2.994-1.4 5.905-1.336 9.202.067 3.508-.225 6.991-.543 10.481-.238 2.63-.692 4.875-1.655 6.87.487-.658.882-1.425 1.112-1.568.366-.229 1.373-.916 1.281-1.602-.077-.578-.315-1.352-.388-1.584.116-.815.514-3.596.937-6.467.322-2.186.869-4.518.961-6.13.235-4.128-.168-6.572-.168-6.572s6.577-2.783 10.458-5.111c.727-3.068.852-6.252-1.638-8.585a1.866 1.866 0 0 1-.345-.441Z"
          fill="#010101"
        />
        <path
          d="M260.443 124.245s-4.384 3.078-9.187 5.503c-2.602 1.313-2.294 2.961-2.483 3.409-.19.448-1.632 19.782-1.632 19.782s-1.096 1.624-2.336 2.839c-1.016.996-2.181 1.575-2.47 1.967-.207.28.777.869 2.424.594 1.647-.274 1.777-1.567 2.745-1.738 1.555-.274 2.241-.686 2.333-.961.091-.274-.549-1.829-.458-2.287 0 0 .75-3.169 1.693-6.404.482-1.654.985-3.803 1.281-5.17.874-4.041.778-6.511.778-6.511s11.802-5.886 12.808-7.99c1.172-2.45-5.497-3.033-5.497-3.033h.001Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".07"
          d="M260.442 124.245s-1.635 1.147-3.999 2.591c1.267 2.824-.806 4.772-2.837 6.636-1.683 1.545-2.141 3.619-2.525 5.771-.013.53-.026.983-.06 1.29-.433 3.951-.916 8.393-2.085 12.193-.452 1.472-1.236 2.999-2.255 4.392.239-.25.477-.456.823-.517 1.555-.275 2.242-.686 2.333-.961.092-.274-.549-1.83-.457-2.287 0 0 .749-3.169 1.692-6.405.482-1.653.986-3.802 1.281-5.169.874-4.042.778-6.511.778-6.511s11.802-5.886 12.809-7.991c1.171-2.449-5.498-3.032-5.498-3.032Z"
          fill="#010101"
        />
        <path
          d="m259.719 124.624-7.64 4.575s6.065 2.892 7.914 4.255c2.951 2.173 1.784 3.888 1.784 3.888s9.653-3.98 10.522-7.045c.869-3.065-.641-5.947-.641-5.947l-11.939.275v-.001Z"
          fill="#DA5E62"
        />
        <path
          opacity=".07"
          d="M267.155 124.454c2.086 1.255 3.077 3.9 2.115 6.244-1.117 2.723-4.205 3.537-6.566 4.824a1.88 1.88 0 0 1-.814.235c.303.964-.113 1.585-.113 1.585s9.653-3.98 10.522-7.045c.869-3.065-.641-5.947-.641-5.947l-4.503.104Z"
          fill="#010101"
        />
        <path
          d="M261.687 106.738c-1.525 3.781-3.761 8.737-3.761 8.737l-8.85 2.333c.048.128.358-.013.39.12.089.365.192.724.312 1.08.03.09.064.179.096.269 0 0 5.039-.359 6.598-.599 1.784-.275 3.02-.961 3.02-.961s3.11-3.598 5.062-9.149c-.514-.065-2.539-1.333-2.867-1.83Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".07"
          d="m261.688 106.738-.149.364c.558.246.958.77.884 1.588-.273 3.015-1.187 6.21-3.591 8.229-1.108.931-2.54 1.569-4.053 1.954a35.662 35.662 0 0 0 1.694-.195c1.784-.275 3.019-.961 3.019-.961s3.111-3.599 5.063-9.149c-.514-.065-2.539-1.333-2.867-1.83Z"
          fill="#010101"
        />
        <path
          d="M244.517 121.01c.267.264.579-.061.579-.061l.61-.655.229-.153-.259 1.098c.289.122.503-.183.503-.183l.366-.915.686-.381s1.159-.244 1.159-.092c0 .153-.58.671-1.007.976-.427.305-.122.61-.122.61s1.311-.793 1.708-.945c.396-.153.904-1.033.904-1.033l.24-1.674-3.706.297-1.89 3.111Z"
          fill="#F7B7A9"
        />
        <path
          d="M244.517 119.547s.183.274.488.213c.305-.061 1.372-.823 1.372-.823l.031-1.037-1.098.808-.793.838v.001Z"
          fill="#F7B7A9"
        />
        <path
          d="m244.875 120.416.766-.801.191-.777-1.601 1.526s.256.372.644.052Z"
          fill="#F7B7A9"
        />
        <path
          d="M261.164 105.629c-.047.284-1.308 2.878-2.284 5.805.957.34 3.736.637 4.752.825.289-1.478.586-2.971.814-4.07.652-3.143.714-4.042.714-4.042-2.218-1.351-3.853.601-3.997 1.481l.001.001Z"
          fill="#E9E8E9"
        />
        <path
          d="M263.332 103.879c-.544.043-.71.157-.71.157s-.633.139-.903 1.178c-.117.453.089 1.116-.068 1.794l-.889 2.268-.893 2.579c-.536 2.107.89 3.162.89 3.162l.543 3.971-1.583 5.637s7.324 4.172 11.907.592l-1.357-4.718c-.073-5.208.626-11.676.626-11.676s2.139-.409 1.649-1.213c-2.624-4.302-7.26-3.887-9.211-3.73l-.001-.001Z"
          fill="#E9E8E9"
        />
        <path
          opacity=".07"
          d="M270.531 113.046c-.614 1.109-1.202 2.233-1.529 3.474-.834 3.157-.295 6.431-1.248 9.582a1.91 1.91 0 0 1-.273.552c1.45-.067 2.899-.464 4.145-1.438l-1.356-4.718c-.035-2.479.105-5.236.261-7.452Z"
          fill="#010101"
        />
        <path
          d="M266.397 103.42c-2.187.416-2.573 2.055-2.375 2.408.199.352.834 1.113 2.618.549 2.124-.672 2.131-1.793 2.131-1.793s-.966-1.431-2.375-1.164h.001Z"
          fill="#F7B7A9"
        />
        <path
          d="m268.132 102.172-3.571-.389s-.554 2.511.366 3.928l3.844-1.127s-.791-1.385-.639-2.412Z"
          fill="#F7B7A9"
        />
        <path
          d="m268.132 102.172-3.571-.389s-.42 2.412-.041 2.903c.632.821 2.341-.197 3.018-.615.25-.336.455-.729.608-1.164l.005-.009a2.468 2.468 0 0 1-.019-.725v-.001Z"
          fill="#EAAEA1"
        />
        <path
          d="M262.888 100.626c0 1.968.822 3.864 2.715 3.359 0 0 3.239-.969 3.66-3.026l.533-3.632-6.695-1.194-.213 4.493Z"
          fill="#F7B7A9"
        />
        <path
          d="M266.589 93.46c-4.793 0-4.018 3.98-4.018 3.98 2.548 1.977 5.721 1.48 5.721 1.48l-.154 3.877c.006.625.506 1.541.506 1.541l2.9 1.827s-.188-6.834-.237-7.768c-.056-1.066-.405-4.937-4.719-4.937h.001Z"
          fill="#CD9848"
        />
        <path
          d="M272.681 108.024a.785.785 0 0 0-.586-.545c-2.205-.45-2.837 2.351-2.792 2.896.048.581 1.878 10.079 1.878 10.079.102 2.495-.287 7.775-.287 7.775l-1.243 2.408-.155 2.511s.192.158.537-.617l.177-1.11.269 1.359-.146.889-.074.338c-.093.319.252.406.454.148.059-.075.453-.485.453-.485l.845-.525.492-1.087.112-2.877c.373-2.377 1.316-6.954 1.381-7.582l.158-1.535s-.262-4.926-.699-8.106c-.292-2.128-.601-3.355-.774-3.934Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".07"
          d="M269.497 133.148s.085.063.241-.112c.051-1.518.552-3.012 1.017-4.537l-1.103 2.137-.155 2.512Zm3.184-25.124a.785.785 0 0 0-.586-.545c-2.205-.45-2.837 2.351-2.792 2.896.048.581 1.878 10.079 1.878 10.079.091 2.214-.205 6.305-.273 7.53.214-.731.407-1.47.522-2.224.627-4.106.244-6.533.133-10.637-.036-1.356.977-2.045 2.029-2.073a57.186 57.186 0 0 0-.136-1.092c-.292-2.128-.602-3.355-.775-3.934Z"
          fill="#010101"
        />
        <path
          d="M272.681 108.024a.785.785 0 0 0-.586-.545c-2.205-.45-2.837 2.351-2.792 2.896.025.297.514 2.921.987 5.417 1.231-.036 2.426-.247 3.491-.875a65.836 65.836 0 0 0-.326-2.959c-.292-2.128-.601-3.355-.774-3.934Z"
          fill="#E9E8E9"
        />
        <path
          opacity=".07"
          d="M269.488 109.365c-.147.445-.199.839-.185 1.01.025.297.514 2.921.987 5.417a9.99 9.99 0 0 0 1.347-.125c-.428-.399-1.829-3.984-2.046-5.249a7.326 7.326 0 0 1-.102-1.053h-.001Zm-6.019 6.213s3.33 2.43 5.298-.591c0 0-2.591 1.816-5.298.591Z"
          fill="#010101"
        />
        <path
          d="M247.188 155.939c-.075.014-.764.378-1.038.516-.908.459-2.436.331-2.556.318-.587.286-1.151.826-1.258.972-.207.28.777.869 2.424.595 1.647-.275 1.776-1.568 2.745-1.739 1.555-.274 2.241-.686 2.333-.96.046-.14-.096-.61-.235-1.099-.025.011-.131.962-2.416 1.397h.001Zm10.621 1.874c.034.538-1.075 1.556-1.704 2.219-1.438 1.516-1.835 1.499-3.113 1.105-.013-.004-.022-.011-.035-.015-.432.466-.63.87-.718 1.129-.228.674.492 1.441 2.23.618.907-.43 2.033-2.287 2.345-2.585.777-.743 1.258-.984 1.167-1.67-.021-.154-.058-.618-.172-.801Z"
          fill="#DA5E62"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m66.546 152.291 3.353 4.987 8.12-4.442-6.624-3.163-4.85 2.618Z"
          fill="url(#j)"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m81.941 154.497.68 3.772 4.746.24 8.119-4.443-6.623-3.162-6.922 3.593Z"
          fill="url(#k)"
        />
        <path
          d="m69.505 150.909-1.424-1.388s-.934.457-1.65 1.125c-.183.17-.346.544-.428.779l-.403 2.523.269.416h.295l.603-1.019c.168 1.073.381 2.455.496 2.704.679 1.473 1.97 1.969 2.628 1.571.476-.288.151-.683-.216-1.87l-.17-4.842v.001Z"
          fill="#676868"
        />
        <path
          d="M71.809 125.363c.005.931.385 3.525.385 3.525l1.174 11.014a15.963 15.963 0 0 0-2.319 3.729 70.562 70.562 0 0 1-2.967 5.891s-.303.149-.694.398c-.483 1.152.762 6.071 1.193 6.071.176 0 .898-.168 1.1-.223l-.005-.017-.171-4.842s4.684-5.357 7.538-8.888c.279-.345.441-1.005.373-1.538.59-3.819 1.372-11.001 1.372-11.001l2.545-6.395-8.416-1.364s-1.133-.548-1.108 3.64Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".07"
          d="M71.808 125.363c.006.931.386 3.526.386 3.526l1.174 11.013a15.96 15.96 0 0 0-2.319 3.729 70.69 70.69 0 0 1-2.968 5.891s-.302.149-.693.398c-.338.806.17 3.45.653 4.969-.081-5.535 4.747-10.194 7.193-15.111.614-1.235 1.556-1.849 2.565-2.003.497-3.775.99-8.293.99-8.293l2.545-6.395-8.417-1.363s-1.133-.548-1.109 3.64v-.001Z"
          fill="#010101"
        />
        <path
          d="m67.328 149.958-.065.042c-.004.011.031-.016.065-.042Zm.059-.038c.004-.011-.026.013-.059.038l.06-.038Z"
          fill="#F7B7A9"
        />
        <path
          d="M87.576 157.375c-.287-.074-.31-.2-.94-.833-1.048-1.051-2.537-3.054-2.74-3.945l-2.127.098s-.564 1.86-.266 3.116c0 0 .192.231.868.456l.353 2.309.25-.125.03-2.013c1.177.252 2.255 1.928 3.268 2.282.846.295 1.986.173 2.271.067 0 0 .299-.082.27-.39 0 0-.095-.726-1.237-1.022Z"
          fill="#676868"
        />
        <path
          d="m88.064 120.13-3.143-7.285s-2.588-11.127-2.759-11.683c-.26-.853-1.993-2.354-4.009-.718 0 0 .182.883 1.252 3.91.914 2.588 2.854 9.504 2.854 9.504l4.474 7.264c-.165.783.396 1.722.698 2.39l.16.596-.007.891s-.083.913.345.724l.164-.908.08.187s-.205 1.171.36 1.098l.154-.485c-.005.331.056.735.396.691l.219-.692c.192.347.415.201.415.201l-.05-1.569-.05-.114c.191.111.326-.001.326-.001l-.499-2.28-1.38-1.72v-.001Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".07"
          d="M88.646 123.101c.033.904-.028-.099-.068-.289-.175-.818-.447-1.604-.758-2.379a2.965 2.965 0 0 1-.2-1.335l-2.698-6.253s-2.589-11.127-2.76-11.684c-.26-.853-1.992-2.354-4.009-.717 0 0 .182.884 1.252 3.91.914 2.588 2.854 9.503 2.854 9.503l4.474 7.265c-.165.782.396 1.721.698 2.389l.16.596-.007.891s-.083.913.345.724l.164-.908.08.187s-.205 1.171.36 1.098l.154-.484c-.005.33.056.734.396.69l.028-.087a4.035 4.035 0 0 1-.398-1.671c-.006-.484-.05-.963-.068-1.446Z"
          fill="#010101"
        />
        <path
          d="M82.163 101.161c-.261-.853-1.993-2.354-4.01-.717 0 0 .182.884 1.252 3.91.914 2.588 2.854 9.503 2.854 9.503l3.404 6.909c.808-.031 2.216-1.141 2.363-1.282l-3.105-6.64s-2.588-11.126-2.759-11.683Z"
          fill="#F9F9FA"
        />
        <path
          opacity=".07"
          d="M84.129 109.445c-.776-3.322-1.858-7.93-1.966-8.284-.261-.853-1.993-2.354-4.01-.717 0 0 .182.884 1.252 3.91.914 2.588 2.854 9.503 2.854 9.503l3.404 6.909c.294-.012.666-.167 1.03-.365-1.32-2.521-1.903-5.214-2.777-8.08-.342-1.121-.21-2.094.213-2.876Z"
          fill="#010101"
        />
        <path
          d="m82.52 116.222.185-5.283s1.425-1.055.89-3.162l-.894-2.579-.888-2.268c-.158-.678-.072-1.572-.189-2.025-.27-1.039-.903-1.177-.903-1.177s-.167-.115-.71-.158a12.467 12.467 0 0 0-2.701.099c-2.184.317-4.832 1.31-6.265 4.018-.822 1.554 1.003 6.358 1.394 12.38.016.233-.001.468-.052.697l-.142 3.984s-.186.674-.388 1.765l-.02.089.003.002c-.274 1.503-.57 3.757-.475 6.163l.334 6.294s2.272 3.037 9.019.653a26.608 26.608 0 0 0 2.054-.818c3.12-1.408 3.134-2.389 3.134-2.389l-2.656-13.026-.73-3.259Z"
          fill="#FDD69B"
        />
        <path
          d="M86.635 156.542c-1.047-1.051-2.536-3.053-2.738-3.945.074-1.086.336-4.208 1.233-11.551.119-.972.284-2.447.385-3.449.1-.382.128-.79.08-1.157-.364-2.82-1.097-6.87-2.984-16.405l-4.431 7.851 3.593 10.603c-.105.956-.69 4.713-.678 6.386.014 1.953.623 7.918.64 7.94a10.17 10.17 0 0 0-.154.666c.044.144.059.172.128.311.048.097.094.195.14.293.677 1.142 1.887 1.595 2.926 2.337 1 .712 1.916 1.136 2.883.978l-.082-.025c-.287-.074-.31-.2-.941-.833Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".07"
          d="m78.18 127.886 3.593 10.603c-.105.955-.69 4.713-.678 6.386.014 1.953.623 7.918.641 7.94-.036.134-.096.371-.155.666.045.145.06.172.129.312.048.097.094.195.14.293.423.713 1.054 1.158 1.722 1.572-2.107-5.513-.844-13.574-.021-18.029.245-1.328.954-2.158 1.85-2.577-.419-2.792-1.188-6.928-2.79-15.017l-4.43 7.852-.001-.001Z"
          fill="#010101"
        />
        <path
          d="M82.491 117.106c-1.015.661-2.532 1.271-3.831 1.3a3.849 3.849 0 0 1-.538-.032c-1.71.47-3.53.554-5.025.011l-.76 3.46s-.185.675-.387 1.765l-.02.09.002.001c-.273 1.503-.569 3.757-.475 6.163l.334 6.294s2.273 3.037 9.02.653c5.187-1.833 5.187-3.207 5.187-3.207l-3.233-13.327-.274-3.172v.001Z"
          fill="#676868"
        />
        <path
          d="M79.93 109.367c-.286-.901-2.392-5.557-2.587-6.117-.351-.338-.738-.638-1.07-.997a7.57 7.57 0 0 1-1.32-1.964c-1.509.594-2.97 1.624-3.907 3.397-.822 1.554 1.259 9.882 1.342 13.077 0 0-.89 6.956-1.028 7.967-.351 2.564-.55 10.339-.55 10.339s2.562 2.287 8.102 1.184c.841-.167 1.478-.558 2.054-.818-2.169-8.219-.177-17.372-1.035-26.068Z"
          fill="#F9F9FA"
        />
        <path
          opacity=".07"
          d="M72.608 123.878c.327-3.794 1.056-7.543 1.283-11.346.163-2.735.231-4.936-1.993-6.791a3.922 3.922 0 0 1-1.024-1.264c-.196 2.611 1.44 9.457 1.514 12.287 0 0-.89 6.956-1.028 7.966-.351 2.565-.55 10.339-.55 10.339s1.252 1.111 3.889 1.409c-2.245-3.693-2.48-8.081-2.09-12.6Z"
          fill="#010101"
        />
        <path
          d="m83.251 119.481-.409-3.168-.136-5.374s1.425-1.055.89-3.162l-.894-2.579-.889-2.269c-.157-.677.46-1.327.343-1.781-.27-1.039-1.434-1.42-1.434-1.42s-.167-.115-.71-.158c-.647-.052.598 4.789 1.183 7.274.236 1.001.56 1.553.721 2.55 1.269 7.887.17 17.053 2.253 24.943 2.745-1.341 2.226-2.074 2.226-2.074l-3.144-12.781v-.001Z"
          fill="#F9F9FA"
        />
        <path
          d="M79.44 101.75c.2-.353-.187-1.992-2.374-2.407-1.408-.268-2.236.986-2.236.986s-.131 1.298 1.993 1.97c.485.153.718.163 1.048.156.276-.007 1.616 1.612 1.616 1.612s-.146-2.14-.046-2.317Z"
          fill="#F7B7A9"
        />
        <path
          d="M75.332 98.094c.152 1.027-.323 2.066-.323 2.066l3.838 1.467c.17-1.306.056-3.922.056-3.922l-3.571.39Z"
          fill="#F7B7A9"
        />
        <path
          d="M75.331 98.094c.029.194.03.385.022.573.289 1.315 1.343 2.166 2.645 2.317.287-.102.606-.208.92-.332a41.924 41.924 0 0 0-.016-2.947l-3.57.39Z"
          fill="#EAAEA1"
        />
        <path
          d="M72.314 102.98a1.193 1.193 0 0 0-1.268.707c-.276.626-.71 1.734-1.23 3.492-.909 3.079-1.908 7.909-1.908 7.909l-.074 1.541c-.031.641.042 8.828.042 8.828l-.357 3.185.323 1.148.756.647s.328.464.375.547c.16.285.515.25.471-.078l-.022-.346-.01-.901.47-1.303.007 1.125c.225.817.439.69.439.69l.223-2.506-.867-2.568s.629-6.725 1.105-9.176c0 0 3.235-9.116 3.37-9.683.117-.491-.049-2.973-1.846-3.259v.001Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".07"
          d="M72.313 102.98a1.193 1.193 0 0 0-1.268.707c-.276.626-.71 1.734-1.229 3.493-.91 3.078-1.909 7.908-1.909 7.908l-.074 1.542c-.031.64.042 8.827.042 8.827l-.357 3.185.323 1.149.756.646.009.013a9.337 9.337 0 0 1 .062-1.693 12.13 12.13 0 0 1 .377-1.794c.071-.208.13-.421.19-.633a4.015 4.015 0 0 1 .633-3.1c.221-2.177.604-5.681.92-7.308 0 0 3.235-9.116 3.37-9.683.117-.491-.049-2.972-1.846-3.258l.001-.001Z"
          fill="#010101"
        />
        <path
          d="M72.314 102.98a1.193 1.193 0 0 0-1.268.707c-.276.626-.71 1.734-1.23 3.493-.909 3.078-1.908 7.908-1.908 7.908s-1.016 7.152-.987 9.688c.005.002 1.25.58 2.812-.188.156-1.6.658-6.619 1.056-8.667 0 0 3.235-9.116 3.37-9.682.117-.492-.049-2.973-1.846-3.259Z"
          fill="#F9F9FA"
        />
        <path
          opacity=".07"
          d="M71.046 103.687c-.276.626-.71 1.734-1.23 3.493-.909 3.078-1.908 7.908-1.908 7.908s-1.016 7.152-.987 9.688c.004.002.923.421 2.168.058a4.387 4.387 0 0 1-.178-.68c-1.23-7.065.626-14.089 2.523-20.935a1.197 1.197 0 0 0-.389.468Z"
          fill="#010101"
        />
        <path
          d="m75.22 99.535-.871 1.009c.343 2.421 2.922 3.319 2.922 3.319l.6-1.409c-1.34-.308-2.65-2.919-2.65-2.919Zm3.719.321-.007.441c.555.8.51 1.453.51 1.453l.366-.289c-.306-1.128-.66-1.605-.66-1.605h-.21Z"
          fill="#fff"
        />
        <path
          d="m81.503 155.811.75 2.634.47.13-.024-2.265-1.196-.499Z"
          fill="#676868"
        />
        <path
          opacity=".07"
          d="M74.28 110.797c1.967 3.021 5.298.591 5.298.591-2.708 1.224-5.299-.591-5.299-.591Zm.77-11.044-1.434 1.189.571 1.842 1.007.183-.275 1.068 1.19.915c1.189.915 3.84 4.536 3.84 4.536-.122-1.403-1.94-5.799-2.429-6.195-2.046-1.663-2.47-3.538-2.47-3.538Z"
          fill="#010101"
        />
        <path
          d="m75.05 99.753-1.434 1.189 1.037 1.799 1.006.183-.274 1.068 1.19.915c1.19.915 3.374 4.578 3.374 4.578-.122-1.403-1.94-5.798-2.429-6.195-2.046-1.663-2.47-3.538-2.47-3.538Z"
          fill="#fff"
        />
        <path
          opacity=".07"
          d="m80.531 100.741.153-.244-.709-.942-.38-.016-.446.316s.415.935.66 1.606c.14.385.357 1.791.998 4.17.253.94.915 2.974.915 2.974-.206-2.185-.367-6.522-.367-6.522l-.823-1.342Z"
          fill="#010101"
        />
        <path
          d="m80.265 100.79.153-.244-.443-.991-.38-.016-.446.316s.415.935.66 1.606c.14.385.357 1.791.998 4.17.253.94.915 2.974.915 2.974-.206-2.185-.633-6.473-.633-6.473l-.823-1.342h-.001Z"
          fill="#fff"
        />
        <path
          d="m75.23 99.456-.361.198c-.104.112-1.068 1.36.14 4.742 1.194 3.344.777 5.25.773 5.269l.284.067c.02-.08.453-2.002-.782-5.435-1.184-3.288-.065-4.828-.054-4.841Zm4.516-.065-.143.15c.097.013 2.19.531 2.105 4.561l.232.034c-.07-4.618-2.152-4.668-2.194-4.744Z"
          fill="#04556D"
        />
        <path
          d="M75.985 110.6a.954.954 0 1 0 0-1.908.954.954 0 0 0 0 1.908Z"
          fill="#B5B5B5"
        />
        <path
          d="M75.985 108.951a.697.697 0 0 0 0 1.391.697.697 0 0 0 0-1.391Zm0 1.098a.403.403 0 1 1 0-.805.403.403 0 0 1 0 .805Z"
          fill="#787877"
        />
        <path
          d="M83.218 105.023c-.283-.496-.739-.799-1.352-.9-.495-.079-.87.036-1.12.346-.984 1.217.377 5.146.75 6.153-.038.054-.058.115-.034.173l.162.404c.04.099.168.141.287.094.118-.047.18-.166.14-.266l-.161-.403c-.03-.073-.11-.1-.195-.099-.371-1.016-1.67-4.814-.778-5.918.2-.247.502-.335.913-.266.546.09.948.356 1.197.791.72 1.259.03 3.592-.23 4.361-.073.011-.138.043-.16.11l-.14.411c-.033.102.037.217.157.258.12.041.246-.009.28-.11l.14-.412c.023-.069-.013-.135-.067-.189.273-.796.983-3.186.21-4.537l.001-.001Z"
          fill="#A8A7A6"
        />
        <path
          d="M73.02 90.238c-1.909 1.597.51 6.76.51 6.76l.665-1.264 1.91-5.375s-1.177-1.72-3.086-.121Z"
          fill="#424143"
        />
        <path
          d="m74.692 90.987 1.692-.685s-1.228-.486-1.692.685Z"
          fill="#9B9B9B"
        />
        <path
          d="m73.668 93.25.407 2.772a4.582 4.582 0 0 0 3.786 3.884c1.893.506 2.715-1.39 2.715-3.358l-.214-4.493-6.694 1.195Z"
          fill="#F7B7A9"
        />
        <path
          d="M75.358 90.626c-.8.43-2.301 1.649-1.69 5 .299 1.64 1.67 2.971 1.67 2.971l-.006-.502s.207-2.23.368-2.694c.094-.272.401-.608.77-.492 2.116.67 4.373-.304 4.373-.304.542-1.542-.309-2.725-.861-3.253-1.63-1.56-3.824-1.156-4.624-.726Z"
          fill="#424143"
        />
        <path
          d="M75.288 95.352c-.586.02-.545.497-.3.986.405.804.793.649.793.649l.127-1.404s-.034-.25-.62-.231Z"
          fill="#F7B7A9"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m122.508 69.348.045 6.534 10.76-6.013-4.835-3.683-5.97 3.162Z"
          fill="url(#l)"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m107.579 69.68.185 6.331 10.991-4.4-5.011-4.109-6.165 2.177Z"
          fill="url(#m)"
        />
        <path
          d="M106.254 72.369c-.335 1.425-2.607 3.198-3.406 3.813-.799.615-.984.891-.984.891a.503.503 0 0 0 .215.462c.191.194 1.509.503 2.339.164.831-.338 1.65-1.233 2.83-1.476 1.211-.249 1.507-.615 1.507-.615.307-1.255-.243-3.118-.243-3.118l-2.258-.122Z"
          fill="#DCDCDC"
        />
        <path
          d="M102.781 76.235c-.738.576-.917.838-.917.838a.503.503 0 0 0 .215.462c.191.194 1.509.503 2.339.164.164-.066.328-.159.493-.259-.001-.008-.005-.016-.007-.025-.11-.683-1.197-1.015-2.123-1.18Zm4.65-.055c1.049-.246 1.323-.572 1.323-.572.204-.833.031-1.932-.109-2.578a13.232 13.232 0 0 0-1.214 3.15Z"
          fill="#DA5E62"
        />
        <path
          d="M106.675 75.918c-.714.352-1.309.894-2.044 1.213-.921.4-1.916.489-2.714-.123a.906.906 0 0 0-.053.065.503.503 0 0 0 .215.462c.191.194 1.509.503 2.339.164.831-.338 1.65-1.233 2.83-1.476 1.211-.249 1.507-.615 1.507-.615a3.45 3.45 0 0 0 .083-.598c-.018.016-.034.034-.055.049-.643.466-1.403.511-2.108.859Z"
          fill="#424143"
        />
        <path
          d="m105.131 74.16-.164.175c.631.085 1.134.587 1.134.587l.179-.125c-.537-.7-1.149-.637-1.149-.637Zm-.368.382-.164.16c.631.085 1.134.603 1.134.603l.179-.126c-.537-.699-1.149-.637-1.149-.637Zm-.414.382-.164.16c.631.085 1.134.603 1.134.603l.179-.126c-.537-.699-1.149-.637-1.149-.637Z"
          fill="#DA5E62"
        />
        <path
          d="m122.335 69.185-1.841 1.25.266 4.37c-.367 1.186-.692 1.581-.217 1.87.658.398 2.18-.14 2.86-1.614.299-.65 1.036-4.367.629-4.783-.407-.416-1.696-1.093-1.696-1.093h-.001Z"
          fill="#DCDCDC"
        />
        <path
          d="M122.484 69.265c.059.819.399 1.5.982 2.105.183.19.4.35.614.512.094-.783.109-1.442-.049-1.604-.323-.329-1.196-.821-1.547-1.013Zm.282 5.863c-.597-.269-1.341-.26-2.057-.17-.344 1.061-.619 1.442-.166 1.716.651.395 2.149-.132 2.838-1.575-.173.1-.39.13-.615.029Z"
          fill="#DA5E62"
        />
        <path
          d="M123.773 70.06c-.118 2.548-.073 4.115-1.2 5.432-.536.626-1.177.693-2.027.83a.85.85 0 0 1-.234.004c.009.143.073.253.23.348.657.398 2.18-.14 2.859-1.613.3-.65 1.036-4.367.629-4.783a2.27 2.27 0 0 0-.257-.217Z"
          fill="#424143"
        />
        <path
          d="M119.229 63.294a15.979 15.979 0 0 0-2.319-3.73l1.173-11.013s.38-2.594.386-3.525c.025-4.188-1.109-3.64-1.109-3.64l-8.008 1.297-1.686-2.985c-1.887 9.535-2.62 13.585-2.984 16.405-.048.368-.02.775.08 1.157.101 1.002.267 2.477.385 3.449 1.186 9.709.955 11.81.955 11.81s.214.431 1.381.362c.859-.052 1.089-.441 1.089-.441s.597-5.95.61-7.902c.012-1.673-.572-5.43-.677-6.386l3.001-8.857c.115 1.04.669 7.207 1.209 10.705.043.588.241 1.339.52 1.684 2.854 3.531 7.281 9.116 7.281 9.116s.29.428 1.33 0c.896-.37.713-1.403.713-1.403s-1.747-2.541-3.33-6.104Z"
          fill="#04556D"
        />
        <path
          opacity=".07"
          d="M115.585 60.53c-.756-1.69 2.691-13.411 1.871-18.175-.017-.1.03-.173.045-.23-.046-.02-.108-.075-.192-.19a2.68 2.68 0 0 1-.278-.494l-7.679 1.243-1.686-2.985c-1.887 9.535-2.62 13.584-2.984 16.405-.048.368-.02.774.08 1.157.101 1.002.267 2.477.385 3.448 1.186 9.71.955 11.81.955 11.81s.214.432 1.381.362a2.34 2.34 0 0 0 .416-.062c.511-2.043.242-9.044-.623-14.09-.213-1.244 4.23-9.432 4.23-9.432.115 1.039.669 7.207 1.209 10.705.043.588.241 1.338.52 1.684 2.854 3.53 7.281 9.115 7.281 9.115s.29.428 1.33 0a1.14 1.14 0 0 0 .34-.214 4.898 4.898 0 0 1-.298-.748c-1.46-1.264-6.066-7.779-6.303-9.307v-.001Z"
          fill="#010101"
        />
        <path
          d="M108.114 20.825c-.17.557-2.759 11.683-2.759 11.683l-3.176 7.772-1.589 1.602-.484 2.243s.136.112.327 0l-.05.115-.05 1.569s.223.146.415-.201l.218.692c.34.044.402-.36.397-.69l.153.484c.566.073.36-1.098.36-1.098l.08-.187.165.908c.427.189.344-.724.344-.724l-.007-.891.105-.393c.34-.546 1.145-1.532.997-2.413l4.436-7.318s1.806-6.934 2.875-9.96c1.069-3.027 1.251-3.91 1.251-3.91-2.016-1.637-3.748-.136-4.009.717h.001Z"
          fill="#926750"
        />
        <path
          opacity=".07"
          d="M109.755 22.293a19.862 19.862 0 0 1-1.159 3.206c-.377.822-.839 1.512-1.337 2.26a3.946 3.946 0 0 0-.177.302c-.152 1.275-.341 2.54-.792 3.755-.02.053-.048.1-.073.149-.372 2.28-1.192 4.407-2.394 6.44-.754 1.274-1.918 3.084-2.722 3.799-.483.43-.447 1.286-.817 1.967a.323.323 0 0 0 .15-.046l-.051.114-.049 1.569s.223.146.415-.201l.218.692c.34.044.401-.36.396-.69l.153.484c.566.074.361-1.098.361-1.098l.08-.187.164.908c.428.19.345-.724.345-.724l-.008-.891.106-.393c.34-.545 1.144-1.532.997-2.413l4.436-7.318s1.805-6.934 2.875-9.96c.207-.59.381-1.095.527-1.531a1.679 1.679 0 0 1-.367-.015c-.425-.064-.851-.121-1.277-.18v.002Z"
          fill="#010101"
        />
        <path
          d="M119.23 23.35c-2.142-4.05-7.013-4.273-8.965-4.117-.543.044-.71.158-.71.158s-.633.139-.903 1.178c-.118.453-.031 1.346-.189 2.024l-.889 2.269-.893 2.578c-.535 2.108.89 3.162.89 3.162l-1.73 3.696c-.954 2.63-.196 5.043 1.094 7.525l.179.671s5.009 4.7 11.324-.228l-1.282-5.84a2.442 2.442 0 0 1-.053-.676c.388-6.032 2.95-10.845 2.127-12.4Z"
          fill="#DA5E62"
        />
        <path
          opacity=".06"
          d="M119.231 23.35a7.08 7.08 0 0 0-2.659-2.794c.007.02.016.037.022.058.543 1.951.607 4.085.255 6.164-.052 4.63-1.433 9.388-5.109 11.844-1.543 1.03-3.507 1.759-5.411 1.92.185.426.384.853.607 1.282l.179.67s5.008 4.702 11.323-.228l-1.281-5.839a2.48 2.48 0 0 1-.054-.676c.388-6.032 2.951-10.845 2.128-12.401Z"
          fill="#010101"
        />
        <path
          d="M113.21 19.006c-2.187.416-2.573 2.055-2.374 2.407.198.353.833 1.113 2.618.55 2.124-.672 2.13-1.793 2.13-1.793s-.966-1.431-2.374-1.164Z"
          fill="#926750"
        />
        <path
          d="m114.945 17.758-3.571-.39s-.112 2.738.058 4.045l4.152-1.243s-.792-1.385-.639-2.412Z"
          fill="#926750"
        />
        <path
          opacity=".07"
          d="m114.945 17.758-3.57-.39s-.054 1.306-.03 2.545c.947.898 2.841-.133 3.631-1.378a2.437 2.437 0 0 1-.031-.777Z"
          fill="#010101"
        />
        <path
          d="M109.701 16.212c0 1.967.822 3.863 2.715 3.358 0 0 3.239-.968 3.66-3.025l.532-3.632-6.694-1.194-.214 4.493h.001Z"
          fill="#926750"
        />
        <path
          d="M113.401 9.046c-4.792 0-4.018 3.979-4.018 3.979 2.549 1.977 5.721 1.481 5.721 1.481l-.153 3.877c.005.625.549 1.675.549 1.675l2.875 1.997s-.206-7.138-.255-8.072c-.057-1.066-.406-4.937-4.719-4.937Z"
          fill="#424143"
        />
        <path
          d="M122.382 45.146c.029-2.526.09-8.242.061-8.853l-.074-1.541s-1-4.83-1.909-7.91c-.52-1.758-.953-2.866-1.229-3.492a1.194 1.194 0 0 0-1.268-.707c-1.798.286-1.963 2.768-1.846 3.259.135.566 3.37 9.682 3.37 9.682.477 2.452 1.105 9.177 1.105 9.177l-.867 2.568.224 2.506s.213.127.438-.69l.033-.994.021-.004.424 1.176-.011.901-.022.346c-.044.328.311.362.471.078.047-.083.375-.548.375-.548l.756-.646.324-1.148-.358-3.185-.018.025Z"
          fill="#926750"
        />
        <path
          opacity=".07"
          d="M120.304 35.83c-.508-2.328-1.389-4.644-2.271-6.853-.859-2.15-1.533-3.593-1.099-5.804-.83.835-.906 2.356-.817 2.73.134.566 3.37 9.682 3.37 9.682.477 2.451 1.104 9.177 1.104 9.177l-.867 2.567.224 2.506s.026.013.066 0c-.193-2.134.958-4.017.964-6.15.007-2.626-.112-5.282-.674-7.855Z"
          fill="#010101"
        />
        <path
          d="m120.612 72.393.019.311s.77.136 1.212 0v-.31s-.886.134-1.231 0Zm.036.6.014.224s.511.125 1.18 0v-.224s-.477.116-1.194 0Zm.035.557.018.302s.438.17 1.142 0v-.303s-.477.148-1.16 0Z"
          fill="#DA5E62"
        />
        <path
          opacity=".07"
          d="M110.285 30.792s3.331 2.43 5.299-.591c0 0-2.591 1.815-5.299.59Z"
          fill="#010101"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m101.563 69.781-2.227 3.273 6.721-2.993-.158-2.235-4.336 1.955Z"
          fill="url(#n)"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m94.252 70.215-2.816-.761 9.687-3.072 2.68.982-9.55 2.851Z"
          fill="url(#o)"
        />
        <path
          d="m91.068 51.632 2.714-4.484.852-4.95s1.287-3.48 3.122-.688c0 0-.702 3.588-1.421 5.73-.61 1.818-3.301 4.387-4.107 5.128.075.369-.263.967-.527 1.236l-.078.209-.063.423s.093.506-.271.375l-.162-.508-.062.097s.202.656-.275.58l-.142-.276c.013.182-.028.4-.315.354l-.201-.394c-.153.178-.344.084-.344.084l.002-.858.04-.06c-.159.049-.275-.021-.275-.021l.464-1.201 1.05-.775h-.001Z"
          fill="#926750"
        />
        <path
          opacity=".07"
          d="M89.8 53.726c.263-.354.172-.724.511-1.01.273-.231.761-.303 1.093-.86.903-1.518 2.699-3.558 2.958-5.479a1.567 1.567 0 0 0-.256-1.109l.529-3.07s1.286-3.48 3.121-.688c0 0-.702 3.588-1.421 5.731-.61 1.818-3.3 4.386-4.107 5.128.075.368-.263.966-.526 1.236l-.08.208-.062.423s.093.506-.27.376l-.163-.51-.062.098s.202.656-.275.58l-.142-.276c.013.182-.028.4-.315.354l-.201-.394c-.153.179-.344.084-.344.084l.002-.808.012-.013H89.8Z"
          fill="#010101"
        />
        <path
          d="m99.687 71.24.821-1.846a.744.744 0 0 1 .614-.439l1.463-.128a.347.347 0 0 1 .37.267c.1.44.284 1.26.352 1.63.096.521-1.226 1.679-1.758 2.055-.542.384-2.372.49-2.654.15-.323-.39-.088-.981.792-1.689Z"
          fill="#F3F3F3"
        />
        <path
          d="M100.783 72.554a1.41 1.41 0 0 0 .56-.296 4.845 4.845 0 0 0 1.301-1.212 6.23 6.23 0 0 0 .273-.312 2.26 2.26 0 0 0 .297-.468c.038.179.072.342.093.459.095.52-1.226 1.678-1.758 2.054-.542.384-2.372.49-2.655.15a.577.577 0 0 1-.134-.348l.05.004c.631.21 1.332.14 1.973-.03Z"
          fill="#04556D"
        />
        <path
          d="M90.645 69.782c.665-.471 1.302-.972 1.776-1.938a.24.24 0 0 1 .23-.137l1.693.113a.236.236 0 0 1 .218.19c.076.39.218 1.35-.016 2.167 0 0-.263.3-1.297.471-1.006.167-.609.213-1.323.471-.715.259-1.82-.045-1.976-.217 0 0-.203-.138-.167-.398 0 0 .165-.228.862-.722Z"
          fill="#F3F3F3"
        />
        <path
          d="M89.949 70.332c.16.134.344.239.545.296.426.121.883.118 1.289-.018.117-.032.229-.079.338-.135.038-.012.077-.02.115-.035.253-.092.488-.275.739-.358.293-.096.626-.098.928-.144.315-.048.572-.235.76-.484a3.41 3.41 0 0 1-.117.724s-.263.3-1.297.47c-1.006.167-.609.213-1.323.471-.715.26-1.82-.045-1.976-.216 0 0-.203-.139-.167-.398 0 0 .042-.058.166-.173Z"
          fill="#04556D"
        />
        <path
          d="M97.756 41.51s-.567 2.895-1.204 5.038c-.205-.12-1.513-.236-1.921-.392-.178-.068-.858-.355-1.034-.427l1.038-3.531s1.287-3.48 3.122-.689Z"
          fill="#FDD69B"
        />
        <path
          opacity=".07"
          d="M97.191 41.578a1.54 1.54 0 0 0 .403-.3c.053.071.107.148.162.231 0 0-.567 2.895-1.204 5.039-.205-.12-1.513-.236-1.921-.392-.138-.052-.572-.235-.845-.348.202-.703.405-1.417.782-2.02.602-.962 1.627-1.703 2.624-2.21Z"
          fill="#010101"
        />
        <path
          d="M97.756 52.913v3.752l-2.611 4.796.13 1.116a5.285 5.285 0 0 1-.102 1.82l-.824 3.526s-1.008.702-1.712-.133l-.127-7.052 2.073-8.527 3.173.702Z"
          fill="#926750"
        />
        <path
          opacity=".07"
          d="m92.79 59.582 1.792-7.37 3.173.7v3.753l-2.611 4.796.13 1.116a5.287 5.287 0 0 1-.102 1.82l-.824 3.526s-.48.334-1.008.267c.437-.72.698-1.572.818-2.534.21-1.69.614-4.046-.487-5.492a1.553 1.553 0 0 0-.881-.582Z"
          fill="#010101"
        />
        <path
          d="M97.89 52.78v3.753l-1.593 3.8c-.422.152-2.404-.075-3.627-1.419l2.047-6.835 3.173.702Z"
          fill="#E9E8E9"
        />
        <path
          opacity=".07"
          d="m94.667 52.245.05-.166 3.173.702v3.751l-1.593 3.8c-.138.05-.443.058-.831.001l.014-.012c.594-.636.714-1.266.897-2.081.177-.785.597-1.47.834-2.24.288-.937-.307-1.6-1.041-1.793l.02-.089c.242-1.109-.655-1.837-1.523-1.873Z"
          fill="#010101"
        />
        <path
          d="M101.459 57.86c-.24 1.27-.74 4.085-.74 4.085l.876 1.507c.084.152.231.561.263.732l.875 4.75s-.216.375-.67.507c-.312.091-.778.038-1.196-.21 0 0-2.552-5.423-2.742-6.4-.19-.977-.699-5.133-.699-5.133l-.844-4.616 4.452-.5s.811 3.23.425 5.278Z"
          fill="#926750"
        />
        <path
          opacity=".07"
          d="M101.458 57.86c-.24 1.27-.74 4.085-.74 4.085l.876 1.507c.084.152.231.561.263.732l.876 4.75s-.125.216-.383.377a4.074 4.074 0 0 0-.071-1.572c-.178-1.626-.948-3.263-2.012-4.373a51.088 51.088 0 0 0-.466-.998c-.028-.059-.067-.108-.104-.16-.31-.683-1.124-1.043-1.805-.905a294.81 294.81 0 0 1-.466-3.605l-.844-4.616 4.452-.5s.811 3.229.425 5.277h-.001Z"
          fill="#010101"
        />
        <path
          d="M101.459 57.86c-.128.675.104 2.63.104 2.63-.845 1.041-4.107.534-4.137.542-.567-2.238-.844-7.95-.844-7.95l4.452-.5s.811 3.228.425 5.277Z"
          fill="#E9E8E9"
        />
        <path
          opacity=".07"
          d="M100.544 53.104a1.452 1.452 0 0 0-.147-.45l.637-.072s.811 3.228.424 5.277c-.127.676.105 2.63.105 2.63-.346.428-1.097.594-1.865.643.518-.847.638-1.827.772-2.883.222-1.756.341-3.388.075-5.145h-.001Z"
          fill="#010101"
        />
        <path
          d="M101.169 42.275c.68.02 1.252.517 1.453 1.167.357 1.156 1.004 3.346 1.295 4.913.361 1.942-.557 5.793-.795 6.734l.076 1.793-.405.646-.694.312s-.324.243-.372.288c-.165.153-.449.101-.373-.088l.061-.201.12-.529-.221-.807-.145.66c-.284.46-.429.222-.429.222l.115-1.348 1.01-1.415-.109-5.365-1.775-4.483s-.393-2.547 1.188-2.5Z"
          fill="#926750"
        />
        <path
          opacity=".07"
          d="M101.169 42.275c.68.02 1.253.517 1.453 1.167.357 1.156 1.004 3.346 1.295 4.913.361 1.942-.557 5.793-.795 6.734l.076 1.793-.404.646-.588.264c.197-.4.338-.855.412-1.363.163-1.107.042-2.226.233-3.33.25-1.44.689-2.793.543-4.272-.124-1.26-1.468-1.69-2.32-1.293l-1.093-2.76s-.393-2.547 1.188-2.5Z"
          fill="#010101"
        />
        <path
          d="M98.7 40.602c.146.055 2.278.716 3.352 1.94.609.693-.358 3.33-.754 6.524-.303 2.443.414 5.23.414 5.23s-3.998 2.867-7.7-.846l.601-9.946c-.039-2.05 2.167-3.621 4.086-2.902Z"
          fill="#FDD69B"
        />
        <path
          opacity=".07"
          d="M101.68 43.19c.22-.093.388-.215.512-.355.264.977-.541 3.38-.895 6.23-.303 2.444.414 5.23.414 5.23s-.467.335-1.229.627c-.18-1.685-.362-2.986-.316-4.59.05-1.721.013-3.37 0-4.705-.01-1.137.255-1.9 1.514-2.437Z"
          fill="#010101"
        />
        <path
          d="M101.169 42.275c.68.02 1.252.517 1.453 1.167.256.83.778 2.114 1.095 3.395-.648.588-1.856.848-2.778.875l-.958-2.938s-.393-2.547 1.188-2.5Z"
          fill="#FDD69B"
        />
        <path
          opacity=".07"
          d="m100.938 47.712-.957-2.938s-.043-.296-.04-.681c.278 1.301.982 2.51 1.846 3.528a6.448 6.448 0 0 1-.849.091Z"
          fill="#010101"
        />
        <path
          d="M98.333 40.36c1.047-.261 1.834.773 1.834.773s.043.843-1.525 1.438c-1.317.5-1.826-.045-1.99-.3-.165-.258.056-1.506 1.682-1.91v-.001Z"
          fill="#926750"
        />
        <path
          d="M99.584 39.348c-.07.778.583 1.785.583 1.785l-2.674.864c-.83-1.23-.609-2.79-.609-2.79l2.7.141Z"
          fill="#926750"
        />
        <path
          opacity=".07"
          d="M99.584 39.348c-.032.356.088.76.227 1.094a4.42 4.42 0 0 1-.872.745 1.75 1.75 0 0 1-1.806.077l-.009-.006c-.38-1.037-.24-2.05-.24-2.05l2.7.14Z"
          fill="#010101"
        />
        <path
          d="M100.24 39.417c-.507 1.631-2.493 1.774-2.493 1.774-1.606.023-2.002-1.032-2.087-2.51l-.023-2.612h5.081l-.478 3.348Z"
          fill="#926750"
        />
        <path
          d="m101.323 70.494-.093.228c-.592-.43-1.115-.445-1.115-.445l.097-.217c.77.076 1.112.434 1.112.434h-.001Zm-.287.43-.115.188c-.605-.322-1.003-.39-1.003-.39l.079-.178c.541.01 1.039.38 1.039.38Zm-.25.376-.161.242c-.417-.282-.939-.3-.939-.3l.117-.261c.427.002.983.32.983.32Zm-8.276-1.935-.219.174a1.663 1.663 0 0 0-.77-.46l.141-.141c.554.07.847.427.847.427Zm-.466.295-.188.121s-.42-.378-.63-.438l.161-.139s.294.087.657.456Zm-.451.215-.242.1a.99.99 0 0 0-.452-.377l.177-.135c.371.186.517.412.517.412Z"
          fill="#04556D"
        />
        <path
          d="M94.985 36.402a.482.482 0 0 1-.178-.37c0-.15.07-.279.176-.369a.477.477 0 0 1-.096-.276c0-.17.092-.313.224-.4a.476.476 0 0 1-.084-.258c0-.222.152-.403.355-.463 0-.01-.005-.017-.005-.027 0-.27.22-.49.49-.49.037 0 .07.014.105.021a.487.487 0 0 1 .455-.315c.057 0 .111.015.163.033a.487.487 0 0 1 .456-.321c.123 0 .233.05.319.125a.486.486 0 0 1 .457-.327.48.48 0 0 1 .384.2.48.48 0 0 1 .385-.2c.218 0 .397.146.46.343a.486.486 0 0 1 .803.193.482.482 0 0 1 .456.008.489.489 0 0 1 .24.463.482.482 0 0 1 .418.026c.191.11.272.328.225.532a.482.482 0 0 1 .331.052c.217.125.294.39.198.614a.482.482 0 0 1 .202.06.49.49 0 0 1 .18.67.484.484 0 0 1-.097.11c.042.01.084.018.122.04a.49.49 0 0 1 .179.67.468.468 0 0 1-.198.179.484.484 0 0 1 .084.585.482.482 0 0 1-.271.215.403.403 0 0 1 .049.468.402.402 0 0 1-.309.194.35.35 0 0 1 .11.464.35.35 0 0 1-.362.168.4.4 0 0 1-.403.586.4.4 0 0 1-.048.192.408.408 0 0 1-.555.15.333.333 0 0 1-.039.201.347.347 0 0 1-.475.127.336.336 0 0 1-.112-.108c-.12-.37-.188-2.115-.188-2.115s-.282-.01-.347-.068c-.153-.138-.197-.637-.205-.796 0-.01-.01-.018-.012-.028a.29.29 0 0 1-.137.038.3.3 0 0 1-.3-.3l.003-.008a.078.078 0 0 0-.029-.014.291.291 0 0 1-.164.056.296.296 0 0 1-.255-.152l-.073-.014a.294.294 0 0 1-.123.05.293.293 0 0 1-.25-.088.294.294 0 0 1-.215.155.296.296 0 0 1-.32-.2.295.295 0 0 1-.206.133.295.295 0 0 1-.315-.188.295.295 0 0 1-.179.1.298.298 0 0 1-.287-.129.294.294 0 0 1-.241.132c-.01 0-.018-.005-.027-.006a.296.296 0 0 1 .027.122c0 .148-.11.267-.253.29a.48.48 0 0 1 .102.285.484.484 0 0 1-.165.361.41.41 0 0 1 .172.33c0 .128-.06.239-.151.315a.28.28 0 0 1-.132.53.283.283 0 0 1-.284-.283c0-.062.024-.116.057-.162a.412.412 0 0 1-.326-.4c0-.104.042-.196.105-.27a.484.484 0 0 1-.256-.42.47.47 0 0 1 .081-.254.487.487 0 0 1-.15-.351.54.54 0 0 1 .248-.418v.002Z"
          fill="#424143"
        />
        <path
          d="M100.286 38.118c.13.525-.154 1.153-.607 1.006l-.121-1.029s.552-.689.728.023Z"
          fill="#926750"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m77.79 73.68 5.697 3.977 10.84-5.402-5.988-4.106-10.55 5.531Z"
          fill="url(#p)"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m63.071 71.513 1.677 5.43 11.907-5.26-5.572-3.534-8.012 3.364Z"
          fill="url(#q)"
        />
        <path
          d="M77.44 20.784c.17.557 2.759 11.684 2.759 11.684l3.493 7.769 1.374 1.65.381 2.197s-.135.111-.326 0l.05.114.05 1.57s-.223.146-.416-.202l-.218.692c-.34.045-.401-.36-.396-.69l-.153.484c-.566.074-.361-1.098-.361-1.098l-.08-.186-.164.907c-.428.19-.345-.723-.345-.723l.008-.892-.03-.58c-.339-.546-1.02-1.752-.77-2.478l-4.59-7.666s-1.955-6.334-3.024-9.36c-1.07-3.027-1.251-3.91-1.251-3.91 2.016-1.637 3.748-.136 4.009.717v.001Z"
          fill="#F7B7A9"
        />
        <path
          d="M77.44 20.784c.144.471 2.47 7.645 3.045 10.113-.884.793-1.951 1.738-2.899 2.05-.437-1.407-1.99-6.388-2.903-8.97-1.07-3.027-1.251-3.91-1.251-3.91 2.016-1.637 3.748-.136 4.009.717Z"
          fill="#048E95"
        />
        <path
          d="M80.058 29.284c.18.634.33 1.195.427 1.613-.884.793-1.951 1.738-2.898 2.05l-.35-1.123c.052-.012.104-.02.156-.034 1.32-.363 2.245-1.33 2.665-2.506Z"
          fill="#37878A"
        />
        <path
          opacity=".06"
          d="M76.434 19.659c-.321.328-.502.799-.374 1.372.438 1.974 1.35 3.727 2.041 5.613.694 1.895.654 3.874 1.234 5.789.498 1.642 3.728 7.667 4.557 8.89.624.921 1.013 1.826 1.378 2.807a.324.324 0 0 1-.15-.046l.051.114.05 1.57s-.223.146-.416-.202l-.218.692c-.34.045-.401-.36-.396-.69l-.153.484c-.566.074-.361-1.098-.361-1.098l-.08-.186-.164.907c-.428.19-.345-.723-.345-.723l.008-.892-.03-.58c-.339-.546-1.02-1.752-.77-2.478l-4.59-7.666s-1.955-6.334-3.024-9.36c-1.07-3.027-1.251-3.91-1.251-3.91 1.177-.956 2.256-.839 3.003-.408Z"
          fill="#010101"
        />
        <path
          d="M80.885 56.226c.047.368.02.775-.08 1.157a194.426 194.426 0 0 1-.385 3.449c-.899 7.356-1.018 10.729-1.022 11.932.529 1.371 2.571 2.964 3.32 3.54.8.615.984.892.984.892a.503.503 0 0 1-.215.461c-.191.195-1.51.503-2.34.165-.83-.338-1.65-1.234-2.829-1.476-1.21-.249-1.506-.615-1.506-.615-.307-1.254.272-3.503.272-3.503-.216-1.846-.688-6.06-.699-7.567-.011-1.673.573-5.43.678-6.386L73.47 47.672l4.43-7.851c1.888 9.535 2.621 13.585 2.985 16.405Z"
          fill="#F7B7A9"
        />
        <path
          d="M80.885 56.226c.047.367.02.774-.08 1.157a190.83 190.83 0 0 1-.386 3.448c-.773 6.328-.577 9.772-.62 11.359-.667.417-2.377 1.035-3.477-.091-.218-1.877-.68-6.013-.69-7.504-.012-1.673.128-5.448.233-6.404l-2.395-10.52 4.43-7.851c1.888 9.535 2.621 13.585 2.985 16.406Z"
          fill="#37878A"
        />
        <path
          opacity=".06"
          d="M75.335 51.48c.41.82.817 1.614 1.186 2.37 1.38 2.826.689 4.915.58 8.001a44.288 44.288 0 0 0 .957 10.875c-.601.03-1.232-.111-1.736-.628-.218-1.876-.68-6.012-.69-7.503-.013-1.673.128-5.448.233-6.404l-1.925-8.456c.44.584.912 1.163 1.394 1.745Z"
          fill="#010101"
        />
        <path
          d="M78.821 75.498c.807.445 1.487.955 2.451.907.414-.02.82-.128 1.212-.282l.234.181c.8.615.984.892.984.892a.503.503 0 0 1-.215.461c-.192.196-1.51.503-2.34.165-.83-.338-1.65-1.234-2.829-1.476-1.21-.249-1.507-.615-1.507-.615-.095-.386-.104-.868-.074-1.348.474.658 1.41.744 2.084 1.115Z"
          fill="#F6FBFA"
        />
        <path
          d="m63.338 69.415 1.735 1.142-.266 4.37c.367 1.186.691 1.581.216 1.87-.657.398-2.18-.14-2.859-1.614-.3-.65-1.036-4.367-.63-4.782.408-.416 1.804-.986 1.804-.986Z"
          fill="#F7B7A9"
        />
        <path
          d="M62.364 69.865c.023 1.301.08 2.96.623 4.159.37.814 1.067.995 1.831.938.362 1.157.676 1.55.205 1.834-.657.399-2.18-.139-2.859-1.613-.3-.65-1.036-4.367-.63-4.783.166-.169.497-.363.83-.535Z"
          fill="#F6FBFA"
        />
        <path
          d="M66.338 63.416a15.97 15.97 0 0 1 2.319-3.729l-1.174-11.013s-.38-2.594-.385-3.525c-.025-4.188 1.109-3.64 1.109-3.64l8.416 1.363-2.545 6.395s-.783 7.183-1.372 11.002c.068.532-.094 1.193-.374 1.538-2.854 3.53-7.309 8.871-7.309 8.871s-.262.673-1.302.244c-.896-.37-.606-1.295-.606-1.295s1.64-2.65 3.223-6.212v.001Z"
          fill="#F7B7A9"
        />
        <path
          d="M67.484 48.674s-.38-2.594-.385-3.525c-.026-4.188 1.108-3.64 1.108-3.64l8.972 1.797-3.1 5.961s-.506 6.936-1.096 10.755c.068.532-.371 1.44-.65 1.785-2.854 3.53-6.76 9.377-6.76 9.377s-.811.167-1.852-.262c-.895-.369-1.35-2.025-1.35-2.025s4.848-8.934 5.488-9.699l-.375-10.524Z"
          fill="#37878A"
        />
        <path
          opacity=".06"
          d="M67.484 48.674s-.38-2.594-.386-3.525c-.025-4.188 1.109-3.64 1.109-3.64l2.987.484-.008.016c-1.364 2.721-.906 14.743-1.28 17.638-.28 2.16-2.198 3.95-3.477 5.574-1.33 1.691-2.424 3.376-3.193 5.334-.572-.613-.866-1.659-.866-1.659s4.85-8.934 5.49-9.697l-.376-10.525Z"
          fill="#010101"
        />
        <path
          d="M66.336 23.473c2.142-4.05 7.013-4.273 8.965-4.117.544.044.71.158.71.158s.634.138.903 1.177c.117.454.031 1.347.189 2.025l.889 2.268.893 2.578c.535 2.108-.89 3.162-.89 3.162l-.76 4.982 1.786 7.665s-7.498 3.9-12.08.32l1.468-7.141a2.51 2.51 0 0 0 .053-.697c-.392-6.021-2.948-10.826-2.126-12.38Z"
          fill="#048E95"
        />
        <path
          opacity=".06"
          d="M68.711 27.404c.037 1.824.805 3.577 1.336 5.403.031.11.055.22.084.33-.425 3.493-.245 7.282 2.16 10.04a8.274 8.274 0 0 0 2.142 1.748c-2.398.477-5.283.493-7.493-1.234l1.469-7.141c.05-.228.068-.464.052-.697-.237-3.641-1.262-6.832-1.856-9.134.588.41 1.297.666 2.106.685Z"
          fill="#010101"
        />
        <path
          d="M74.741 19.44c1.2 1.285.93 3.339.941 5.311-.442.32-2.073-.488-3.537-1.158-.77-.353-3.279-1.86-3.308-2.811 1.973-1.251 4.319-1.485 5.808-1.456.033.038.061.076.096.114Z"
          fill="#37878A"
        />
        <path
          d="M72.357 19.128c2.187.416 2.553 1.941 2.578 2.345.02.334.122 1.25.027 2.09-.015.137-.115.206-.24.147-1.129-.53-2.25-1.232-2.928-1.505-2.196-.885-1.811-1.913-1.811-1.913s.966-1.431 2.374-1.164Z"
          fill="#F7B7A9"
        />
        <path
          d="m70.62 17.88 3.572-.39s.1 2.58-.07 3.886l-4.14-1.084s.79-1.385.639-2.412Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".06"
          d="m70.621 17.88 3.571-.39s.044 1.135.024 2.28c-.01.592-.5 1.067-1.093 1.061-.336-.002-2.377-1.203-2.545-2.107a2.5 2.5 0 0 0 .043-.844Z"
          fill="#010101"
        />
        <path
          d="M75.866 16.335c0 1.967-.822 3.863-2.715 3.358 0 0-3.24-.969-3.66-3.026l-.533-3.632 6.694-1.194.214 4.493Zm-12.742 20.08.074-1.541s.998-4.83 1.908-7.909c.52-1.758.953-2.866 1.23-3.492a1.193 1.193 0 0 1 1.267-.707c1.797.286 1.963 2.767 1.846 3.259-.135.566-3.37 9.682-3.37 9.682-.477 2.451-1.105 9.176-1.105 9.176l.867 2.568-.224 2.506s-.214.127-.439-.69l-.007-1.125-.47 1.303.01.901.023.346c.043.328-.311.363-.472.078a18.54 18.54 0 0 0-.374-.547l-.757-.646-.323-1.149.468-3.219s-.19-8.006-.153-8.794Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".06"
          d="M67.851 29.756c.833-2.066 1.851-3.816 1.208-5.861.426.823.46 1.835.39 2.13-.135.566-3.37 9.682-3.37 9.682-.477 2.451-1.105 9.176-1.105 9.176l.867 2.568-.113 1.266a6.651 6.651 0 0 0-.703-2.753c-.023-.047-.058-.085-.086-.128a12.71 12.71 0 0 1-.175-1.591c-.095-2.627.225-5.243.522-7.849.294-2.59 1.617-4.29 2.565-6.64Z"
          fill="#010101"
        />
        <path
          d="M66.372 23.014c.348-.41 1.048-1.114 1.579-1.03 1.797.286 1.615 3.55 1.499 4.04-.106.444-1.57 6.09-2.437 8.54-.06.007-2.173 1.327-4.186-.937.33-1.533 1.158-4.451 1.83-6.725.52-1.759 1.135-3.204 1.715-3.889Z"
          fill="#048E95"
        />
        <path
          opacity=".06"
          d="M66.373 23.014c.226-.267.601-.655.982-.872-2.091 3.613-3.112 8.622-1.999 12.808-.74-.026-1.644-.328-2.529-1.323.33-1.534 1.158-4.452 1.83-6.725.52-1.759 1.135-3.204 1.716-3.889Z"
          fill="#010101"
        />
        <path
          d="M63.86 33.397c1.036.547 2.334.638 3.454.264-.105.33-.207.638-.301.903-.06.007-2.173 1.327-4.186-.937.054-.25.125-.548.203-.863.24.24.507.462.83.633Z"
          fill="#37878A"
        />
        <path
          opacity=".06"
          d="M74.737 31.134s-3.33 2.43-5.298-.591c0 0 2.59 1.816 5.298.591Z"
          fill="#010101"
        />
        <path
          d="m71.017 9.8-1.91 5.376-.664 1.265s-2.42-5.163-.511-6.76c1.908-1.599 3.085.12 3.085.12Z"
          fill="#424143"
        />
        <path
          d="m71.297 9.744-1.691.685c.463-1.17 1.691-.685 1.691-.685Z"
          fill="#9B9B9B"
        />
        <path
          d="M70.27 10.068c.8-.43 2.993-.833 4.624.726.552.528 1.403 1.711.86 3.253 0 0-2.256.974-4.373.304-.368-.116-.675.22-.769.492-.161.464-.368 2.693-.368 2.693l.007.503s-1.372-1.331-1.671-2.971c-.61-3.351.89-4.57 1.69-5Z"
          fill="#424143"
        />
        <path
          d="M70.2 14.794c.585-.02.62.23.62.23l-.127 1.405s-.388.155-.793-.649c-.245-.489-.286-.967.3-.986Z"
          fill="#F7B7A9"
        />
        <path
          d="m134.469 73.147-.01 3.206c-.082.01-.161.026-.232.05l.009-3.206a1.08 1.08 0 0 1 .233-.05Z"
          fill="#C0BFBF"
        />
        <path
          d="m134.235 73.197-.009 3.207a.706.706 0 0 0-.124.056l.009-3.206a.713.713 0 0 1 .124-.057Z"
          fill="#9F9F9F"
        />
        <path
          d="m134.11 73.253-.009 3.207-.419.244.009-3.207.419-.244Z"
          fill="#ABABAB"
        />
        <path
          d="m133.692 73.497-.009 3.207c-.108.063-.173.148-.191.237l.009-3.206a.372.372 0 0 1 .191-.238Zm-.193.238-.009 3.206a7.343 7.343 0 0 0-.741-.356c-.631-.24-1.279-.42-1.939-.54l.009-3.207c.66.12 1.308.3 1.939.54.182.07.449.201.741.357Z"
          fill="#9F9F9F"
        />
        <path
          d="M136.328 73.761c.2.115.202.29-.005.411l-1.037.603a.756.756 0 0 1-.71.005.495.495 0 0 1-.061-.042l-.892-.717c-.103-.081-.143-.186-.123-.286a.372.372 0 0 1 .191-.238l.42-.244a.926.926 0 0 1 .357-.106c.189-.02.392 0 .547.065l1.241.514a.69.69 0 0 1 .072.035Z"
          fill="#044B6D"
        />
        <path
          d="m136.322 74.172-1.036.603a.647.647 0 0 1-.139.058c-.017.004-.034.01-.051.013l-.044.008a.71.71 0 0 1-.193.008.907.907 0 0 1-.093-.013.66.66 0 0 1-.069-.019l-.031-.01a.574.574 0 0 1-.151-.082l-.892-.717a.304.304 0 0 1-.128-.237l-.009 3.207c0 .084.042.168.128.237l.892.716a.529.529 0 0 0 .152.083l.031.01a.755.755 0 0 0 .068.018l.016.004c.008.002.017.002.025.003a.553.553 0 0 0 .096.008h.053a1.697 1.697 0 0 0 .097-.01.967.967 0 0 0 .044-.008l.05-.013c.009-.003.019-.004.028-.008.004 0 .007-.003.011-.004a.605.605 0 0 0 .1-.046l1.037-.602c.078-.046.126-.099.145-.153a.151.151 0 0 0 .01-.055l.009-3.207c0 .074-.051.148-.156.208Z"
          fill="#00364D"
        />
        <path
          d="m88.336 76.923-.01 3.206c-.165-.258-.426-.5-.785-.706a3.845 3.845 0 0 0-.716-.317l.01-3.206c.255.085.497.19.715.316.359.207.62.449.786.707Z"
          fill="#9F9F9F"
        />
        <path
          d="m87.18 77.607-.009 3.207c.001-.3-.197-.602-.594-.831a2.569 2.569 0 0 0-.818-.288l.009-3.206c.299.055.58.15.818.287.397.23.595.53.594.831Z"
          fill="#013349"
        />
        <path
          d="m87.18 77.607-.01 3.207c.001-.3-.197-.602-.594-.831a2.568 2.568 0 0 0-.818-.288l.009-3.206c.299.055.58.15.818.287.397.23.595.53.595.831Z"
          fill="#013349"
        />
        <path
          d="m85.767 76.489-.01 3.206a3.348 3.348 0 0 0-1.639.11l.01-3.207a3.351 3.351 0 0 1 1.64-.11h-.001Z"
          fill="#013D58"
        />
        <path
          d="m84.127 76.598-.009 3.206a2.224 2.224 0 0 0-.397.18c-.39.226-.585.523-.585.82l.009-3.206c0-.298.196-.595.585-.82.122-.072.255-.131.397-.18Zm59.342 1.655-.01 3.207a.243.243 0 0 1-.01.07.386.386 0 0 1-.187.218l.009-3.206a.386.386 0 0 0 .187-.218.284.284 0 0 0 .011-.07Z"
          fill="#013349"
        />
        <path
          d="m143.271 78.542-.009 3.206-.42.244.009-3.206.42-.244Z"
          fill="#00364D"
        />
        <path
          d="m142.85 78.786-.009 3.206a.707.707 0 0 1-.126.057l.009-3.206a.71.71 0 0 0 .127-.057h-.001Z"
          fill="#013349"
        />
        <path
          d="M142.851 78.786a.753.753 0 0 1-.229.084l-.036.008a1.28 1.28 0 0 1-.276.021c-.016 0-.031-.002-.047-.003a1.11 1.11 0 0 1-.104-.011l-.07-.013-.034-.008a.839.839 0 0 1-.106-.035l-1.242-.515a.652.652 0 0 1-.071-.035c-.098-.057-.149-.13-.148-.203l-.009 3.207c0 .073.05.145.148.202a.573.573 0 0 0 .071.035l1.241.515a.912.912 0 0 0 .141.043c.015.004.029.008.044.01l.026.003c.034.006.069.01.104.012.015 0 .031.003.047.003a1.206 1.206 0 0 0 .275-.021l.037-.009a.996.996 0 0 0 .081-.022l.021-.005v-.002a.737.737 0 0 0 .127-.055l.009-3.207Z"
          fill="#00364D"
        />
        <path
          d="M142.388 77.26a.443.443 0 0 1 .061.041l.892.718c.11.087.147.2.117.305a.388.388 0 0 1-.188.218l-.42.244a.95.95 0 0 1-.388.11 1.123 1.123 0 0 1-.514-.067l-1.241-.515a.587.587 0 0 1-.071-.035c-.197-.114-.201-.29.007-.41l1.036-.603a.758.758 0 0 1 .709-.005Z"
          fill="#044B6D"
        />
        <path
          d="m87.18 77.607-.01 3.207c0 .298-.196.595-.587.822-.122.07-.255.13-.397.179l.01-3.207a2.23 2.23 0 0 0 .396-.179c.39-.227.587-.524.588-.822Z"
          fill="#9F9F9F"
        />
        <path
          d="m86.196 78.609-.01 3.206a3.342 3.342 0 0 1-1.637.109l.009-3.206c.542.099 1.14.062 1.638-.11Z"
          fill="#C0BFBF"
        />
        <path
          d="m84.558 78.717-.01 3.207a2.568 2.568 0 0 1-.817-.288c-.398-.23-.596-.531-.595-.832l.009-3.207c0 .301.198.603.595.833.238.137.519.232.818.287Z"
          fill="#9F9F9F"
        />
        <path
          d="M86.585 76.777c.791.456.792 1.196.007 1.652-.784.456-2.06.457-2.852 0-.791-.456-.793-1.196-.01-1.652.785-.456 2.064-.457 2.855 0Z"
          fill="#EDEDEE"
        />
        <path
          d="M98.174 77.67a7.574 7.574 0 0 0-.328-.178l-.09-.046a8.379 8.379 0 0 0-.29-.139l-.057-.027a9.676 9.676 0 0 0-.35-.148l-.091-.035a9.62 9.62 0 0 0-.295-.11l-.087-.031a10.043 10.043 0 0 0-.372-.12l-.076-.023a12.083 12.083 0 0 0-.318-.09l-.103-.027a11.438 11.438 0 0 0-.794-.175c-.017-.003-.035-.008-.052-.01-.022-.005-.043-.007-.064-.011a12.15 12.15 0 0 0-.268-.045l-.108-.017a12.862 12.862 0 0 0-1.264-.126c-.102-.005-.203-.01-.305-.013l-.079-.003a13.4 13.4 0 0 0-.38-.004h-.1a17.03 17.03 0 0 0-.685.023 14.269 14.269 0 0 0-.493.035l-.025.003c-.118.01-.235.023-.351.037l-.117.015a14.472 14.472 0 0 0-.675.105l-.083.014c-.122.023-.243.048-.363.074l-.088.02-.273.066-.117.03-.25.07-.107.03c-.116.035-.23.07-.344.108l-.009 3.207c.114-.038.228-.074.344-.109l.107-.03a10.416 10.416 0 0 1 .64-.165l.088-.02a12.164 12.164 0 0 1 1.12-.194l.117-.015c.117-.014.234-.027.351-.038.009 0 .017-.002.026-.003a13.485 13.485 0 0 1 1.178-.056l.099-.001c.127 0 .253.002.38.005l.079.002.304.013.125.008a14.857 14.857 0 0 1 .722.064l.044.004c.125.015.25.032.373.05l.109.017a11.85 11.85 0 0 1 .786.147c.131.029.262.06.391.094.035.008.07.018.104.027.106.028.212.058.317.09l.076.022c.126.038.25.079.372.12l.087.031c.1.036.198.072.295.11l.09.035c.119.048.236.097.351.15l.058.026a8.291 8.291 0 0 1 .707.363c.901.52 1.549 1.133 1.942 1.786a3.205 3.205 0 0 1 .421 1.116c.024.152.036.304.036.456l.009-3.207c.004-1.215-.797-2.432-2.399-3.357h.002Z"
          fill="#C0BFBF"
        />
        <path
          d="M87.561 78.99a3.426 3.426 0 0 1-.278.143c-.077.036-.156.07-.237.102l-.043.015a4.635 4.635 0 0 1-.672.192l-.14.029a5.106 5.106 0 0 1-.192.03l-.138.02c-.068.008-.137.013-.206.02-.043.003-.087.008-.13.01a5.838 5.838 0 0 1-.234.008c-.035.001-.07.003-.106.003-.113 0-.227-.002-.34-.008l-.04-.004a5.703 5.703 0 0 1-.296-.025l-.115-.017a5.354 5.354 0 0 1-.474-.084l-.052-.012a4.995 4.995 0 0 1-.27-.073h-.002a4.412 4.412 0 0 1-.258-.089l-.047-.017a3.773 3.773 0 0 1-.238-.101l-.044-.022a3.325 3.325 0 0 1-.232-.121c-.668-.386-1-.891-1-1.397L81.77 80.8c-.002.505.331 1.01.999 1.396.074.044.152.083.232.122l.044.021a3.813 3.813 0 0 0 .543.206l.002.001c.088.027.179.05.27.073l.052.012c.075.017.15.034.228.047l.029.005c.072.013.144.022.217.032l.115.017c.098.01.197.019.296.025l.041.004c.113.006.226.009.34.009l.105-.003c.078-.002.156-.003.234-.008l.13-.011c.069-.006.138-.012.206-.02l.138-.02c.065-.009.129-.018.193-.03l.14-.029a5.277 5.277 0 0 0 .32-.078c.058-.016.116-.034.174-.053.023-.007.048-.013.07-.021l.107-.04.043-.015c.081-.032.16-.066.237-.102l.049-.023c.078-.038.156-.078.23-.12.655-.382.983-.88.984-1.379l.01-3.206c-.002.498-.33.997-.986 1.378Z"
          fill="#013349"
        />
        <path
          d="M88.335 76.923c.446.695.189 1.507-.773 2.066-1.316.765-3.46.766-4.784 0-1.326-.764-1.334-2.007-.018-2.772 1.101-.64 2.778-.745 4.074-.317.256.085.497.19.715.316.359.207.62.449.786.707Zm-4.594 1.507c.791.457 2.068.455 2.852 0 .785-.457.784-1.196-.007-1.653-.791-.457-2.07-.456-2.855 0-.783.456-.781 1.197.01 1.653Z"
          fill="#044B6D"
        />
        <path
          d="m115.494 80.27-.009 3.207-1.214-.414.01-3.206 1.213.414Z"
          fill="#ADADAD"
        />
        <path
          d="M132.758 73.378a11.054 11.054 0 0 0-1.939-.54c-.084-.015-.168-.027-.251-.04-.069-.012-.137-.024-.206-.034-.097-.013-.195-.023-.292-.034-.064-.008-.127-.017-.191-.023-.11-.01-.219-.017-.33-.024-.052-.004-.105-.009-.158-.012a11.957 11.957 0 0 0-.491-.015 18.7 18.7 0 0 0-.344.01c-.032 0-.062.002-.093.003a19.05 19.05 0 0 0-.272.014l-.066.003-.318.023-.075.007a14.659 14.659 0 0 0-.658.075 9.412 9.412 0 0 0-.259.04l-.08.013c-.081.014-.162.028-.241.044l-.042.007-.272.058-.069.017a11.209 11.209 0 0 0-.534.14l-.046.015a9.092 9.092 0 0 0-.212.067l-.07.023-.056.019c-.022.007-.044.016-.065.024a9.163 9.163 0 0 0-.593.233l-.06.025a9.723 9.723 0 0 0-.312.144l-.083.042a8.51 8.51 0 0 0-.229.117l-.102.054c-.076.04-.151.083-.226.125l-.085.048c-.102.06-.204.12-.306.183l-.05.031-.26.166-.1.066-.222.15a16.341 16.341 0 0 0-.377.264l-.038.027a20.305 20.305 0 0 0-.66.491l-.11.085-.259.201-.085.066-.35.277a73.184 73.184 0 0 0-.371.297l-.126.102-.275.222-.119.097-.379.307c-.702.57-1.495 1.214-2.382 1.908-.409.323-1.097.94-1.476 1.283l-.009 3.207c.379-.344 1.066-.96 1.476-1.283.887-.694 1.68-1.339 2.381-1.908l.379-.308.12-.097.274-.222c.042-.034.084-.068.126-.1a36.634 36.634 0 0 1 .371-.298l.35-.278.084-.065c.088-.068.174-.136.26-.201l.11-.085c.081-.061.161-.123.241-.182.032-.025.064-.05.096-.073.109-.08.216-.16.323-.237l.036-.026.281-.198.098-.067.222-.15.1-.066a12.6 12.6 0 0 1 .261-.166l.049-.031a13.716 13.716 0 0 1 .617-.357l.102-.054c.076-.04.153-.08.23-.118l.083-.04c.103-.05.207-.099.311-.145l.06-.025.258-.108.104-.04a6.39 6.39 0 0 1 .231-.085c.041-.014.081-.03.122-.043l.07-.023a12.091 12.091 0 0 1 .515-.154 11.209 11.209 0 0 1 .276-.069l.069-.016c.089-.02.18-.04.271-.058l.043-.008.241-.044.08-.013.259-.04.033-.004c.098-.014.198-.026.298-.037l.081-.009c.082-.009.164-.017.247-.024l.074-.007c.104-.009.21-.016.318-.023l.067-.003c.089-.006.179-.01.271-.014l.093-.003c.113-.004.228-.008.345-.01.164.001.327.006.49.015.054.002.108.008.162.012.109.007.217.013.325.024.065.006.129.015.194.022.097.011.193.021.29.035.069.01.137.022.206.033a11.14 11.14 0 0 1 2.19.58c.182.07.448.2.741.357l.009-3.207a7.476 7.476 0 0 0-.741-.356l.001.002Z"
          fill="#9F9F9F"
        />
        <path
          d="M134.468 73.147a.926.926 0 0 0-.358.106l-.42.244a.37.37 0 0 0-.19.238 7.476 7.476 0 0 0-.741-.357 11.12 11.12 0 0 0-3.858-.722c-4.195.075-5.877 1.44-9.55 4.424-.701.57-1.494 1.214-2.381 1.908-.41.322-1.097.939-1.475 1.283l-1.214-.414c.381-.347 1.11-1 1.559-1.354a146.9 146.9 0 0 0 2.367-1.897c3.714-3.016 5.759-4.679 10.667-4.763 1.632.011 3.188.3 4.653.856.252.096.591.261.941.448Z"
          fill="#EDEDEE"
        />
        <path
          d="m145.737 82.376-.009 3.207c-.024-.77-.446-1.519-1.256-2.23-.239-.21-.898-.609-1.47-.939a41.387 41.387 0 0 0-.549-.311l.009-3.207c.158.088.348.196.549.312.572.33 1.231.729 1.47.938.81.712 1.232 1.461 1.256 2.23Z"
          fill="#9F9F9F"
        />
        <path
          d="m116.057 80.558-.009 3.206a.115.115 0 0 1-.038.083c-.407.404-2.387 2.376-2.945 3.095-.497.64-.751 1.236-.753 1.808l.01-3.206c.001-.573.254-1.169.752-1.808.558-.719 2.538-2.692 2.945-3.096a.115.115 0 0 0 .038-.082Zm-3.646 9.015-.009 3.206c-2.051-1.287-3.071-2.624-3.067-4.039l.009-3.206c-.004 1.415 1.016 2.75 3.067 4.039Z"
          fill="#A03024"
        />
        <path
          d="M144.016 78.641c.589.34 1.324.785 1.635 1.058.961.846 1.465 1.746 1.491 2.675-.13 2.86-2.992 4.05-8.187 6.212-.974.405-2.081.866-3.269 1.375-.597.258-1.696.673-2.3.897l-.719-.7a60.051 60.051 0 0 0 2.178-.849c1.195-.516 2.307-.977 3.287-1.385 5.14-2.138 7.49-3.116 7.604-5.547-.024-.769-.446-1.518-1.256-2.23-.239-.21-.898-.608-1.47-.938a49.55 49.55 0 0 0-.548-.312.954.954 0 0 0 .388-.11l.42-.244a.388.388 0 0 0 .188-.218c.148.082.344.193.559.317h-.001Z"
          fill="#EDEDEE"
        />
        <path
          d="M138.956 88.586c-.975.404-2.081.865-3.269 1.375-.598.258-1.696.672-2.301.896l-.009 3.207a60.691 60.691 0 0 0 2.3-.897c1.188-.51 2.295-.97 3.269-1.375 5.195-2.161 8.057-3.353 8.187-6.212l.009-3.206c-.129 2.859-2.992 4.05-8.186 6.212Z"
          fill="#9F9F9F"
        />
        <path
          d="m133.386 90.857-.009 3.207-.719-.701.009-3.207.719.701Z"
          fill="#919191"
        />
        <path
          d="m112.843 90.949-.009 3.206c-.364-.21-.549-.541-.548-.893l.009-3.206c-.001.352.183.683.548.893Z"
          fill="#A03024"
        />
        <path
          d="m112.967 91.02-.009 3.207-.125-.072.009-3.206.125.072Z"
          fill="#A13023"
        />
        <path
          d="m119.432 91.047-.009 3.206c0 .03-.004.059-.01.088l.009-3.206a.376.376 0 0 0 .01-.088Z"
          fill="#A03024"
        />
        <path
          d="m114.588 91.956-.009 3.207-1.621-.936.009-3.206 1.621.935Z"
          fill="#A13023"
        />
        <path
          d="m114.714 92.029-.009 3.206-.125-.072.009-3.207.125.073Zm2.417.238-.009 3.206a5 5 0 0 1-1.684.008l.009-3.206a5 5 0 0 0 1.684-.008Zm-1.685.008-.009 3.206a2.327 2.327 0 0 1-.732-.246l.009-3.206c.194.112.447.194.732.246Z"
          fill="#BF3A2B"
        />
        <path
          d="m99.833 85.274-3.078 1.789-.21.121-1.007.586-3.287 1.91c-1.572.914-2.358 2.111-2.362 3.31l-.01 3.207c.004-1.2.79-2.397 2.363-3.31l3.287-1.91 1.007-.586c.07-.041.142-.081.21-.122l3.078-1.789c2.012-1.17 3.019-2.703 3.024-4.24l.009-3.206c-.005 1.536-1.012 3.07-3.024 4.24Z"
          fill="#9F9F9F"
        />
        <path
          d="M115.974 80.44c.088.051.112.134.045.2-.406.404-2.386 2.377-2.945 3.096-1.299 1.672-.933 3.042 1.238 4.487.373-.038.748.02 1.05.194l3.714 2.144c.287.165.39.369.347.573 2.355 1.078 4.619 1.225 7.346.508.792-.207 2.702-.822 5.241-1.686l.098-.033a.455.455 0 0 1 .34.028l.22.205.719.701.336.329c.039.038.051.083.031.126-.019.043-.066.079-.132.1-1.301.444-4.33 1.464-5.617 1.801-3.929 1.032-7.498.72-10.875-.946-.89.153-1.879.072-2.416-.239l-.125-.072-1.621-.935-.125-.072c-.529-.306-.678-.866-.431-1.376-3.225-2.024-3.9-4.17-2.057-6.55.687-.884 3.071-3.236 3.094-3.26.08-.077.254-.103.391-.056l.442.15 1.213.414.422.144a.34.34 0 0 1 .057.025Z"
          fill="#ED4736"
        />
        <path
          d="m133.762 91.27-.009 3.207a.104.104 0 0 1-.009.042c-.019.042-.066.079-.132.1-1.301.444-4.33 1.464-5.617 1.801-3.929 1.032-7.498.72-10.875-.947l.009-3.206c3.378 1.666 6.946 1.978 10.875.947 1.287-.337 4.316-1.358 5.617-1.8.066-.023.113-.059.132-.102a.104.104 0 0 0 .009-.041Z"
          fill="#A03024"
        />
        <mask
          id="r"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="117"
          y="91"
          width="17"
          height="7"
        >
          <path
            d="m133.762 91.27-.009 3.207a.104.104 0 0 1-.009.042c-.019.042-.066.079-.132.1-1.301.444-4.33 1.464-5.617 1.801-3.929 1.032-7.498.72-10.875-.947l.009-3.206c3.378 1.666 6.946 1.978 10.875.947 1.287-.337 4.316-1.358 5.617-1.8.066-.023.113-.059.132-.102a.104.104 0 0 0 .009-.041Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#r)" fill="#A03024">
          <path d="m133.763 91.27-.009 3.207a.09.09 0 0 1-.01.042c-.018.042-.065.078-.13.1l.009-3.206c.065-.022.112-.058.13-.1a.09.09 0 0 0 .01-.042Zm-.14.142-.009 3.207h-.001c-1.302.443-4.331 1.463-5.618 1.8-2.448.643-4.756.764-6.966.361l.009-3.206c2.209.403 4.518.281 6.966-.361 1.287-.337 4.316-1.358 5.617-1.8l.002-.001Z" />
          <path d="m121.039 93.575-.009 3.206a14.786 14.786 0 0 1-3.91-1.308l.009-3.206a14.794 14.794 0 0 0 3.91 1.308Z" />
        </g>
        <path
          d="M105.421 97.284a11.42 11.42 0 0 1-.346.191l-.073.038c-.114.06-.23.118-.348.174l-.064.03c-.11.051-.223.102-.337.151l-.048.021a9.416 9.416 0 0 1-.374.151l-.082.032a11.736 11.736 0 0 1-.851.29l-.101.029a13.61 13.61 0 0 1-.379.107c-.058.016-.118.03-.177.045-.104.026-.208.052-.312.076-.067.016-.135.03-.202.044-.099.022-.197.043-.296.063l-.214.04a13.072 13.072 0 0 1-.513.085 16.578 16.578 0 0 1-.808.103l-.226.022c-.1.01-.199.017-.298.024l-.223.015-.307.015-.217.01-.324.006-.2.002c-.124 0-.248-.001-.372-.004l-.152-.001a17.544 17.544 0 0 1-.523-.022c-.032-.001-.064-.005-.096-.007a16.597 16.597 0 0 1-.425-.03l-.186-.018-.333-.034-.208-.026-.306-.041a18.817 18.817 0 0 1-.51-.083c-1.577-.28-3.063-.778-4.311-1.499-2.053-1.185-3.078-2.743-3.073-4.3l-.01 3.207c-.004 1.556 1.021 3.115 3.074 4.3 1.224.707 2.679 1.2 4.223 1.482v.002l.087.015.294.048.216.034c.102.015.205.028.307.041l.208.026c.11.013.222.024.333.034l.185.019c.142.012.284.021.426.03l.096.007a18.215 18.215 0 0 0 1.047.027c.067 0 .134-.002.2-.003.108-.001.216-.002.324-.006l.216-.009c.103-.004.205-.009.308-.015l.223-.015.297-.024a16.808 16.808 0 0 0 .519-.055l.225-.028.291-.042.221-.034.291-.052c.072-.013.143-.025.214-.04.1-.019.198-.04.297-.062.067-.014.134-.028.201-.044.105-.024.209-.05.313-.077l.177-.044c.128-.034.254-.071.381-.108l.099-.029a14.25 14.25 0 0 0 .851-.29l.082-.031c.126-.049.251-.099.374-.151l.048-.022c.114-.049.227-.099.338-.151l.063-.03a10.308 10.308 0 0 0 .767-.403l9.168-5.328.009-3.206-9.167 5.327h-.001Z"
          fill="#9F9F9F"
        />
        <path
          d="m94.901 98.768-.01 3.206c-1.544-.282-2.998-.777-4.222-1.484-2.053-1.185-3.078-2.744-3.073-4.3l.009-3.206c-.005 1.556 1.02 3.115 3.073 4.3 1.225.707 2.678 1.201 4.223 1.484Z"
          fill="#9F9F9F"
        />
        <path
          d="M99.785 76.734c4.077 2.355 4.099 6.186.048 8.54l-3.078 1.788c-.068.041-.139.081-.21.122l-1.007.586-3.287 1.91c-3.163 1.838-3.147 4.83.038 6.668 3.184 1.838 8.348 1.838 11.512 0l9.167-5.328 1.621.936-9.167 5.327c-4.052 2.355-10.666 2.355-14.744 0-4.078-2.354-4.1-6.185-.048-8.54l3.075-1.786c.07-.042.141-.082.212-.123l1.008-.586 3.287-1.91c3.163-1.839 3.146-4.83-.038-6.668-2.67-1.542-6.732-1.791-9.84-.748-.165-.257-.427-.5-.785-.706a3.852 3.852 0 0 0-.716-.316c4.02-1.477 9.43-1.2 12.951.833v.001Z"
          fill="#EDEDEE"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m99.043 156.656 1.68 3.541 12.88-5.961-2.286-4.666-12.274 7.086Z"
          fill="url(#s)"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m112.339 158.555 5.215 2.737 12.881-5.961-5.822-3.862-12.274 7.086Z"
          fill="url(#t)"
        />
        <path
          d="M117.759 160.051c-.707-.544-2.634-2.047-3.134-3.341.005-1.136.117-4.318.965-11.259.112-.917.268-2.309.364-3.254a2.9 2.9 0 0 0 .075-1.091c-.343-2.662-1.035-6.483-2.816-15.48l-4.181 7.409 3.391 10.005c-.1.901-.651 4.446-.64 6.024.01 1.423.456 5.398.66 7.141 0 0-.547 2.121-.257 3.305 0 0 .279.345 1.422.58 1.112.229 1.886 1.074 2.669 1.393.783.319 2.027.029 2.208-.156 0 0 .232-.144.203-.435 0 0-.174-.261-.929-.841Z"
          fill="#926750"
        />
        <path
          d="m113.214 125.625-4.181 7.409 2.26 9.926c-.099.901-.231 4.464-.22 6.043.009 1.406.446 5.309.652 7.079 1.037 1.064 2.651.48 3.28.087.04-1.498-.144-4.747.586-10.718.112-.917.268-2.309.363-3.255.095-.36.12-.744.076-1.091-.344-2.662-1.035-6.482-2.816-15.48Z"
          fill="#008D88"
        />
        <path
          opacity=".06"
          d="M109.44 132.513c-.026-.024-.046-.05-.071-.074l-.336.595 2.26 9.926c-.099.901-.231 4.464-.22 6.042.009 1.407.445 5.31.652 7.08.819.841 1.993.651 2.762.34-1.643-3.705-1.79-7.855-1.917-11.909-.129-4.102.101-8.949-3.13-12.001v.001Z"
          fill="#010101"
        />
        <path
          d="m117.759 160.051-.221-.172c-.37.146-.753.248-1.143.267-.911.044-1.552-.436-2.313-.856-.636-.351-1.52-.432-1.967-1.053-.029.454-.019.908.07 1.272 0 0 .279.346 1.422.581 1.112.228 1.886 1.073 2.669 1.393.783.319 2.027.028 2.208-.156 0 0 .232-.145.203-.435 0 0-.174-.261-.929-.842l.001.001Z"
          fill="#008D88"
        />
        <path
          d="m101.11 154.628-1.637-1.078s-1.318.538-1.702.93c-.384.392.311 3.9.594 4.513.641 1.391 2.078 1.898 2.698 1.522.448-.272.142-.645-.205-1.764l.252-4.123Z"
          fill="#926750"
        />
        <path
          d="M99.142 157.899c-.513-1.131-.566-2.697-.59-3.924-.313.162-.624.345-.78.505-.385.392.31 3.9.593 4.513.641 1.391 2.077 1.898 2.698 1.522.444-.269.148-.639-.194-1.731-.721.054-1.38-.117-1.728-.885Z"
          fill="#008D88"
        />
        <path
          d="M103.021 130.653c.005.879.363 3.327.363 3.327l1.107 10.391a15.106 15.106 0 0 0-2.188 3.518 54.19 54.19 0 0 1-3.041 5.861s-.274.874.572 1.222c.981.404 1.229-.23 1.229-.23s4.204-5.039 6.896-8.371c.264-.326.417-.949.353-1.451.556-3.603 1.294-10.381 1.294-10.381l2.402-6.034-7.941-1.286s-1.07-.518-1.046 3.434Z"
          fill="#F7B7A9"
        />
        <path
          d="M103.02 130.653c.005.879.363 3.327.363 3.327l.355 9.93c-.605.721-5.18 9.151-5.18 9.151s.43 1.563 1.275 1.912c.981.404 1.746.246 1.746.246s3.687-5.516 6.38-8.848c.263-.326.678-1.182.613-1.684.556-3.603 1.033-10.148 1.033-10.148l3.257-5.882-8.796-1.438s-1.07-.518-1.047 3.434h.001Z"
          fill="#008D88"
        />
        <path
          opacity=".06"
          d="M103.02 130.653c.006.879.364 3.326.364 3.326l.355 9.931c-.605.721-5.18 9.151-5.18 9.151s.35 1.258 1.035 1.765c.429-1.548 1.109-2.965 2.097-4.388 1.125-1.622 2.468-3.008 2.948-4.971 1.166-4.771-.373-9.842 1.223-14.541.501-1.476 1.439-2.45 2.548-3.004l-4.344-.704s-1.069-.517-1.046 3.434v.001Z"
          fill="#010101"
        />
        <path
          d="M114.684 107.309c-.277-.794-1.967-2.144-3.806-.525 0 0 .205.825 1.326 3.639 1.121 2.813 3.202 8.712 3.202 8.712s.429.795 2.516 1.795c1.18.565 4.609 2.248 5.089 2.479.144-.494.353-.964.63-1.393l-5.98-4.02c-.415-1.508-2.811-10.213-2.977-10.687Z"
          fill="#926750"
        />
        <path
          opacity=".06"
          d="M117.151 118.7c-1.475-1.72-1.94-4.065-.955-6.013-.713-2.573-1.424-5.127-1.512-5.377-.277-.795-1.967-2.145-3.806-.526 0 0 .205.826 1.326 3.639 1.121 2.814 3.202 8.712 3.202 8.712s.429.795 2.516 1.795c1.18.566 4.609 2.249 5.089 2.479a5.41 5.41 0 0 1 .329-.839 29.167 29.167 0 0 1-.971-.456c-1.854-.917-3.845-1.812-5.218-3.413v-.001Z"
          fill="#010101"
        />
        <path
          d="M110.878 106.784s.205.826 1.326 3.639c.957 2.401 1.555 6.527 2.02 7.838 2.043.086 2.906-.75 3.71-1.531-.634-2.305-3.096-8.982-3.25-9.42-.277-.795-1.967-2.145-3.806-.526Z"
          fill="#359996"
        />
        <path
          opacity=".06"
          d="M116.386 114.107c-1.198-1.895-2.639-3.736-3.1-5.98a6.115 6.115 0 0 1-.076-2.028c-.663-.174-1.481-.066-2.333.685 0 0 .205.826 1.326 3.639.957 2.402 1.555 6.528 2.02 7.838 2.043.086 2.906-.75 3.71-1.53a24.33 24.33 0 0 0-.212-.715 24.631 24.631 0 0 1-1.335-1.909Z"
          fill="#010101"
        />
        <path
          d="M117.541 115.909c-.909.989-2.249 1.43-3.555 1.508.084.34.163.631.238.843 2.043.087 2.906-.749 3.71-1.53a27.692 27.692 0 0 0-.285-.948c-.036.042-.07.086-.108.127Z"
          fill="#83B7B4"
        />
        <path
          d="m114.555 111.639-.615-2.216c-.082-.651.085-1.481.019-1.918-.152-1.002-.733-1.193-.733-1.193s-.145-.123-.651-.217c-1.817-.335-6.411-.597-8.813 2.997-.922 1.379 1.012 6.137.798 11.826-.008.221-.048.44-.117.649l-2.069 6.56c3.955 3.804 11.625.832 11.625.832l-1.191-7.33 1.196-4.602s1.44-.852 1.142-2.882l-.589-2.507-.002.001Z"
          fill="#359996"
        />
        <path
          opacity=".06"
          d="M112.033 125.904c-3.374-.849-5.697-3.364-6.198-6.789-.212-1.45-.29-2.909-.442-4.366-.071-.688-.25-1.393-.284-2.086-.99-.947-1.351-2.349-1.234-3.722-.037.052-.078.097-.114.152-.922 1.379 1.012 6.136.798 11.826a2.38 2.38 0 0 1-.116.648l-2.07 6.561c3.955 3.803 11.625.831 11.625.831l-.466-2.867a6.076 6.076 0 0 1-1.5-.188h.001Z"
          fill="#010101"
        />
        <path
          d="M111.961 106.005c-1.395-.171-3.62-.179-5.592.805-.065.894 2.144 2.552 2.832 2.958 1.31.771 2.763 1.688 3.209 1.43.18-1.853.632-3.755-.369-5.077-.03-.038-.052-.077-.08-.116Z"
          fill="#83B7B4"
        />
        <path
          d="M109.833 105.598c-1.296-.388-2.341.863-2.341.863s-.461.928 1.515 1.971c.61.322 1.594 1.09 2.603 1.695.111.067.212.013.239-.114.171-.779.164-1.649.177-1.965.016-.381-.18-1.848-2.193-2.45Z"
          fill="#926750"
        />
        <path
          d="m107.491 106.461 3.781 1.418c.286-1.21.442-3.641.442-3.641l-3.39.021c.043.978-.833 2.202-.833 2.202Z"
          fill="#926750"
        />
        <path
          opacity=".06"
          d="M108.202 105.046c.071.864 1.87 2.189 2.185 2.224a1.022 1.022 0 0 0 1.128-.891c.13-1.072.199-2.141.199-2.141l-3.39.02a2.35 2.35 0 0 1-.122.788Z"
          fill="#010101"
        />
        <path
          d="M107.38 103.011c.196 1.971 3.143 3.193 3.143 3.193 1.728.658 2.683-1.043 2.873-2.889l.234-4.238-6.399.473.149 3.461Z"
          fill="#926750"
        />
        <path
          opacity=".06"
          d="M105.989 116.03c1.556 3.025 4.916 1.067 4.916 1.067-2.66.887-4.916-1.067-4.916-1.067Z"
          fill="#010101"
        />
        <path
          d="M106.592 96.302c-2.307 2.917-1.031 8.606-1.031 8.606l1.603-3.335 2.313-4.86s-1.428-2.254-2.885-.411Z"
          fill="#424143"
        />
        <path
          d="m107.178 98.183 2.567-1.496s-2.308-.274-2.567 1.496Z"
          fill="#83B7B4"
        />
        <path
          d="M108.751 96.892c-.792.326-2.32 1.325-2.071 4.529.122 1.568 1.281 2.95 1.281 2.95l.042-.472s.41-2.072.606-2.493c.115-.246.436-.532.77-.387 1.921.834 4.134.137 4.134.137.659-1.394-.026-2.587-.493-3.136-1.38-1.62-3.478-1.455-4.27-1.129h.001Z"
          fill="#424143"
        />
        <path
          d="M108.227 101.321c-.552-.039-.56.414-.377.897.302.794.682.685.682.685l.255-1.305s-.008-.239-.56-.277Z"
          fill="#926750"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m126.172 156.977.705 4.998 8.665-4.192-.285-5.681-9.085 4.875Z"
          fill="url(#u)"
        />
        <path
          style={{ mixBlendMode: 'multiply' }}
          opacity=".5"
          d="m131.467 159.74 3.027 5.535 8.665-4.192-2.607-6.219-9.085 4.876Z"
          fill="url(#v)"
        />
        <path
          d="M127.37 116.86c-1.161-.071.543-5.496.543-5.496s-2.034-.081-3.264 1.89c-.98 1.571-2.671 10.218-2.671 10.218l-5.948 3.932a1.72 1.72 0 0 0-1.15.186c-.832.438-2.629.657-2.629.657s-.087.457.439.513h.744s-1.446.92-2.278 1.152c-.213.059-.082.679.526.635 0 0 .698.559 1.928.407 1.511-.188 2.979-1.274 2.979-1.274s.183-.25.497-.599c-.004.034-.009.056-.009.056l6.346-2.417a2.926 2.926 0 0 0 2.069-3.006l.289-3.068 2.612-3.838a5.033 5.033 0 0 1-1.023.052Zm-10.998 10.652s-.07-.035-.184-.069c.105.004.19.025.261.06l-.077.009Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".06"
          d="M127.37 116.86c-1.161-.071.542-5.496.542-5.496s-2.033-.081-3.263 1.89c-.29.465-.642 1.55-.994 2.846 1.563 1.168 1.807 3.206 1.011 4.941-2.372 5.173-7.71 7.564-12.917 9.112a4.277 4.277 0 0 1-.626.133c.087.149.266.282.559.261 0 0 .698.56 1.928.407 1.511-.188 2.979-1.274 2.979-1.274s.183-.249.496-.598a1.04 1.04 0 0 1-.008.055l6.346-2.417a2.927 2.927 0 0 0 2.069-3.006l.288-3.068 2.613-3.838a4.965 4.965 0 0 1-1.023.052Z"
          fill="#010101"
        />
        <path
          d="M127.37 116.86c-1.161-.071.543-5.496.543-5.496s-2.034-.081-3.264 1.89c-.457.733-1.069 3.007-1.591 5.224a13.4 13.4 0 0 1 3.298 1.323l2.037-2.993a4.965 4.965 0 0 1-1.023.052Z"
          fill="#E5E5E5"
        />
        <path
          opacity=".06"
          d="M127.37 116.86c-.72-.044-.338-2.147.056-3.739-.282.162-.557.332-.834.501l-.031.038c-.387.437-.841.826-1.234 1.263l-.028.031-.008.013c-.17.279-.372.541-.545.819a20.145 20.145 0 0 0-.93 1.693 4.184 4.184 0 0 1-.711 1.013c1.132.293 2.219.725 3.251 1.308l2.037-2.992a4.965 4.965 0 0 1-1.023.052Z"
          fill="#010101"
        />
        <path
          d="M125.818 121.178c-.151-.089-.3-.18-.454-.264-.093-.05-.724-.356-1.001-.497-.275-.093-.979-.355-1.087-.388-.179-.054-.36-.099-.541-.147-.176-.004-.406 1.197-.703 2.706-.11.558-.347 1.078-.821 1.392l-4.845 3.201a4.136 4.136 0 0 0-.066-.03c-.582-.13-2.827.863-2.827.863l-.324.863 1.749 1.813c2.007-.734 2.18-1.554 2.18-1.554l6.748-2.245c1.1-.333 2.326-2.422 2.244-3.568l-.251-2.147-.001.002Z"
          fill="#fff"
        />
        <path
          opacity=".06"
          d="M125.902 121.892a4.328 4.328 0 0 1-.104.371c-.775 2.341-2.666 3.691-4.831 4.668-2.316 1.045-4.722 2.013-7.202 2.585l1.132 1.175c2.007-.734 2.18-1.554 2.18-1.554l6.749-2.245c1.099-.333 2.325-2.422 2.244-3.568l-.168-1.432Z"
          fill="#010101"
        />
        <path
          d="M128.903 164.836c-.496.502-1.596 1.225-1.722 1.919l-.019.104c.744 1.56 2.799.993 2.799.993l4.572-2.545c.377-.211.611-.61.611-1.043v-1.497l-3.628-.545-2.613 2.614Zm-6.887-3.396c-2.467 1.307-1.611 2.363-.599 2.703 1.153.388 3.78-1.396 3.78-1.396l2.449-.836c.377-.211.61-.61.61-1.042v-1.498l-3.627-.545-2.613 2.614Z"
          fill="#424143"
        />
        <path
          d="M127.179 131.15c-1.12-.552-.683.387-1.857-.286 0 0-.568 5.54-.633 6.963-.259 5.65-.546 21.068-.546 21.068s.744 2.092 4.429.958l1.239-19.896.889 22.347s1.007 2.591 4.94.499l.387-15.364 1.334-15.589c-.072.002-7.164.783-10.182-.701v.001Z"
          fill="#676868"
        />
        <path
          opacity=".06"
          d="M129.933 139.955c0 1.206.01 2.413.022 3.621l.744 18.728s.981 2.496 4.756.588c-.038-.213.012-.451-.082-.661-2.993-6.676-5.017-21.527-5.44-22.276Zm-4.611-9.091s-.567 5.54-.633 6.963c-.259 5.65-.546 21.068-.546 21.068s.553 1.532 3.031 1.256c-.85-4.103-.887-8.429-1.038-12.571-.218-6.022-.54-12.569 4.67-15.616-1.379-.116-2.696-.357-3.627-.815-1.12-.551-.683.388-1.857-.285Z"
          fill="#010101"
        />
        <path
          d="m136.179 112.494-3.241-2.116-2.008-.351h-1.718a1.236 1.236 0 0 1-.479.646c-.831.59-1.986 1.121-2.95 1.428-.687 3.6-.244 6.857-.124 10.558.096 2.947-.032 5.885-.441 8.795.845.644 2.467 1.485 5.436 1.886 5.404.728 5.691-1.724 5.691-1.724l2.083-15.224c.093-1.764-.699-3.052-2.249-3.898Z"
          fill="#E5E5E5"
        />
        <path
          d="M138.97 117.143s-.178-4.231-2.723-4.099c-2.335.122-1.728 4.931-1.728 4.931l1.594 7.622.04 9.118-.844 2.519.131 3.002s.637.061.636-.848l-.039-1.038.019.08.001.049.001.01.012-.001.288 1.21-.071 1.123-.07.36c-.067.343.391.549.586.258l.557-.835.88-.643.423-1.191-.273-2.456-.021-.897 1.044-9.62-.443-8.654Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".06"
          d="M136.247 113.044c-2.335.122-1.728 4.931-1.728 4.931l1.594 7.622.04 9.118-.844 2.519.131 3.002s.637.061.636-.848l-.039-1.038.019.08.001.049.001.01.012-.001.288 1.21-.071 1.123-.07.36c-.038.197.096.344.255.383.584-1.63.599-2.046.204-3.99-.306-1.511.366-4.004.082-9.933-.078-1.635-.41-2.925.017-4.52.378-1.415 1.3-2.221 2.372-2.536l-.176-3.442s-.179-4.231-2.724-4.099Zm-10.588 9.615c.096 2.947-.032 5.885-.441 8.795.615.469 1.651 1.041 3.311 1.473-.888-2.316-2.686-11.233-3.011-13.222.052.962.108 1.941.141 2.954Z"
          fill="#010101"
        />
        <path
          d="M136.247 113.045c-2.335.121-1.728 4.93-1.728 4.93l.321 2.292c1.451.141 3.273.022 4.562-.251l-.431-2.872s-.179-4.232-2.724-4.099Z"
          fill="#E5E5E5"
        />
        <path
          opacity=".06"
          d="M135.158 113.631c-1.018 1.306-.638 4.344-.638 4.344l.32 2.291c.431.042.868.057 1.305.058-.987-2.094-1.458-4.494-.987-6.693Z"
          fill="#010101"
        />
        <path
          d="M128.627 107.097v3.525c0 1.191.965 2.157 2.155 2.157 1.191 0 2.18-1.191 2.18-2.381l-1.424-2.936-2.911-.365Z"
          fill="#F7B7A9"
        />
        <path
          opacity=".06"
          d="M131.305 107.997a4.7 4.7 0 0 1-.452-.621l-2.226-.279v3.525c0 .378.105.728.276 1.036 1.102 1.07 2.765-1.132 2.85-2.858-.071-.233-.056-.12-.153-.335.042.152-.658-.889-.296-.468h.001Z"
          fill="#010101"
        />
        <path
          d="m131.576 103.956-6.304.76 1.351 4.422c.537 1.756 1.747 2.497 3.317 1.744.963-.462 2.612-2.751 2.264-3.625l-.628-3.301Z"
          fill="#F7B7A9"
        />
        <path
          d="M131.659 102.083c-1.954-1.349-4.264-1.587-6.178.625-2.089 2.414.005 2.708.005 2.708s4.23-1.18 4.482-.483c.074.204.238 1.519.238 1.519l.606.21.168-.69 1.184 2.742s.661-1.199.557-3.197c-.047-.883-.108-2.777-1.062-3.435v.001Z"
          fill="#825350"
        />
        <path
          d="m130.979 105.972.447 1.462c.697.093.944-.893.617-1.621-.442-.987-1.064.159-1.064.159Z"
          fill="#F7B7A9"
        />
        <path
          d="m118.387 129.164-.296-.14-.747-.405-.859-.986.931.51c.777.19.77-.045.77-.045l-1.963-1.335-2.515-.464s-4.452-3.054-6.564-4.723c-.027-.756-.334-9.085-.409-9.604-.069-.472-1.076-2.591-2.753-2.217a1.127 1.127 0 0 0-.866 1.061c-.024.646-.019 1.768.137 3.491.246 2.725.79 6.801.919 7.549 0 0 .085.806.366 1.223l.103.089 1.237.769c.632.393 7.319 3.911 7.319 3.911l2.439 1.863 1.095.26.88-.326s.534-.057.624-.058c.308-.002.443-.31.152-.425v.002Z"
          fill="#926750"
        />
        <path
          opacity=".06"
          d="M104.467 115.267c.122-1.749.938-3.034 2.059-3.862-.382-.778-1.269-1.934-2.544-1.649a1.126 1.126 0 0 0-.866 1.061c-.024.645-.019 1.768.137 3.491.246 2.725.79 6.801.919 7.549 0 0 .085.806.366 1.223l.103.089 1.237.769c.632.393 7.319 3.911 7.319 3.911l2.439 1.863 1.095.26.88-.327.025-.002c-1.663-.778-3.312-1.795-5.044-2.848-4.299-2.614-8.515-5.944-8.125-11.528Z"
          fill="#010101"
        />
        <path
          d="M104.015 108.95c-.495.11-.864.971-1.027 1.452-.271.802-.308 2.284-.152 4.007.202 2.228.491 5.075.734 6.535 2.553 1.286 3.948-.607 3.998-.634-.092-2.45-.771-7.912-.833-8.338-.069-.471-1.045-3.397-2.721-3.022h.001Z"
          fill="#359996"
        />
        <path
          d="M104.397 120.383a3.237 3.237 0 0 1-.949-.266c.042.303.083.589.123.827 2.553 1.286 3.948-.607 3.997-.634-.01-.265-.028-.57-.05-.896-.852.717-2.022 1.089-3.121.969Z"
          fill="#83B7B4"
        />
        <path
          opacity=".06"
          d="M103.661 110.606a5.54 5.54 0 0 1 .24-1.609c-.437.204-.763.962-.913 1.405-.271.803-.308 2.284-.152 4.007.201 2.228.491 5.075.734 6.535 1.21.609 2.156.502 2.826.221-.279-.539-.549-1.081-.819-1.614-1.493-2.942-1.934-5.669-1.916-8.945Z"
          fill="#010101"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1="278.027"
          y1="98.699"
          x2="287.951"
          y2="92.788"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D3D3D3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="c"
          x1="284.379"
          y1="95.449"
          x2="294.303"
          y2="89.538"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D3D3D3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="d"
          x1="259.962"
          y1="154.654"
          x2="282.049"
          y2="142.083"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="e"
          x1="205.268"
          y1="157.906"
          x2="255.124"
          y2="129.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="f"
          x1="210.452"
          y1="155.976"
          x2="220.487"
          y2="149.999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D3D3D3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="g"
          x1="201.969"
          y1="159.034"
          x2="212.004"
          y2="153.057"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D3D3D3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="h"
          x1="246.822"
          y1="155.518"
          x2="252.998"
          y2="151.839"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="i"
          x1="254.348"
          y1="159.731"
          x2="260.524"
          y2="156.052"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="j"
          x1="66.897"
          y1="155.771"
          x2="72.998"
          y2="152.137"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="k"
          x1="81.876"
          y1="158.355"
          x2="90.286"
          y2="153.345"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="l"
          x1="123.72"
          y1="76.866"
          x2="127.932"
          y2="69.572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="m"
          x1="109.37"
          y1="77.221"
          x2="113.21"
          y2="70.57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="n"
          x1="101.048"
          y1="74.412"
          x2="103.943"
          y2="69.398"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="o"
          x1="95.368"
          y1="72.308"
          x2="98.331"
          y2="67.176"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="p"
          x1="82.464"
          y1="76.561"
          x2="89.124"
          y2="69.902"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="q"
          x1="65.491"
          y1="75.97"
          x2="71.855"
          y2="69.607"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="s"
          x1="101.349"
          y1="158.409"
          x2="110.611"
          y2="152.892"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="t"
          x1="115.476"
          y1="160.464"
          x2="126.43"
          y2="153.939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="u"
          x1="126.951"
          y1="159.707"
          x2="134.756"
          y2="155.058"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <linearGradient
          id="v"
          x1="133.998"
          y1="162.386"
          x2="140.707"
          y2="158.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3B3B3" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default MobileServicesIcon
